/* eslint-disable max-len */
/* eslint-disable default-case */
/* eslint-disable react/no-array-index-key */
import { IonButton, IonRow, IonCol, IonDatetime, IonContent, IonList, IonGrid, IonLabel, IonSelect, IonSelectOption } from '@ionic/react'
import React, { FC, useEffect, useState, useCallback } from 'react'
import moment from 'moment'
import Select from 'react-select'
import Datetime from 'react-datetime'
import CreatableSelect from 'react-select/creatable'
import axios from 'axios'
import { Icon } from '@iconify/react'
import { ObscureBackground, OverlayContainer } from '../GlobalContainers'
import { SimpleButton } from '../maps/StyledContainers'
import { BlueButton, TabOption, TagButton } from '../projects/StyledContainers'
import { useRiskRegister } from '../../hooks/risks/useRiskRegister'
import useApi from '../../hooks/testHooks'
import { useWorkspace } from '../../hooks/useWorkspace'
import { FlashpointStatus, IncidentCause, User } from '../types/GlobalTypes'
import { getColor } from '../maps/apps/AppMap'
import ExistingMeasures from './forms/assessment/ExistingMeasures'
import { CenterForm, ColumnContainer, MeasureContainer } from './StyledContainers'
import { SettingField } from '../settings/StyledContainers'
import { IssueTag } from '../terrain-mapping/StyledContainer'
import { Flashpoint, Stakeholder } from '../types/OptimizedMaps'
import { useAuth } from '../../hooks/useAuth'
import { BackendRiskAssessment, EditMeasures } from '../../hooks/risks/types/BackendData'
import { formatRequestRisk, processBackendRiskAssessments } from '../../hooks/risks/helpers/ProcessBackendData'
import { RiskAssessment } from './types/RiskAssessments'
import RiskSelection from './forms/assessment/RiskSelection'
import SummaryExisting from './forms/assessment/SummaryExisting'
import InherentThread from './forms/assessment/InherentThreat'
import InherentVulnerability from './forms/assessment/InherentVulnerability'
import { operations, people, property, threat, vulnerability } from './forms/FormOptions'
import { getImpactCategory, getLikelihoodCategory, getNumericalValue } from './forms/utils/Categories'
import InherentImpact from './forms/assessment/InherentImpact'
import MeasureSummary from './forms/assessment/MeasureSummary'
import IncidentDataSummary from './IncidentDataSummary'
import useAlertHistoryRefetch from '../../hooks/risks/useAlertHistoryRefetch'
import NewMeasures from './forms/assessment/NewMeasures'
import RemoveExistingMeasures from './forms/assessment/RemoveExistingMeasures'
import RemoveNewMeasures from './forms/assessment/RemoveNewMeasures'
import ResidualImpact from './forms/assessment/ResidualImpact'
import ResidualVulnerability from './forms/assessment/ResidualVulnerability'
import Summary from './forms/assessment/Summary'
import { getImpactRating, computeRiskRating, computeThreatRating } from './forms/utils/RiskAssessmentCalculations'
import { Asset, AssetList } from './types/Assets'
import Review from './forms/assessment/Review'
import { DisplayAssetAction, FocusedActionKind } from '../../hooks/risks/helpers/StateReducers'
import { set } from 'cypress/types/lodash'
import { updateRiskAssessment } from '../../hooks/risks/helpers/utils'
import { scSingleCounty, getLevelDescription, scColor, getLevelTitle } from '../maps/apps/SecurityConditions'
import { incidentCategories } from '../maps/apps/incident_types.json'
import { sanitizeIndicators } from './utils/indicatorUtils'

const AlertPopup = ({ onClose, asset, setShowAlertPopup, setSelectedAsset }) => {
  const [step, setStep] = useState(1)

  const nextStep = () => setStep(prev => Math.min(prev + 1, 7))
  const prevStep = () => setStep(prev => Math.max(prev - 1, 1))
  const [alert, setAlert] = useState(asset.alert_state || 1) // Default to Level 1 - Caution
  const [proposedAlert, setProposedAlert] = useState(null) // default to current
  const [input, setInput] = useState<any>({ existingMeasures: asset.control_measures, newMeasures: [] })
  const { user } = useAuth()
  const { workspace } = useWorkspace()
  const [categoryLevels, setCategoryLevels] = useState([])

  const [indicatorInput, setIndicatorInput] = useState({
    existingCategory: null,
    existingMeasures: [],
    edit: false,
  })
  const existingIndicators = sanitizeIndicators(indicatorInput?.existingMeasures)

  useEffect(() => {
    const incs = asset.incidents || []
    const cats = Object.keys(incidentCategories).filter((cat) =>
      incs.some((inc) => incidentCategories[cat].includes(inc.incident_type)),
    )
    const levels = cats.map((cat) => {
      const filters = Object.keys(incidentCategories).reduce((acc, curr) => {
        acc[curr] = curr === cat
        return acc
      }, {})
      const level = scSingleCounty(incs, filters, moment().format('YYYY/MM/DD HH:mm'))
      return { category: cat, level }
    })
    setCategoryLevels(levels)
  }, [])
  const [selectedDate, setSelectedDate] = useState<string>('')
  const { rawMeasures, users, setLoading, setSubmittedMessage, rawIndicators, selectedAsset } = useRiskRegister()
  const categories = rawMeasures.map(({ category }) => category).filter((val, pos, arr) => arr.indexOf(val) === pos)


  const alertDefs = [
    ['Level 1 - Caution', 'There is a low risk of possible terrorist activity or civil unrest affecting operations or personnel. Business as usual.'],
    ['Level 2 - Warning', 'A general or localised threat situation, the nature and extent of which are unpredictable, and circumstances do not justify full implementation of higher alert measures. Local travel restrictions may be necessary.'],
    ['Level 3 - Standfast', 'A foreseen event or situation that could impact on the security of operations. There is potential for the security situation in the area to deteriorate rapidly. Local lockdowns and/or severely restricted staff movements may be necessary. An evacuation may be required imminently.'],
    ['Level 4 - Standby', 'A "threat to life" incident is highly likely. Security conditions are hostile and approaching a level where operations are not possible. Critical risk to staff. Partial evacuation should be considered.'],
    ['Level 5 - Evacuation', 'There is an immediate/direct threat to personnel; or armed conflict has occurred in the area. There are extreme risks to personnel and assets. Full evacuation should be considered.']
  ]
  const alertLabel = alertDefs[alert - 1][0]
  const alertDefinition = alertDefs[alert - 1][1]

  const customStyles = {
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: '#326771', // Set background color to #326771
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: '#fff', // Set text color to white
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      color: '#fff', // Set remove icon color to white
      ':hover': {
        backgroundColor: '#ff0000', // Change this to your desired hover background color
        color: '#fff', // Set hover text color to white
      },
    }),
  }

  function getAlertColor(level) {
    if (level === 'Level 1 - Caution') {
      return '#14C105'
    } if (level === 'Level 2 - Warning') {
      return '#349DFF'
    } if (level === 'Level 3 - Standfast') {
      return '#FFE500'
    } if (level === 'Level 4 - Standby') {
      return '#FF8A00'
    }
    return '#FF0000'
  }

  const handleAddMeasures = () => {
    const measureIds = input.existingMeasures.map((measure) => measure.id)
    setLoading(true)
    axios.post('/api/v1/asset/add_control_measures', {
      domain_id: workspace.id,
      asset_id: asset.id,
      measures: measureIds,
    }).then((response) => {
      // Assuming the response contains the newly created note's ID
      // const { id } = response.data // Extract the ID from the response
      // Create a new note object with the ID and other details
      // Update the selectedAsset.notes with the new note
      setSubmittedMessage('Control Measures Created Successfully')
      setLoading(false)
      setSelectedAsset({ ...selectedAsset, control_measures: input.existingMeasures })
    }).catch((error) => {
      console.error('Error adding Measure:', error)
      setLoading(false)
    })
  }

  const handleUpdateAlert = () => {
    handleAddMeasures()
    setLoading(true)
    const indicatorIds = existingIndicators.map((indicator) => indicator.id)
    axios.post('/api/v1/asset/create_alert_state_history', {
      id: asset.id,
      proposed_level: proposedAlert,
      approved_level: 0,
      comments: input?.comments || '',
      review_date: selectedDate,
      approved_by: selectedApprover?.id || null,
      indicators: indicatorIds,
    })
    .then(response => {
      const newAlertHistory = {
        id: Math.floor(Math.random() * 100000), // Temporary ID or use something meaningful
        proposed_level: proposedAlert,
        approved_level: 0,
        comments: input?.comments || '',
        review_date: selectedDate,
        user_id: user?.user_id || null,  // Replace with actual user ID
        approved_by: selectedApprover?.id || null,
        status: 'Pending',
        submitted_at: new Date().toISOString(),
        approved_at: null,
      }

      setSelectedAsset(prevState => ({
        ...prevState,
        alert_state_histories: [...(prevState.alert_state_histories || []), newAlertHistory]
      }))

      setLoading(false)
      setSubmittedMessage('Alert state history created successfully')
      setShowAlertPopup(false)
    })
    .catch(error => {
      console.error('Error creating alert state history:', error)
      setLoading(false)
    })
  }

  const handleDropRemove = (e) => {
    /* Get measure name */
    const measure = JSON.parse(e.dataTransfer.getData('measure'))

    const index = input?.existingMeasures.findIndex((val) => val.id === measure.id)
    if (index < 0) return

    const copy = input?.existingMeasures.slice()
    copy.splice(index, 1)

    if (Object.keys(input?.removeNew).find((val) => val === measure.id)) {
      setInput({ ...input, removeNew: { ...input?.removeNew, [measure.id]: false }, existingMeasures: copy })
      return
    }

    if (Object.keys(input?.removeExisting).find((val) => val === measure.id)) {
      setInput({ ...input, removeExisting: { ...input.removeExisting, [measure.id]: false }, existingMeasures: copy })
      return
    }
    setInput({ ...input, existingMeasures: copy })
  }

  const handleDropAdd = (e) => {
    const measure = JSON.parse(e.dataTransfer.getData('measure'));

    if (!input) return;

    if (input.existingMeasures?.find((val) => val.id === measure.id)) return;

    const copy = input.existingMeasures?.slice() ?? [];
    copy.push(measure);

    // Ensure removeNew and removeExisting are objects before using Object.keys
    const removeNew = input.removeNew ?? {};
    const removeExisting = input.removeExisting ?? {};

    if (Object.keys(removeNew).includes(measure.id)) {
      setInput({ ...input, removeNew: { ...removeNew, [measure.id]: true }, existingMeasures: copy });
      return;
    }

    if (Object.keys(removeExisting).includes(measure.id)) {
      setInput({ ...input, removeExisting: { ...removeExisting, [measure.id]: true }, existingMeasures: copy });
      return;
    }

    setInput({ ...input, existingMeasures: copy });
  }

  const [selectedApprover, setSelectedApprover] = useState(null)

  const options = users.map(user => ({
    value: user.id,
    label: `${user.first_name} ${user.final_name}`,
    user, // Attach full user data for display
  }))

  const handleSelect = (selected) => {
    setSelectedApprover(selected.user)
  }

    const getAlertStyle = (value) => {
    switch (value) {
      case 1:
        return { backgroundColor: '#14C105', color: 'white' }
      case 2:
        return { backgroundColor: '#349DFF', color: 'white' }
      case 3:
        return { backgroundColor: '#FFE500', color: 'black' }
      case 4:
        return { backgroundColor: '#FF8A00', color: 'white' }
      case 5:
        return { backgroundColor: '#FF8A00', color: 'white' }
      default:
        return { backgroundColor: 'white', color: 'black' }
    }
  }

  const ind_categories = rawIndicators.map(({ category }) => category).filter((val, pos, arr) => arr.indexOf(val) === pos)
  
  const handleIndicatorDropRemove = (e) => {
    const indicator = JSON.parse(e.dataTransfer.getData('measure')) // Assuming 'measure' is reused

    const index = existingIndicators.findIndex((val) => val.id === indicator.id)
    if (index < 0) return

    const copy = existingIndicators.slice()
    copy.splice(index, 1)

    if (Object.keys(indicatorInput?.removeNew).find((val) => val === indicator.id)) {
      setIndicatorInput({
        ...indicatorInput,
        removeNew: { ...indicatorInput?.removeNew, [indicator.id]: false },
        existingMeasures: copy
      })
      return
    }

    if (Object.keys(indicatorInput?.removeExisting).find((val) => val === indicator.id)) {
      setIndicatorInput({
        ...indicatorInput,
        removeExisting: { ...indicatorInput.removeExisting, [indicator.id]: false },
        existingMeasures: copy
      })
      return
    }
    setIndicatorInput({ ...indicatorInput, existingMeasures: copy })
  }

  const handleIndicatorDropAdd = (e) => {
    const indicator = JSON.parse(e.dataTransfer.getData('measure'))

    if (!indicatorInput) return

    if (existingIndicators.find((val) => val.id === indicator.id)) return

    const copy = existingIndicators.slice()
    copy.push(indicator)

    const removeNew = indicatorInput.removeNew ?? {}
    const removeExisting = indicatorInput.removeExisting ?? {}

    if (Object.keys(removeNew).includes(indicator.id)) {
      setIndicatorInput({
        ...indicatorInput,
        removeNew: { ...removeNew, [indicator.id]: true },
        existingMeasures: copy
      });
      return
    }

    if (Object.keys(removeExisting).includes(indicator.id)) {
      setIndicatorInput({
        ...indicatorInput,
        removeExisting: { ...removeExisting, [indicator.id]: true },
        existingMeasures: copy
      })
      return
    }

    setIndicatorInput({ ...indicatorInput, existingMeasures: copy })
  }

  const alertOptions = [
    {
      label: 'Level 1 - Caution',
      value: 1,
      definition: 'There is a low risk of possible terrorist activity or civil unrest affecting operations or personnel. Business as usual.',
    },
    {
      label: 'Level 2 - Warning',
      value: 2,
      definition: 'A general or localised threat situation, the nature and extent of which are unpredictable, and circumstances do not justify full implementation of higher alert measures. Local travel restrictions may be necessary.',
    },
    {
      label: 'Level 3 - Standfast',
      value: 3,
      definition: 'A foreseen event or situation that could impact on the security of operations. There is potential for the security situation in the area to deteriorate rapidly. Local lockdowns and / or severely restricted staff movements may be necessary. An evacuation may be required imminently.',
    },
    {
      label: 'Level 4 - Standby',
      value: 4,
      definition: 'A ‘threat to life’ incident is highly likely. Security conditions are hostile and approaching a level where operations are not possible. Critical risk to staff. Partial evacuation should be considered.',
    },
    {
      label: 'Level 5 - Evacuation',
      value: 5,
      definition: 'There is an immediate / direct threat to personnel; or armed conflict has occurred in the area. There are extreme risks to personnel and assets. Full evacuation should be considered.',
    },
  ]

  const getAlertLabel = (value) => {
    const alertOption = alertOptions.find((option) => option.value === value)
    return alertOption ? alertOption.label : 'Unknown'
  }

  switch (step) {
    case 1:
      return (
        <>
          <OverlayContainer
            style={{
              zIndex: 25,
              width: '90%',
              height: '90%',
              borderRadius: '1em',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              padding: '1.5em',
              overflow: 'hidden',
            }}
            className='terrain-add-popup'
          >
            {/* Top Content */}
            <div style={{ overflowY: 'auto' }}>
              {/* Header Row */}
              <IonRow className='ion-justify-content-end'>
                <SimpleButton onClick={onClose}>Close ✕</SimpleButton>
              </IonRow>

              {/* Title */}
              <h5 className='blue' style={{ margin: 0, fontSize: 16, color: '#326771', fontWeight: 'bold', marginLeft: '0.1em' }}>Juba Area of Operations</h5>


              {/* Details Row */}
              <IonGrid>
                <IonRow style={{ fontWeight: 600 }}>
                  <IonCol><h5 style={{ color: '#4197A9', fontSize: 16, margin: 0 }}>Asset Type</h5></IonCol>
                  <IonCol><h5 style={{ color: '#4197A9', fontSize: 16, margin: 0 }}>Owner</h5></IonCol>
                  <IonCol><h5 style={{ color: '#4197A9', fontSize: 16, margin: 0 }}>Approver</h5></IonCol>
                  <IonCol><h5 style={{ color: '#4197A9', fontSize: 16, margin: 0 }}>Date</h5></IonCol>
                </IonRow>
                <IonRow>
                  <IonCol><p style={{ fontSize: 13, margin: 0 }}>{asset.asset_type}</p></IonCol>
                  <IonCol><p style={{ fontSize: 13, margin: 0 }}>N/A</p></IonCol>
                  <IonCol><p style={{ fontSize: 13, margin: 0 }}>N/A</p></IonCol>
                  <IonCol><p style={{ fontSize: 13, margin: 0 }}>N/A</p></IonCol>
                </IonRow>
              </IonGrid>


              {/* Current Alert State */}
              <h5 style={{ color: '#4197A9', fontSize: 14 }}>Current Alert State</h5>
              <p style={{ fontSize: 13 }}>
                <span style={{ ...getAlertStyle(selectedAsset.alert_state), padding: '4px 8px', borderRadius: '6px' }}>
                  {getAlertLabel(selectedAsset?.alert_state)}
                </span>
              </p>
              <p style={{ fontSize: 13 }}>
                {alertDefinition}
              </p>

              {/* Security Condition Summary */}
              <h5 style={{ color: '#4197A9', fontSize: 14 }}>Security Condition Summary</h5>
              <p style={{ fontSize: 13, color: '#555' }}>
                Security Incidents on record with the operations asset area or a 5km radius of other asset types.
              </p>

              {categoryLevels.length === 0 ? (
                <p style={{ fontSize: 13, color: '#737475', marginTop: '1em' }}>
                  No Incidents have been reported for this asset.
                </p>
              ) : (
                <IonGrid style={{ paddingTop: '7px', paddingLeft: '10px', paddingRight: '10px' }}>
                  {categoryLevels.map(({ category, level }) => (
                    <IonRow key={category} style={{ outline: 'solid 2px' }}>
                      <IonCol size='3' style={{ outline: 'solid 2px', backgroundColor: scColor(level) }}>
                        <IonLabel style={{ fontSize: '12px', color: level === 3 ? '#000000' : '#FFFFFF' }}>{category}</IonLabel>
                      </IonCol>
                      <IonCol size='9' style={{ outline: 'solid 2px' }}>
                        <IonLabel style={{ fontSize: '12px' }}>{getLevelDescription(level)}</IonLabel>
                      </IonCol>
                    </IonRow>
                  ))}
                </IonGrid>
              )}

            </div>

            {/* Footer Buttons */}
            <IonRow className='ion-justify-content-between' style={{ marginTop: '1.5em' }}>
              <IonButton onClick={nextStep}>Next</IonButton>
            </IonRow>
          </OverlayContainer>
        </>
      )
    case 2:
      return (
        <>
          <OverlayContainer style={{ zIndex: 25, width: '90%', height: '90%', borderRadius: '1em', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }} className='terrain-add-popup'>
            <div style={{ overflowY: 'auto' }}>
              {/* Header Row */}
              <IonRow className='ion-justify-content-end'>
                <SimpleButton onClick={onClose}>Close ✕</SimpleButton>
              </IonRow>

              {/* Title */}
              <h5 className='blue' style={{ margin: 0, fontSize: 16, color: '#326771', fontWeight: 'bold', marginLeft: '0.1em' }}>Security Event Summary</h5>
              <IncidentDataSummary
                monthly_events={asset?.monthly_events}
                breakdown_30={asset?.breakdown_30}
              />


            </div>

            <IonRow className='ion-justify-content-between' style={{ marginTop: '2em', marginBottom: '1.5em' }}>
              <IonButton onClick={prevStep}>Back</IonButton>
              <IonButton onClick={nextStep}>Next</IonButton>
            </IonRow>
          </OverlayContainer>
        </>
      )
    case 3:
      return (
        <>
          <OverlayContainer style={{ zIndex: 35, width: '90%', height: '89%', borderRadius: '1em' }}>
            <IonRow className='ion-align-items-center ion-justify-content-between' style={{ marginBottom: '0.5em' }}>
              <IonCol size='auto'>
                <h5 className='blue' style={{ margin: 0, fontSize: 16, color: '#326771', fontWeight: 'bold', marginLeft: '0.1em' }}>Add Alert State Indicators</h5>
              </IonCol>
              <IonCol size='auto'>
                <SimpleButton onClick={() => onClose()}>Close X</SimpleButton>
              </IonCol>
            </IonRow>
            <div style={{ marginTop: '0' }}>
              <SettingField style={{ marginTop: '0' }}>
                <p style={{ fontSize: 13 }}>
                  Select indicators that reflect current on the ground conditions.
                  Indicators help explain why a change in alert state may be needed.
                  choose those observed or reported within the area, including signs of instability.
                  These will guide the reviewers decision and are recorded for accountability.
                </p>
              </SettingField>
              <div style={{ width: '200px' }}>
                <Select
                  placeholder='Select Category'
                  name='existingCategory'
                  id='existing-control-measure-categories'
                  className='select-container'
                  value={indicatorInput?.existingCategory}
                  // eslint-disable-next-line no-undef
                  menuPortalTarget={document.body}
                  options={ind_categories.map((level) => ({ value: level, label: level }))}
                  onChange={(selected) => setIndicatorInput({ ...indicatorInput, existingCategory: selected, edit: true })}
                />
              </div>
              <IonRow className='ion-align-items-center'>
                <IonCol size={5}>
                  <ColumnContainer style={{ height: '240px' }} onDragOver={(e) => e.preventDefault()} onDrop={handleIndicatorDropRemove}>
                    {indicatorInput?.existingCategory
                      && rawIndicators.filter(({ category }) => category === indicatorInput?.existingCategory.value)
                        .filter((val) => !existingIndicators.find((measure) => measure.id === val.id)).map((measure, index) => (
                          <MeasureContainer
                            className='single-control-measure'
                            key={index}
                            draggable
                            style={{ backgroundColor: getColor(index) }}
                            onDragStart={(e) => e.dataTransfer.setData('measure', JSON.stringify(measure))}
                          >
                            <p> {measure.indicator} </p>
                          </MeasureContainer>
                        ))}
                    {!indicatorInput?.existingCategory && (
                      <IonRow style={{ height: '100%' }} className='ion-align-items-center'>
                        <SettingField style={{ textAlign: 'center', width: 'auto' }}>
                          <h4 style={{ fontWeight: 'normal', margin: '20px 0', color: '#326771' }}>Choose a category to select indicator</h4>
                          <p style ={{ fontSize: 13 }}>To start adding indicators, choose a category from the drop-down menu above. </p>
                        </SettingField>
                      </IonRow>
                    )}
                  </ColumnContainer>
                </IonCol>
                <IonCol style={{ textAlign: 'center', fontSize: '2.6rem' }} size={2}>
                  <Icon icon='ic:round-swipe-right' />
                </IonCol>
                <IonCol size={5}>
                  <ColumnContainer style={{ height: '240px' }} id='cm-existing-drop' onDragOver={(e) => e.preventDefault()} onDrop={handleIndicatorDropAdd}>
                    {indicatorInput?.existingCategory && existingIndicators.filter((selected) => selected.category === indicatorInput?.existingCategory.value).map((measure, index) => (
                      <MeasureContainer
                        className='selected-control-measure'
                        key={index}
                        draggable
                        style={{ backgroundColor: getColor(index) }}
                        onDragStart={(e) => e.dataTransfer.setData('measure', JSON.stringify(measure))}
                      >
                        <p> {measure.indicator} </p>
                      </MeasureContainer>
                    ))}
                    {(!indicatorInput?.existingCategory || existingIndicators.filter((selected) => selected.category === indicatorInput?.existingCategory.value).length === 0) && (
                      <IonRow style={{ height: '100%' }} className='ion-align-items-center'>
                        <SettingField style={{ textAlign: 'center', width: 'auto' }}>
                          <h4 style={{ fontWeight: 'normal', margin: '20px 0', color: '#326771' }}>Drag and drop items from the left to add them to the Alert State profile</h4>
                          <p style={{ fontSize: 13 }}>Indicators that you add here will appear in the Alert State review.</p>
                        </SettingField>
                      </IonRow>
                    )}
                  </ColumnContainer>
                </IonCol>
              </IonRow>
            </div>
            <IonRow className='ion-justify-content-between'>
              <IonButton onClick={prevStep}>Back</IonButton>
              <IonButton onClick={nextStep}>Next</IonButton>
            </IonRow>
          </OverlayContainer>
        </>
      )
    case 4:
      return (
        <>
          <OverlayContainer style={{ zIndex: 25, width: '90%', height: '90%', borderRadius: '1em' }} className='terrain-add-popup'>
            <IonRow className='ion-justify-content-end'>
              <SimpleButton onClick={() => onClose()}>Close X</SimpleButton>
            </IonRow>
            <h5 style={{ color: '#326771', fontSize: 16, marginBottom: '4px' }}>Add Alert State Selection</h5>
            <div style={{ height: '79%', overflow: 'auto' }}>
              <h5 style={{ color: '#4197A9', fontSize: 13, marginBottom: '4px', marginTop: '1em' }}>Current Alert State</h5>
              <p style={{ fontSize: 13 }}>
                <span style={{ ...getAlertStyle(selectedAsset.alert_state), padding: '4px 8px', borderRadius: '6px' }}>
                  {getAlertLabel(selectedAsset?.alert_state)}
                </span>
              </p>
              <p style={{ fontSize: 13 }}>
                {alertDefinition}
              </p>

              <h5 style={{ color: '#4197A9', fontSize: 13, margin: '12px 0 4px', marginTop: '2em' }}>Advised Alert State</h5>

              <div
                style={{
                  backgroundColor: proposedAlert
                    ? getAlertColor(alertDefs[proposedAlert - 1][0])
                    : '#cccccc',
                  padding: '4px',
                  borderRadius: '6px',
                  width: 'fit-content',
                  marginBottom: '1em',
                }}
              >
                <Select
                  placeholder='Select Alert State'
                  name='proposedAlert'
                  id='select-alert-container'
                  className='select-container'
                  menuPortalTarget={document.body}
                  options={alertDefs.map((def, index) => ({
                    value: index + 1,
                    label: def[0],
                  }))}
                  onChange={(selected) => setProposedAlert(selected?.value || null)}
                  value={
                    proposedAlert
                      ? {
                          value: proposedAlert,
                          label: alertDefs[proposedAlert - 1][0],
                        }
                      : null
                  }
                  styles={{
                    control: (base) => ({
                      ...base,
                      backgroundColor: 'transparent',
                      border: 'none',
                      boxShadow: 'none',
                      fontSize: '13px',
                      color:
                        proposedAlert &&
                        alertDefs[proposedAlert - 1][0] === 'Level 3 - Standfast'
                          ? '#000000'
                          : '#FFFFFF',
                      minWidth: '250px', // Optional: ensure minimum control width
                    }),
                    singleValue: (base) => ({
                      ...base,
                      fontSize: '13px',
                      color:
                        proposedAlert &&
                        alertDefs[proposedAlert - 1][0] === 'Level 3 - Standfast'
                          ? '#000000'
                          : '#FFFFFF',
                    }),
                    placeholder: (base) => ({
                      ...base,
                      fontSize: '13px',
                      color: '#FFFFFF',
                    }),
                    dropdownIndicator: (base) => ({
                      ...base,
                      color:
                        proposedAlert &&
                        alertDefs[proposedAlert - 1][0] === 'Level 3 - Standfast'
                          ? '#000000'
                          : '#FFFFFF',
                    }),
                    indicatorSeparator: () => ({ display: 'none' }),
                    menu: (base) => ({
                      ...base,
                      zIndex: 9999,
                      fontSize: '13px',
                      minWidth: 'max-content', // 👈 Ensures the menu is as wide as needed
                      width: 'auto',            // 👈 Allows menu to expand beyond control width
                    }),
                    option: (base, state) => ({
                      ...base,
                      fontSize: '13px',
                      backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                      color: 'black',
                      whiteSpace: 'nowrap',
                    }),
                  }}

                />
              </div>
              <div style={{
                border: '1px solid #ccc',
                borderRadius: '10px',
                padding: '16px',
                backgroundColor: '#f9f9f9',
                width: '100%',
                maxWidth: '600px',
                marginBottom: '20px',
              }}
              >
                <p style={{ fontSize: 13 }}>
                  {proposedAlert ? alertDefs[proposedAlert - 1][1] : ''}
                </p>
              </div>
            </div>
            <IonRow className='ion-justify-content-between'>
              <IonButton onClick={prevStep}>Back</IonButton>
              <IonButton onClick={nextStep}>Next</IonButton>
            </IonRow>
          </OverlayContainer>
        </>
      )
    case 5:
      return (
        <>
          <OverlayContainer style={{ zIndex: 35, width: '90%', height: '89%', borderRadius: '1em' }}>
            <IonRow className='ion-align-items-center ion-justify-content-between' style={{ marginBottom: '0.5em' }}>
              <IonCol size='auto'>
                <h5 className='blue' style={{ margin: 0, fontSize: 16, color: '#326771', fontWeight: 'bold', marginLeft: '0.1em' }}>Assign Control Measures</h5>
              </IonCol>
              <IonCol size='auto'>
                <SimpleButton onClick={() => onClose()}>Close X</SimpleButton>
              </IonCol>
            </IonRow>
            <div style={{ marginTop: '0' }}>
              <SettingField style={{ marginTop: '0' }}>
                <p style={{ fontSize: 13 }}>
                  Review the current control measures in place for this asset. 
                  Based on the present situation, decide which measures to keep, remove, or add. 
                  Your recommendation should reflect what is realistically needed now to manage risk—neither excessive nor insufficient. 
                  Changes will help guide operational response.
                </p>
              </SettingField>
              <div style={{ width: '200px' }}>
                <Select
                  placeholder='Select Category'
                  name='existingCategory'
                  id='existing-control-measure-categories'
                  className='select-container'
                  value={input?.existingCategory}
                  // eslint-disable-next-line no-undef
                  menuPortalTarget={document.body}
                  options={categories.map((level) => ({ value: level, label: level }))}
                  onChange={(selected) => setInput({ ...input, existingCategory: selected, edit: true })}
                />
              </div>
              <IonRow className='ion-align-items-center'>
                <IonCol size={5}>
                  <ColumnContainer style={{ height: '220px' }} onDragOver={(e) => e.preventDefault()} onDrop={handleDropRemove}>
                    {input?.existingCategory
                      && rawMeasures.filter(({ category }) => category === input?.existingCategory.value)
                        .filter((val) => !input?.existingMeasures.find((measure) => measure.id === val.id)).map((measure, index) => (
                          <MeasureContainer
                            className='single-control-measure'
                            key={index}
                            draggable
                            style={{ backgroundColor: getColor(index) }}
                            onDragStart={(e) => e.dataTransfer.setData('measure', JSON.stringify(measure))}
                          >
                            <p> {measure.control_measure} </p>
                          </MeasureContainer>
                        ))}
                    {!input?.existingCategory && (
                      <IonRow style={{ height: '100%' }} className='ion-align-items-center'>
                        <SettingField style={{ textAlign: 'center', width: 'auto' }}>
                          <h4 style={{ fontWeight: 'normal', margin: '20px 0', color:"#326771" }}>Choose a category to select measures</h4>
                          <p style ={{ fontSize: 13 }}>To start adding control measures, choose a category from the drop-down menu above. </p>
                        </SettingField>
                      </IonRow>
                    )}
                  </ColumnContainer>
                </IonCol>
                <IonCol style={{ textAlign: 'center', fontSize: '2.6rem' }} size={2}>
                  <Icon color='#326771' icon='ic:round-swipe-right' />
                </IonCol>
                <IonCol size={5}>
                  <ColumnContainer style={{ height: '220px' }} id='cm-existing-drop' onDragOver={(e) => e.preventDefault()} onDrop={handleDropAdd}>
                    {input?.existingCategory && input?.existingMeasures.filter((selected) => selected.category === input?.existingCategory.value).map((measure, index) => (
                      <MeasureContainer
                        className='selected-control-measure'
                        key={index}
                        draggable
                        style={{ backgroundColor: getColor(index) }}
                        onDragStart={(e) => e.dataTransfer.setData('measure', JSON.stringify(measure))}
                      >
                        <p> {measure.control_measure} </p>
                      </MeasureContainer>
                    ))}
                    {(!input?.existingCategory || input?.existingMeasures.filter((selected) => selected.category === input?.existingCategory.value).length === 0) && (
                      <IonRow style={{ height: '100%' }} className='ion-align-items-center'>
                        <SettingField style={{ textAlign: 'center', width: 'auto' }}>
                          <h4 style={{ fontWeight: 'normal', margin: '20px 0', color: "#326771" }}>Drag and drop items from the left to add them to your Key Asset’s profile</h4>
                          <p style={{ fontSize: 13 }}>Control measures that you add here will be added to the Key Assets profile following the completion of the review process.</p>
                        </SettingField>
                      </IonRow>
                    )}
                  </ColumnContainer>
                </IonCol>
              </IonRow>
            </div>
            <IonRow className='ion-justify-content-between'>
              <IonButton onClick={prevStep}>Back</IonButton>
              <IonButton onClick={nextStep}>Next</IonButton>
            </IonRow>
          </OverlayContainer>
        </>
      )
    case 6:
      return (
        <>
          <OverlayContainer style={{ zIndex: 25, width: '90%', height: '90%', borderRadius: '1em' }} className='terrain-add-popup'>
            <IonRow className='ion-align-items-center ion-justify-content-between' style={{ marginBottom: '0.5em' }}>
              <IonCol size='auto'>
                <h5 style={{ color: '#326771', fontSize: 16, margin: '12px 0 4px', marginTop: '0' }}>Comment and Authorisation</h5>
              </IonCol>
              <IonCol size='auto'>
                <SimpleButton onClick={() => onClose()}>Close X</SimpleButton>
              </IonCol>
            </IonRow>
            <p style={{ fontSize: 12, marginBottom: '10px' }}>
              Please enter any additional comments or notes regarding the alert state change in the textbox down below.
            </p>
            <textarea
              style={{
                width: '100%',
                height: '30%',
                borderRadius: '1em',
                border: '1px solid #ccc',
                padding: '1em',
                fontSize: '14px',
                resize: 'none',
                boxSizing: 'border-box',
                marginBottom: '1em',
              }}
              placeholder='Briefly explain your judgement or relevant context behind the recommended Alert State.'
              value={input?.comments || ''}
              onChange={(e) => setInput({ ...input, comments: e.target.value })}
            />
            
            <h5 style={{ color: '#326771', fontSize: 16, margin: '12px 0 4px', marginTop: '0' }}>Suggested Review Date</h5>
            <div style={{ width: '100%', maxWidth: '400px', marginBottom: '20px' }}>
              <Datetime
                dateFormat='DD/MM/YY'
                timeFormat={false}
                inputProps={{
                  placeholder: 'Start Date',
                  readOnly: true,
                  style: { backgroundColor: 'white', width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #ccc' },
                }}
                isValidDate={(current) => current.isAfter(moment())}
                name='date'
                value={selectedDate}
                onChange={(e) => setSelectedDate(e)}
              />
            </div>

            <h5 style={{ color: '#326771', fontSize: 16, margin: '12px 0 4px', marginTop: '0' }}>Select Approver</h5>
            <div style={{ width: '300px', marginBottom: '20px' }}>
              <Select
                placeholder='Select Approver'
                options={options}
                onChange={handleSelect}
                menuPortalTarget={document.body}
              />
            </div>

            <IonRow className='ion-justify-content-between'>
              <IonButton onClick={prevStep}>Back</IonButton>
              <IonButton onClick={handleUpdateAlert} disabled={!selectedDate}>Submit</IonButton>
            </IonRow>
          </OverlayContainer>
        </>
      )
    default:
      return null
  }
}

const ViewAlertPopup = ({ onClose, asset, setViewAlertPopup, selectedAlert }) => {
  const [step, setStep] = useState(1)

  const nextStep = () => setStep(prev => Math.min(prev + 1, 7))
  const prevStep = () => setStep(prev => Math.max(prev - 1, 1))
  const [alert, setAlert] = useState(asset.alert_state || 1) // Default to Level 1 - Caution

  const { users } = useRiskRegister()


  const alertDefs = [
    ['Level 1 - Caution', 'There is a low risk of possible terrorist activity or civil unrest affecting operations or personnel. Business as usual.'],
    ['Level 2 - Warning', 'A general or localised threat situation, the nature and extent of which are unpredictable, and circumstances do not justify full implementation of higher alert measures. Local travel restrictions may be necessary.'],
    ['Level 3 - Standfast', 'A foreseen event or situation that could impact on the security of operations. There is potential for the security situation in the area to deteriorate rapidly. Local lockdowns and/or severely restricted staff movements may be necessary. An evacuation may be required imminently.'],
    ['Level 4 - Standby', 'A "threat to life" incident is highly likely. Security conditions are hostile and approaching a level where operations are not possible. Critical risk to staff. Partial evacuation should be considered.'],
    ['Level 5 - Evacuation', 'There is an immediate/direct threat to personnel; or armed conflict has occurred in the area. There are extreme risks to personnel and assets. Full evacuation should be considered.']
  ]
  const alertLabel = alertDefs[alert - 1][0]
  const alertDefinition = alertDefs[alert - 1][1]  
  
  const proposedAlertLabel = alertDefs[selectedAlert.proposed_level - 1][0]
  const proposedAlertDefinition = alertDefs[selectedAlert.proposed_level - 1][1]

  function getAlertColor(level) {
    if (level === 'Level 1 - Caution') {
      return '#14C105'
    } if (level === 'Level 2 - Warning') {
      return '#349DFF'
    } if (level === 'Level 3 - Standfast') {
      return '#FFE500'
    } if (level === 'Level 4 - Standby') {
      return '#FF8A00'
    }
    return '#FF0000'
  }

  const getNoteUser = (user_id) => {
    const user = users.find((e) => e.id === user_id)
    if (user) {
      return { value: user.id, label: `${user.first_name} ${user.final_name}`, email: user.email, phone_number: user.phone_number }
    }
    return { value: null, label: 'N/A' }
  }

  const [groupedMeasures, setGroupedMeasures] = useState(asset.control_measures.reduce((acc, measure) => {
    acc[measure.category] = acc[measure.category] || []
    acc[measure.category].push(measure)
    return acc
  }, {}))

  const [groupedIndicators, setGroupedIndicators] = useState(selectedAlert.alert_indicators.reduce((acc, indicator) => {
    acc[indicator.category] = acc[indicator.category] || []
    acc[indicator.category].push(indicator)
    return acc
  }, {}))

  const apiHook = useApi()

  const handleDownload = () => {
    apiHook.downloadAlertHistory({ alert_history_id: selectedAlert.id })
      .then((data) => {
        const filename = `${asset.name}-alert.pdf`
        apiHook.downloader2(data, filename)
      })
  }

  const selectedCategories = Object.keys(groupedMeasures)
  const selectedIndicatorCategories = Object.keys(groupedIndicators)

  const rows = []
  for (let i = 0; i < selectedCategories.length; i += 3) {
    rows.push(selectedCategories.slice(i, i + 3))
  }

  const indicatorRows = []
  for (let i = 0; i < selectedIndicatorCategories.length; i += 3) {
    indicatorRows.push(selectedIndicatorCategories.slice(i, i + 3))
  }

  switch (step) {
    case 1:
      return (
        <>
          <OverlayContainer style={{ zIndex: 25, width: '90%', height: '90%', borderRadius: '1em' }} className='terrain-add-popup'>
            <IonRow className='ion-justify-content-end'>
              <SimpleButton onClick={() => onClose()}>Close X</SimpleButton>
            </IonRow>
            <h5 style={{ color: '#326771', fontSize: 16, marginBottom: '4px' }}>{asset.name}</h5>
            <div style={{ height: '79%', overflow: 'auto' }}>
              <h5 style={{ color: '#4197A9', fontSize: 13, marginBottom: '4px', marginTop: '1em' }}>Current Alert State</h5>
              <IonGrid style={{ paddingTop: '7px', paddingLeft: '10px', paddingRight: '10px' }}>
                <IonRow style={{ outline: 'solid 2px' }}>
                  <IonCol size='3' style={{ backgroundColor: getAlertColor(alertLabel) }}>
                    <IonLabel style={{ fontSize: '12px', color: (alertLabel === 'Level 3 - Standfast') ? '#000000' : '#FFFFFF' }}>{alertLabel}</IonLabel>
                  </IonCol>
                  <IonCol size='9' style={{ outline: 'solid 2px' }}>
                    <IonLabel style={{ fontSize: '12px' }}>{alertDefinition}</IonLabel>
                  </IonCol>
                </IonRow>
              </IonGrid>
              <h5 style={{ color: '#4197A9', fontSize: 13, margin: '12px 0 4px', marginTop: '2em' }}>Proposed Alert State</h5>
              <IonGrid style={{ paddingTop: '7px', paddingLeft: '10px', paddingRight: '10px' }}>
                <IonRow style={{ outline: 'solid 2px' }}>
                  <IonCol size='3' style={{ backgroundColor: getAlertColor(proposedAlertLabel) }}>
                    <IonLabel style={{ fontSize: '12px', color: (proposedAlertLabel === 'Level 3 - Standfast') ? '#000000' : '#FFFFFF' }}>{proposedAlertLabel}</IonLabel>
                  </IonCol>
                  <IonCol size='9' style={{ outline: 'solid 2px' }}>
                    <IonLabel style={{ fontSize: '12px' }}>{proposedAlertDefinition}</IonLabel>
                  </IonCol>
                </IonRow>
              </IonGrid>
              <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap', marginTop: '7px' }}>
                {/* First Box */}
                <div style={{
                  border: '1px solid #ccc',
                  borderRadius: '10px',
                  padding: '16px',
                  backgroundColor: '#f9f9f9',
                  width: '100%',
                  maxWidth: '400px',
                  flex: '1',
                }}>
                  <h6 style={{ marginBottom: '8px', color: '#326771', fontSize: 16 }}>Approver Details</h6>
                  <p style={{ fontSize: '13px' }}>
                    <span style={{ color: '#4197A9' }}>Name:</span>{' '}
                    {getNoteUser(selectedAlert.approved_by).label}
                  </p>
                  <p style={{ fontSize: '13px' }}>
                    <span style={{ color: '#4197A9' }}>Email:</span>{' '}
                    {getNoteUser(selectedAlert.approved_by).email}
                  </p>
                  <p style={{ fontSize: '13px' }}>
                    <span style={{ color: '#4197A9' }}>Number:</span>{' '}
                    {getNoteUser(selectedAlert.approved_by).phone_number}
                  </p>
                </div>

                {/* Second Box */}
                <div style={{
                  border: '1px solid #ccc',
                  borderRadius: '10px',
                  padding: '16px',
                  backgroundColor: '#f9f9f9',
                  width: '100%',
                  maxWidth: '400px',
                  flex: '1',
                }}>
                  <h6 style={{ marginBottom: '8px', color: '#326771', fontSize: 16 }}>Submitter Details</h6>
                  <p style={{ fontSize: '13px' }}>
                    <span style={{ color: '#4197A9' }}>Name:</span>{' '}
                    {getNoteUser(selectedAlert.user_id).label}
                  </p>
                  <p style={{ fontSize: '13px' }}>
                    <span style={{ color: '#4197A9' }}>Email:</span>{' '}
                    {getNoteUser(selectedAlert.user_id).email}
                  </p>
                  <p style={{ fontSize: '13px' }}>
                    <span style={{ color: '#4197A9' }}>Number:</span>{' '}
                    {getNoteUser(selectedAlert.user_id).phone_number}
                  </p>
                </div>
              </div>

            </div>
            <IonRow className='ion-justify-content-between'>
              <IonButton onClick={handleDownload}>Download PDF</IonButton>
              <IonButton onClick={nextStep}>Next</IonButton>
            </IonRow>
          </OverlayContainer>
        </>
      )
    case 2:
      return (
        <>
          <OverlayContainer style={{ zIndex: 25, width: '90%', height: '90%', borderRadius: '1em', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }} className='terrain-add-popup'>
            <div style={{ overflowY: 'auto', height: '79%' }}>
              {/* Header Row */}
              <IonRow className='ion-justify-content-end'>
                <SimpleButton onClick={onClose}>Close ✕</SimpleButton>
              </IonRow>

              {/* Title */}
              <h5 className='blue' style={{ margin: 0, fontSize: 16, color: '#326771', fontWeight: 'bold', marginLeft: '0.1em' }}>Security Event Summary</h5>
              <IncidentDataSummary
                monthly_events={asset?.monthly_events}
                breakdown_30={asset?.breakdown_30}
              />


            </div>

            <IonRow className='ion-justify-content-between' style={{ marginTop: '2em' }}>
              <IonButton onClick={prevStep}>Back</IonButton>
              <IonButton onClick={nextStep}>Next</IonButton>
            </IonRow>
          </OverlayContainer>
        </>
      )
    case 3:
      return (
        <>
          <OverlayContainer style={{ zIndex: 35, width: '90%', height: '89%', borderRadius: '1em' }}>
            <IonRow className='ion-align-items-center ion-justify-content-between' style={{ marginBottom: '0.5em' }}>
              <IonCol size='auto'>
                <h5 className='blue' style={{ margin: 0, fontSize: 16, color: '#326771', fontWeight: 'bold', marginLeft: '0.1em' }}>Selected Indicators</h5>
              </IonCol>
              <IonCol size='auto'>
                <SimpleButton onClick={() => onClose()}>Close X</SimpleButton>
              </IonCol>
            </IonRow>
            <div style={{ height: '79%', overflow: 'auto' }}>
              {indicatorRows.map((row, rowIndex) => (
                <IonRow key={rowIndex} style={{ marginLeft: '2em', marginTop: rowIndex === 0 ? '0' : '2em', height: '40%' }}>
                  {row.map((category) => (
                    <IonCol key={category}>
                      <h5 style={{ color: '#4197A9', fontSize: 13, marginBottom: '4px' }}>{category}</h5>
                      {groupedIndicators[category].map((indicator) => (
                        <div key={indicator.id} style={{ marginBottom: '9px' }}>
                          <p style={{ margin: 0, fontSize: 13, color: '#737475' }}>
                            {indicator.indicator}
                          </p>
                        </div>
                      ))}
                    </IonCol>
                  ))}
                  {row.length < 3 && [...Array(3 - row.length)].map((_, index) => (
                    <IonCol key={`empty-${index}`} />
                  ))}
                </IonRow>
              ))}
            </div>
            <IonRow className='ion-justify-content-between'>
              <IonButton onClick={prevStep}>Back</IonButton>
              <IonButton onClick={nextStep}>Next</IonButton>
            </IonRow>
          </OverlayContainer>
        </>
      )
    case 4:
      return (
                <>
          <OverlayContainer style={{ zIndex: 35, width: '90%', height: '89%', borderRadius: '1em' }}>
            <IonRow className='ion-align-items-center ion-justify-content-between' style={{ marginBottom: '0.5em' }}>
              <IonCol size='auto'>
                <h5 className='blue' style={{ margin: 0, fontSize: 16, color: '#326771', fontWeight: 'bold', marginLeft: '0.1em' }}>Control Measures</h5>
              </IonCol>
              <IonCol size='auto'>
                <SimpleButton onClick={() => onClose()}>Close X</SimpleButton>
              </IonCol>
            </IonRow>
            <div style={{ height: '79%', overflow: 'auto' }}>
              {rows.map((row, rowIndex) => (
                <IonRow key={rowIndex} style={{ marginLeft: '2em', marginTop: rowIndex === 0 ? '0' : '2em', height: '40%' }}>
                  {row.map((category) => (
                    <IonCol key={category}>
                      <h5 style={{ color: '#4197A9', fontSize: 13, marginBottom: '4px' }}>{category}</h5>
                      {groupedMeasures[category].map((measure) => (
                        <div key={measure.id} style={{ marginBottom: '9px' }}>
                          <p style={{ margin: 0, fontSize: 13, color: '#737475' }}>
                            {measure.control_measure}
                          </p>
                        </div>
                      ))}
                    </IonCol>
                  ))}
                  {row.length < 3 && [...Array(3 - row.length)].map((_, index) => (
                    <IonCol key={`empty-${index}`} />
                  ))}
                </IonRow>
              ))}
            </div>
            <IonRow className='ion-justify-content-between'>
              <IonButton onClick={prevStep}>Back</IonButton>
              <IonButton onClick={nextStep}>Next</IonButton>
            </IonRow>
          </OverlayContainer>
        </>
      )
    case 5:
      return (
        <>
          <OverlayContainer style={{ zIndex: 25, width: '90%', height: '90%', borderRadius: '1em' }} className='terrain-add-popup'>
            <IonRow className='ion-justify-content-end'>
              <SimpleButton onClick={() => onClose()}>Close X</SimpleButton>
            </IonRow>
            <h5 style={{ color: '#326771', fontSize: 16, margin: '12px 0 4px', marginTop: '0' }}>Additional Comments</h5>
            <div
              style={{
                width: '100%',
                borderRadius: '1em',
                border: '1px solid #ccc',
                padding: '1em',
                fontSize: '14px',
                boxSizing: 'border-box',
                marginBottom: '1.5em',
                backgroundColor: '#f9f9f9',
                whiteSpace: 'pre-wrap',
                height: '50%',
              }}
            >
              {selectedAlert?.comments || 'No comments provided.'}
            </div>
            <div
              style={{
                border: '1px solid #ccc',
                borderRadius: '10px',
                padding: '16px',
                backgroundColor: '#f9f9f9',
                width: '100%',
                maxWidth: '400px',
                boxSizing: 'border-box',
              }}
            >
                <>
                  <h6 style={{ marginBottom: '8px', color: '#326771', fontSize: 16 }}>
                    Review Date
                  </h6>
                  <p style={{ fontSize: '13px', marginBottom: '16px' }}>
                    <span style={{ color: '#4197A9' }}>Review scheduled for:</span>{' '}
                    {new Date(selectedAlert.review_date).toLocaleString()}
                  </p>
                </>
            </div>

            <IonRow className='ion-justify-content-between'>
              <IonButton onClick={prevStep}>Back</IonButton>
              <IonButton onClick={onClose}>Finish</IonButton>
            </IonRow>
          </OverlayContainer>
        </>
      )
    default:
      return null
  }
}

const ReviewAlertPopup = ({ onClose, asset, setSelectedAsset, setReviewAlertPopup, selectedAlert }) => {
  const [step, setStep] = useState(1)

  const nextStep = () => setStep(prev => Math.min(prev + 1, 7))
  const prevStep = () => setStep(prev => Math.max(prev - 1, 1))
  const [alert, setAlert] = useState(asset.alert_state || 1) // Default to Level 1 - Caution
  const [proposedAlert, setProposedAlert] = useState(null) // default to current
  const [input, setInput] = useState<any>({ existingMeasures: asset.control_measures, newMeasures: [], comments: selectedAlert?.comments || '' })
  const { user } = useAuth()
  const { workspace } = useWorkspace()

  const [indicatorInput, setIndicatorInput] = useState({
    existingCategory: null,
    existingMeasures: selectedAlert?.alert_indicators ?? [],
    edit: false,
  })
  const existingIndicators = sanitizeIndicators(indicatorInput?.existingMeasures)

  const [selectedDate, setSelectedDate] = useState<string>('')
  const { rawMeasures, users, setLoading, setSubmittedMessage, rawIndicators, selectedAsset } = useRiskRegister()
  const categories = rawMeasures.map(({ category }) => category).filter((val, pos, arr) => arr.indexOf(val) === pos)


  const alertDefs = [
    ['Level 1 - Caution', 'There is a low risk of possible terrorist activity or civil unrest affecting operations or personnel. Business as usual.'],
    ['Level 2 - Warning', 'A general or localised threat situation, the nature and extent of which are unpredictable, and circumstances do not justify full implementation of higher alert measures. Local travel restrictions may be necessary.'],
    ['Level 3 - Standfast', 'A foreseen event or situation that could impact on the security of operations. There is potential for the security situation in the area to deteriorate rapidly. Local lockdowns and/or severely restricted staff movements may be necessary. An evacuation may be required imminently.'],
    ['Level 4 - Standby', 'A "threat to life" incident is highly likely. Security conditions are hostile and approaching a level where operations are not possible. Critical risk to staff. Partial evacuation should be considered.'],
    ['Level 5 - Evacuation', 'There is an immediate/direct threat to personnel; or armed conflict has occurred in the area. There are extreme risks to personnel and assets. Full evacuation should be considered.']
  ]
  const alertLabel = alertDefs[alert - 1][0]
  const alertDefinition = alertDefs[alert - 1][1]

  const customStyles = {
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: '#326771', // Set background color to #326771
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: '#fff', // Set text color to white
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      color: '#fff', // Set remove icon color to white
      ':hover': {
        backgroundColor: '#ff0000', // Change this to your desired hover background color
        color: '#fff', // Set hover text color to white
      },
    }),
  }

  function getAlertColor(level) {
    if (level === 'Level 1 - Caution') {
      return '#14C105'
    } if (level === 'Level 2 - Warning') {
      return '#349DFF'
    } if (level === 'Level 3 - Standfast') {
      return '#FFE500'
    } if (level === 'Level 4 - Standby') {
      return '#FF8A00'
    }
    return '#FF0000'
  }

  const handleAddMeasures = () => {
    const measureIds = input.existingMeasures.map((measure) => measure.id)
    setLoading(true)
    axios.post('/api/v1/asset/add_control_measures', {
      domain_id: workspace.id,
      asset_id: asset.id,
      measures: measureIds,
    }).then((response) => {
      // Assuming the response contains the newly created note's ID
      // const { id } = response.data // Extract the ID from the response
      // Create a new note object with the ID and other details
      // Update the selectedAsset.notes with the new note
      setSubmittedMessage('Control Measures Created Successfully')
      setLoading(false)
      setSelectedAsset({ ...selectedAsset, control_measures: input.existingMeasures })
    }).catch((error) => {
      console.error('Error adding Measure:', error)
      setLoading(false)
    })
  }

  const handleUpdateAlert = () => {
    handleAddMeasures()
    setLoading(true)
    const indicatorIds = existingIndicators.map((indicator) => indicator.id)
    axios.put('/api/v1/asset/review_alert_state_history', {
      id: selectedAlert.id, // This should be the ID of the AlertStateHistory being reviewed
      approved_level: proposedAlert,
      comments: input?.comments || '',
      indicators: indicatorIds, // optional, only if updating indicators
    })
    .then((response) => {
      const updatedHistory = response.data.alert_history

      setSelectedAsset(prevState => ({
        ...prevState,
        alert_state_histories: (prevState.alert_state_histories || []).map(history =>
          history.id === updatedHistory.id ? updatedHistory : history
        ),
      }))

      setLoading(false)
      setSubmittedMessage('Alert state history created successfully')
      setReviewAlertPopup(false)
    })
    .catch((error) => {
      console.error('Error creating alert state history:', error)
      setLoading(false)
    })
  }

  const handleDropRemove = (e) => {
    /* Get measure name */
    const measure = JSON.parse(e.dataTransfer.getData('measure'))

    const index = input?.existingMeasures.findIndex((val) => val.id === measure.id)
    if (index < 0) return

    const copy = input?.existingMeasures.slice()
    copy.splice(index, 1)

    if (Object.keys(input?.removeNew).find((val) => val === measure.id)) {
      setInput({ ...input, removeNew: { ...input?.removeNew, [measure.id]: false }, existingMeasures: copy })
      return
    }

    if (Object.keys(input?.removeExisting).find((val) => val === measure.id)) {
      setInput({ ...input, removeExisting: { ...input.removeExisting, [measure.id]: false }, existingMeasures: copy })
      return
    }
    setInput({ ...input, existingMeasures: copy })
  }

  const handleDropAdd = (e) => {
    const measure = JSON.parse(e.dataTransfer.getData('measure'));

    if (!input) return;

    if (input.existingMeasures?.find((val) => val.id === measure.id)) return;

    const copy = input.existingMeasures?.slice() ?? [];
    copy.push(measure);

    // Ensure removeNew and removeExisting are objects before using Object.keys
    const removeNew = input.removeNew ?? {};
    const removeExisting = input.removeExisting ?? {};

    if (Object.keys(removeNew).includes(measure.id)) {
      setInput({ ...input, removeNew: { ...removeNew, [measure.id]: true }, existingMeasures: copy });
      return;
    }

    if (Object.keys(removeExisting).includes(measure.id)) {
      setInput({ ...input, removeExisting: { ...removeExisting, [measure.id]: true }, existingMeasures: copy });
      return;
    }

    setInput({ ...input, existingMeasures: copy });
  }

  const [selectedApprover, setSelectedApprover] = useState(null)

  const options = users.map(user => ({
    value: user.id,
    label: `${user.first_name} ${user.final_name}`,
    user, // Attach full user data for display
  }))

  const handleSelect = (selected) => {
    setSelectedApprover(selected.user)
  }

    const getAlertStyle = (value) => {
    switch (value) {
      case 1:
        return { backgroundColor: '#14C105', color: 'white' }
      case 2:
        return { backgroundColor: '#349DFF', color: 'white' }
      case 3:
        return { backgroundColor: '#FFE500', color: 'black' }
      case 4:
        return { backgroundColor: '#FF8A00', color: 'white' }
      case 5:
        return { backgroundColor: '#FF8A00', color: 'white' }
      default:
        return { backgroundColor: 'white', color: 'black' }
    }
  }

  const ind_categories = rawIndicators.map(({ category }) => category).filter((val, pos, arr) => arr.indexOf(val) === pos)
  
  const handleIndicatorDropRemove = (e) => {
    const indicator = JSON.parse(e.dataTransfer.getData('measure')) // Assuming 'measure' is reused
    const index = existingIndicators.findIndex((val) => val.id === indicator.id)
    if (index < 0) return

    const copy = existingIndicators.slice()
    copy.splice(index, 1)

    if (Object.keys(indicatorInput?.removeNew).find((val) => val === indicator.id)) {
      setIndicatorInput({
        ...indicatorInput,
        removeNew: { ...indicatorInput?.removeNew, [indicator.id]: false },
        existingMeasures: copy
      })
      return
    }

    if (Object.keys(indicatorInput?.removeExisting).find((val) => val === indicator.id)) {
      setIndicatorInput({
        ...indicatorInput,
        removeExisting: { ...indicatorInput.removeExisting, [indicator.id]: false },
        existingMeasures: copy
      })
      return
    }
    setIndicatorInput({ ...indicatorInput, existingMeasures: copy })
  }

  const handleIndicatorDropAdd = (e) => {
    const indicator = JSON.parse(e.dataTransfer.getData('measure'))

    if (!indicatorInput) return

    if (existingIndicators.find((val) => val.id === indicator.id)) return

    const copy = existingIndicators.slice()
    copy.push(indicator)

    const removeNew = indicatorInput.removeNew ?? {}
    const removeExisting = indicatorInput.removeExisting ?? {}

    if (Object.keys(removeNew).includes(indicator.id)) {
      setIndicatorInput({
        ...indicatorInput,
        removeNew: { ...removeNew, [indicator.id]: true },
        existingMeasures: copy
      });
      return
    }

    if (Object.keys(removeExisting).includes(indicator.id)) {
      setIndicatorInput({
        ...indicatorInput,
        removeExisting: { ...removeExisting, [indicator.id]: true },
        existingMeasures: copy
      })
      return
    }

    setIndicatorInput({ ...indicatorInput, existingMeasures: copy })
  }

  const proposedAlertLabel = alertDefs[selectedAlert.proposed_level - 1][0]
  const proposedAlertDefinition = alertDefs[selectedAlert.proposed_level - 1][1]

  const getNoteUser = (user_id) => {
    const user = users.find((e) => e.id === user_id)
    if (user) {
      return { value: user.id, label: `${user.first_name} ${user.final_name}`, email: user.email, phone_number: user.phone_number }
    }
    return { value: null, label: 'N/A' }
  }


  switch (step) {
    case 1:
      return (
        <>
          <OverlayContainer style={{ zIndex: 25, width: '90%', height: '90%', borderRadius: '1em' }} className='terrain-add-popup'>
            <IonRow className='ion-justify-content-end'>
              <SimpleButton onClick={() => onClose()}>Close X</SimpleButton>
            </IonRow>
            <h5 style={{ color: '#326771', fontSize: 16, marginBottom: '4px' }}>{asset.name}</h5>
            <div style={{ height: '79%', overflow: 'auto' }}>
                            <IonGrid>
                <IonRow style={{ fontWeight: 600 }}>
                  <IonCol><h5 style={{ color: '#4197A9', fontSize: 16, margin: 0 }}>Asset Type</h5></IonCol>
                  <IonCol><h5 style={{ color: '#4197A9', fontSize: 16, margin: 0 }}>Owner</h5></IonCol>
                  <IonCol><h5 style={{ color: '#4197A9', fontSize: 16, margin: 0 }}>Approver</h5></IonCol>
                  <IonCol><h5 style={{ color: '#4197A9', fontSize: 16, margin: 0 }}>Date</h5></IonCol>
                </IonRow>
                <IonRow>
                  <IonCol><p style={{ fontSize: 13, margin: 0 }}>{asset.asset_type}</p></IonCol>
                  <IonCol><p style={{ fontSize: 13, margin: 0 }}>{getNoteUser(selectedAlert.user_id).label}</p></IonCol>
                  <IonCol><p style={{ fontSize: 13, margin: 0 }}>{getNoteUser(selectedAlert.approved_by).label}</p></IonCol>
                  <IonCol><p style={{ fontSize: 13, margin: 0 }}>{new Date(selectedAlert.review_date).toLocaleString()}</p></IonCol>
                </IonRow>
              </IonGrid>
              <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap', marginTop: '1em' }}>
                {/* Current Alert */}
                <div style={{ flex: 1, minWidth: '200px' }}>
                  <div style={{ fontSize: '12px', marginBottom: '4px' }}><h5 style={{ color: '#4197A9', fontSize: 16, margin: 0 }}>Current Alert State</h5></div>
                  <div style={{ display: 'inline-block', padding: '4px 8px', backgroundColor: getAlertColor(alertLabel), borderRadius: '4px' }}>
                    <span style={{ color: alertLabel === 'Level 3 - Standfast' ? '#000' : '#fff', fontWeight: 600, fontSize: '13px' }}>
                      {alertLabel}
                    </span>
                  </div>
                  <p style={{ fontSize: '12px', marginTop: '6px', color: '#333' }}>{alertDefinition}</p>
                </div>

                {/* Proposed Alert */}
                <div style={{ flex: 1, minWidth: '200px' }}>
                  <div style={{ fontSize: '12px', marginBottom: '4px' }}><h5 style={{ color: '#4197A9', fontSize: 16, margin: 0 }}>Advised Alert State</h5></div>
                  <div style={{ display: 'inline-block', padding: '4px 8px', backgroundColor: getAlertColor(proposedAlertLabel), borderRadius: '4px' }}>
                    <span style={{ color: proposedAlertLabel === 'Level 3 - Standfast' ? '#000' : '#fff', fontWeight: 600, fontSize: '13px' }}>
                      {proposedAlertLabel}
                    </span>
                  </div>
                  <p style={{ fontSize: '12px', marginTop: '6px', color: '#333' }}>{proposedAlertDefinition}</p>
                </div>
              </div>
              <h5 style={{ color: '#4197A9', fontSize: 16, margin: 0 }}>Owner's Comment</h5>
              <p style={{ fontSize: '13px', marginTop: '6px', color: '#333' }}>{selectedAlert.comments}</p>

            </div>
            <IonRow className='ion-justify-content-end'>
              <IonButton onClick={nextStep}>Next</IonButton>
            </IonRow>
          </OverlayContainer>
        </>
      )
    case 2:
      return (
        <>
          <OverlayContainer style={{ zIndex: 25, width: '90%', height: '90%', borderRadius: '1em', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }} className='terrain-add-popup'>
            <div style={{ overflowY: 'auto' }}>
              {/* Header Row */}
              <IonRow className='ion-justify-content-end'>
                <SimpleButton onClick={onClose}>Close ✕</SimpleButton>
              </IonRow>

              {/* Title */}
              <h5 className='blue' style={{ margin: 0, fontSize: 16, color: '#326771', fontWeight: 'bold', marginLeft: '0.1em' }}>Security Event Summary</h5>
              <IncidentDataSummary
                monthly_events={asset?.monthly_events}
                breakdown_30={asset?.breakdown_30}
              />


            </div>

            <IonRow className='ion-justify-content-between' style={{ marginTop: '2em', marginBottom: '1.5em' }}>
              <IonButton onClick={prevStep}>Back</IonButton>
              <IonButton onClick={nextStep}>Next</IonButton>
            </IonRow>
          </OverlayContainer>
        </>
      )
    case 3:
      return (
        <>
          <OverlayContainer style={{ zIndex: 35, width: '90%', height: '89%', borderRadius: '1em' }}>
            <IonRow className='ion-align-items-center ion-justify-content-between' style={{ marginBottom: '0.5em' }}>
              <IonCol size='auto'>
                <h5 className='blue' style={{ margin: 0, fontSize: 16, color: '#326771', fontWeight: 'bold', marginLeft: '0.1em' }}>Add Indicators</h5>
              </IonCol>
              <IonCol size='auto'>
                <SimpleButton onClick={() => onClose()}>Close X</SimpleButton>
              </IonCol>
            </IonRow>
            <div style={{ marginTop: '0' }}>
              <SettingField style={{ marginTop: '0' }}>
                <p style={{ fontSize: 13 }}>Indicators are indicators that are currently in place for this Key Asset. Use the drop-down to select a category,
                  and then <span style={{ color: '#326771' }}>drag and drop</span> items from the left table to the right.
                </p>
              </SettingField>
              <div style={{ width: '200px' }}>
                <Select
                  placeholder='Select Category'
                  name='existingCategory'
                  id='existing-control-measure-categories'
                  className='select-container'
                  value={indicatorInput?.existingCategory}
                  // eslint-disable-next-line no-undef
                  menuPortalTarget={document.body}
                  options={ind_categories.map((level) => ({ value: level, label: level }))}
                  onChange={(selected) => setIndicatorInput({ ...indicatorInput, existingCategory: selected, edit: true })}
                />
              </div>
              <IonRow className='ion-align-items-center'>
                <IonCol size={5}>
                  <ColumnContainer style={{ height: '240px' }} onDragOver={(e) => e.preventDefault()} onDrop={handleIndicatorDropRemove}>
                    {indicatorInput?.existingCategory
                      && rawIndicators.filter(({ category }) => category === indicatorInput?.existingCategory.value)
                        .filter((val) => !existingIndicators.find((measure) => measure.id === val.id)).map((measure, index) => (
                          <MeasureContainer
                            className='single-control-measure'
                            key={index}
                            draggable
                            style={{ backgroundColor: getColor(index) }}
                            onDragStart={(e) => e.dataTransfer.setData('measure', JSON.stringify(measure))}
                          >
                            <p> {measure.indicator} </p>
                          </MeasureContainer>
                        ))}
                    {!indicatorInput?.existingCategory && (
                      <IonRow style={{ height: '100%' }} className='ion-align-items-center'>
                        <SettingField style={{ textAlign: 'center', width: 'auto' }}>
                          <h4 style={{ fontWeight: 'normal', margin: '20px 0', color: "#326771" }}>Choose a category to select indicators</h4>
                          <p style ={{ fontSize: 13 }}>To start adding indicators, choose a category from the drop-down menu above. </p>
                        </SettingField>
                      </IonRow>
                    )}
                  </ColumnContainer>
                </IonCol>
                <IonCol style={{ textAlign: 'center', fontSize: '2.6rem' }} size={2}>
                  <Icon color='#326771' icon='ic:round-swipe-right' />
                </IonCol>
                <IonCol size={5}>
                  <ColumnContainer style={{ height: '240px' }} id='cm-existing-drop' onDragOver={(e) => e.preventDefault()} onDrop={handleIndicatorDropAdd}>
                    {indicatorInput?.existingCategory && existingIndicators.filter((selected) => selected.category === indicatorInput?.existingCategory.value).map((measure, index) => (
                      <MeasureContainer
                        className='selected-control-measure'
                        key={index}
                        draggable
                        style={{ backgroundColor: getColor(index) }}
                        onDragStart={(e) => e.dataTransfer.setData('measure', JSON.stringify(measure))}
                      >
                        <p> {measure.indicator} </p>
                      </MeasureContainer>
                    ))}
                    {(!indicatorInput?.existingCategory || existingIndicators.filter((selected) => selected.category === indicatorInput?.existingCategory.value).length === 0) && (
                      <IonRow style={{ height: '100%' }} className='ion-align-items-center'>
                        <SettingField style={{ textAlign: 'center', width: 'auto' }}>
                          <h4 style={{ fontWeight: 'normal', margin: '20px 0', color:"#326771" }}>Drag and drop items from the left to add them to your Key Asset’s profile</h4>
                          <p style={{ fontSize: 13 }}>Indicators that you add here will appear in the Key Assets profile as current indicators.</p>
                        </SettingField>
                      </IonRow>
                    )}
                  </ColumnContainer>
                </IonCol>
              </IonRow>
            </div>
            <IonRow className='ion-justify-content-between'>
              <IonButton onClick={prevStep}>Back</IonButton>
              <IonButton onClick={nextStep}>Next</IonButton>
            </IonRow>
          </OverlayContainer>
        </>
      )
    case 4:
      return (
        <>
          <OverlayContainer style={{ zIndex: 35, width: '90%', height: '89%', borderRadius: '1em' }}>
            <IonRow className='ion-align-items-center ion-justify-content-between' style={{ marginBottom: '0.5em' }}>
              <IonCol size='auto'>
                <h5 className='blue' style={{ margin: 0, fontSize: 16, color: '#326771', fontWeight: 'bold', marginLeft: '0.1em' }}>Add Control Measures</h5>
              </IonCol>
              <IonCol size='auto'>
                <SimpleButton onClick={() => onClose()}>Close X</SimpleButton>
              </IonCol>
            </IonRow>
            <div style={{ marginTop: '0' }}>
              <SettingField style={{ marginTop: '0' }}>
                <p style={{ fontSize: 13 }}>Control Measures are measures that are currently in place for this Key Asset. Use the drop-down to select a category,
                  and then <span style={{ color: '#326771' }}>drag and drop</span> items from the left table to the right.
                </p>
              </SettingField>
              <div style={{ width: '200px' }}>
                <Select
                  placeholder='Select Category'
                  name='existingCategory'
                  id='existing-control-measure-categories'
                  className='select-container'
                  value={input?.existingCategory}
                  // eslint-disable-next-line no-undef
                  menuPortalTarget={document.body}
                  options={categories.map((level) => ({ value: level, label: level }))}
                  onChange={(selected) => setInput({ ...input, existingCategory: selected, edit: true })}
                />
              </div>
              <IonRow className='ion-align-items-center'>
                <IonCol size={5}>
                  <ColumnContainer style={{ height: '240px' }} onDragOver={(e) => e.preventDefault()} onDrop={handleDropRemove}>
                    {input?.existingCategory
                      && rawMeasures.filter(({ category }) => category === input?.existingCategory.value)
                        .filter((val) => !input?.existingMeasures.find((measure) => measure.id === val.id)).map((measure, index) => (
                          <MeasureContainer
                            className='single-control-measure'
                            key={index}
                            draggable
                            style={{ backgroundColor: getColor(index) }}
                            onDragStart={(e) => e.dataTransfer.setData('measure', JSON.stringify(measure))}
                          >
                            <p> {measure.control_measure} </p>
                          </MeasureContainer>
                        ))}
                    {!input?.existingCategory && (
                      <IonRow style={{ height: '100%' }} className='ion-align-items-center'>
                        <SettingField style={{ textAlign: 'center', width: 'auto' }}>
                          <h4 style={{ fontWeight: 'normal', margin: '20px 0', color: "#326771" }}>Choose a category to select measures</h4>
                          <p style ={{ fontSize: 13 }}>To start adding control measures, choose a category from the drop-down menu above. </p>
                        </SettingField>
                      </IonRow>
                    )}
                  </ColumnContainer>
                </IonCol>
                <IonCol style={{ textAlign: 'center', fontSize: '2.6rem' }} size={2}>
                  <Icon color='#326771' icon='ic:round-swipe-right' />
                </IonCol>
                <IonCol size={5}>
                  <ColumnContainer style={{ height: '240px' }} id='cm-existing-drop' onDragOver={(e) => e.preventDefault()} onDrop={handleDropAdd}>
                    {input?.existingCategory && input?.existingMeasures.filter((selected) => selected.category === input?.existingCategory.value).map((measure, index) => (
                      <MeasureContainer
                        className='selected-control-measure'
                        key={index}
                        draggable
                        style={{ backgroundColor: getColor(index) }}
                        onDragStart={(e) => e.dataTransfer.setData('measure', JSON.stringify(measure))}
                      >
                        <p> {measure.control_measure} </p>
                      </MeasureContainer>
                    ))}
                    {(!input?.existingCategory || input?.existingMeasures.filter((selected) => selected.category === input?.existingCategory.value).length === 0) && (
                      <IonRow style={{ height: '100%' }} className='ion-align-items-center'>
                        <SettingField style={{ textAlign: 'center', width: 'auto' }}>
                          <h4 style={{ fontWeight: 'normal', margin: '20px 0', color: "#326771" }}>Drag and drop items from the left to add them to your Key Asset’s profile</h4>
                          <p style={{ fontSize: 13 }}>Control measures that you add here will appear in the Key Assets profile as existing measures.</p>
                        </SettingField>
                      </IonRow>
                    )}
                  </ColumnContainer>
                </IonCol>
              </IonRow>
            </div>
            <IonRow className='ion-justify-content-between'>
              <IonButton onClick={prevStep}>Back</IonButton>
              <IonButton onClick={nextStep}>Next</IonButton>
            </IonRow>
          </OverlayContainer>
        </>
      )
    case 5:
      return (
        <>
          <OverlayContainer style={{ zIndex: 25, width: '90%', height: '90%', borderRadius: '1em' }} className='terrain-add-popup'>
            <IonRow className='ion-justify-content-end'>
              <SimpleButton onClick={() => onClose()}>Close X</SimpleButton>
            </IonRow>
            <h5 style={{ color: '#326771', fontSize: 16, margin: '12px 0 4px', marginTop: '0' }}>Alert State Selection</h5>
            <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap', marginTop: '1em' }}>
              {/* Current Alert */}
              <div style={{ flex: 1, minWidth: '200px' }}>
                <div style={{ fontSize: '12px', marginBottom: '4px' }}><h5 style={{ color: '#4197A9', fontSize: 16, margin: 0 }}>Current Alert State</h5></div>
                <div style={{ display: 'inline-block', padding: '4px 8px', backgroundColor: getAlertColor(alertLabel), borderRadius: '4px' }}>
                  <span style={{ color: alertLabel === 'Level 3 - Standfast' ? '#000' : '#fff', fontWeight: 600, fontSize: '13px' }}>
                    {alertLabel}
                  </span>
                </div>
                <p style={{ fontSize: '12px', marginTop: '6px', color: '#333' }}>{alertDefinition}</p>
              </div>      
              {/* Proposed Alert */}
              <div style={{ flex: 1, minWidth: '200px' }}>
                <div style={{ fontSize: '12px', marginBottom: '4px' }}><h5 style={{ color: '#4197A9', fontSize: 16, margin: 0 }}>Proposed Alert State</h5></div>
                <div style={{ display: 'inline-block', padding: '4px 8px', backgroundColor: getAlertColor(proposedAlertLabel), borderRadius: '4px' }}>
                  <span style={{ color: proposedAlertLabel === 'Level 3 - Standfast' ? '#000' : '#fff', fontWeight: 600, fontSize: '13px' }}>
                    {proposedAlertLabel}
                  </span>
                </div>
                <p style={{ fontSize: '12px', marginTop: '6px', color: '#333' }}>{proposedAlertDefinition}</p>
              </div>
            </div>
            <h5 style={{ color: '#4197A9', fontSize: 13, margin: '12px 0 4px', marginTop: '0.5em' }}>Advised Alert State</h5>
            <div
              style={{
                backgroundColor: proposedAlert
                  ? getAlertColor(alertDefs[proposedAlert - 1][0])
                  : '#cccccc',
                padding: '4px',
                borderRadius: '6px',
                width: 'fit-content',
                marginBottom: '1em',
              }}
            >
              <Select
                placeholder='Select Alert State'
                name='proposedAlert'
                id='select-alert-container'
                className='select-container'
                menuPortalTarget={document.body}
                options={alertDefs.map((def, index) => ({
                  value: index + 1,
                  label: def[0],
                }))}
                onChange={(selected) => setProposedAlert(selected?.value || null)}
                value={
                  proposedAlert
                    ? {
                        value: proposedAlert,
                        label: alertDefs[proposedAlert - 1][0],
                      }
                    : null
                }
                styles={{
                  control: (base) => ({
                    ...base,
                    backgroundColor: 'transparent',
                    border: 'none',
                    boxShadow: 'none',
                    fontSize: '13px',
                    color:
                      proposedAlert &&
                      alertDefs[proposedAlert - 1][0] === 'Level 3 - Standfast'
                        ? '#000000'
                        : '#FFFFFF',
                    minWidth: '250px', // Optional: ensure minimum control width
                  }),
                  singleValue: (base) => ({
                    ...base,
                    fontSize: '13px',
                    color:
                      proposedAlert &&
                      alertDefs[proposedAlert - 1][0] === 'Level 3 - Standfast'
                        ? '#000000'
                        : '#FFFFFF',
                  }),
                  placeholder: (base) => ({
                    ...base,
                    fontSize: '13px',
                    color: '#FFFFFF',
                  }),
                  dropdownIndicator: (base) => ({
                    ...base,
                    color:
                      proposedAlert &&
                      alertDefs[proposedAlert - 1][0] === 'Level 3 - Standfast'
                        ? '#000000'
                        : '#FFFFFF',
                  }),
                  indicatorSeparator: () => ({ display: 'none' }),
                  menu: (base) => ({
                    ...base,
                    zIndex: 9999,
                    fontSize: '13px',
                    minWidth: 'max-content', // 👈 Ensures the menu is as wide as needed
                    width: 'auto',            // 👈 Allows menu to expand beyond control width
                  }),
                  option: (base, state) => ({
                    ...base,
                    fontSize: '13px',
                    backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                    color: 'black',
                    whiteSpace: 'nowrap',
                  }),
                }}
              />
            </div>
            <div style={{
              border: '1px solid #ccc',
              borderRadius: '10px',
              padding: '16px',
              backgroundColor: '#f9f9f9',
              width: '100%',
              maxWidth: '600px',
              marginBottom: '20px',
            }}
            >
              <p style={{ fontSize: 13 }}>
                {proposedAlert ? alertDefs[proposedAlert - 1][1] : ''}
              </p>
            </div>
            <IonRow className='ion-justify-content-between'>
              <IonButton onClick={prevStep}>Back</IonButton>
              <IonButton onClick={handleUpdateAlert}>Submit</IonButton>
            </IonRow>
          </OverlayContainer>
        </>
      )
    case 6:
      return (
        <>
          <OverlayContainer style={{ zIndex: 25, width: '90%', height: '90%', borderRadius: '1em' }} className='terrain-add-popup'>
            <IonRow className='ion-justify-content-end'>
              <SimpleButton onClick={() => onClose()}>Close X</SimpleButton>
            </IonRow>
            <h5 style={{ color: '#326771', fontSize: 16, marginBottom: '4px' }}>Update Alert State</h5>
            <div style={{ height: '79%', overflow: 'auto' }}>
              <h5 style={{ color: '#4197A9', fontSize: 13, margin: '12px 0 4px', marginTop: '2em' }}>Reviewed Alert State</h5>
              <p style={{ fontSize: 12, marginBottom: '10px' }}>
                Please select the actual alert state level from the dropdown below to be set for this asset with this review.
              </p>
              <IonGrid style={{ paddingTop: '7px', paddingLeft: '10px', paddingRight: '10px' }}>
                <IonRow style={{ outline: 'solid 2px' }}>
                  <IonCol
                    size='3'
                    style={{
                      backgroundColor: proposedAlert
                        ? getAlertColor(alertDefs[proposedAlert - 1][0])
                        : '#cccccc', // neutral color for placeholder
                      padding: '4px',
                    }}
                  >
                    <Select
                      placeholder='Select Alert State'
                      name='proposedAlert'
                      id='select-alert-container'
                      className='select-container'
                      menuPortalTarget={document.body}
                      options={alertDefs.map((def, index) => ({
                        value: index + 1,
                        label: def[0],
                      }))}
                      onChange={(selected) => setProposedAlert(selected?.value || null)}
                      value={
                        proposedAlert
                          ? {
                            value: proposedAlert,
                            label: alertDefs[proposedAlert - 1][0],
                          }
                          : null
                      }
                      styles={{
                        control: (base) => ({
                          ...base,
                          backgroundColor: 'transparent',
                          border: 'none',
                          boxShadow: 'none',
                          fontSize: '13px',
                          color: proposedAlert &&
                            alertDefs[proposedAlert - 1][0] === 'Level 3 - Standfast'
                            ? '#000000'
                            : '#FFFFFF',
                        }),
                        singleValue: (base) => ({
                          ...base,
                          fontSize: '13px',
                          color: proposedAlert &&
                            alertDefs[proposedAlert - 1][0] === 'Level 3 - Standfast'
                            ? '#000000'
                            : '#FFFFFF',
                        }),
                        placeholder: (base) => ({
                          ...base,
                          fontSize: '13px',
                          color: '#FFFFFF',
                        }),
                        dropdownIndicator: (base) => ({
                          ...base,
                          color: proposedAlert &&
                            alertDefs[proposedAlert - 1][0] === 'Level 3 - Standfast'
                            ? '#000000'
                            : '#FFFFFF',
                        }),
                        indicatorSeparator: () => ({ display: 'none' }),
                        menu: (base) => ({
                          ...base,
                          zIndex: 9999,
                          fontSize: '13px',
                        }),
                        option: (base, state) => ({
                          ...base,
                          fontSize: '13px',
                          backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                          color: 'black',
                        }),
                      }}
                    />
                  </IonCol>

                  <IonCol size='9' style={{ outline: 'solid 2px' }}>
                    <IonLabel style={{ fontSize: '12px' }}>
                      {proposedAlert ? alertDefs[proposedAlert - 1][1] : ''}
                    </IonLabel>
                  </IonCol>

                </IonRow>
              </IonGrid>
            </div>
            <IonRow className='ion-justify-content-between'>
              <IonButton onClick={prevStep}>Back</IonButton>
              <IonButton onClick={handleUpdateAlert}>Submit</IonButton>
            </IonRow>
          </OverlayContainer>
        </>
      )
    default:
      return null
  }
}

const AssetProfileV2 : FC = () => {
  const {
    selectedAsset, setEditing, setShowSelectedAsset, editing, users, incidentTypes, assetTypes, setLoading, setSubmittedMessage, assets,
    rawMeasures, setSelectedAsset, stakeholders, communities, manifestations, causes, regions, fetchRiskAssessments, eventTypes, riskEvents,
    dispatchRisk, fetchMitigations, focusedRisk, dispatchAsset, setAllAssets, allAssets, redrawAssets,
  } = useRiskRegister()

  const [view, setView] = useState<String>('Home')
  const [showAlertPopup, setShowAlertPopup] = useState(false)
  const [viewAlertPopup, setViewAlertPopup] = useState(false)
  const [reviewAlertPopup, setReviewAlertPopup] = useState(false)
  const [selectedAlert, setSelectedAlert] = useState()
  const { user } = useAuth()

  const categories = rawMeasures.map(({ category }) => category).filter((val, pos, arr) => arr.indexOf(val) === pos)

  const [selectedRegion, setSelectedRegion] = useState('')
  const [counties, setCounties] = useState([])
  const [selectedCounty, setSelectedCounty] = useState(selectedAsset.county_ids)

  const [question, setQuestion] = useState(0)
  const [edit, setEdit] = useState(false)

  const alertOptions = [
    {
      label: 'Level 1 - Caution',
      value: 1,
      definition: 'There is a low risk of possible terrorist activity or civil unrest affecting operations or personnel. Business as usual.',
    },
    {
      label: 'Level 2 - Warning',
      value: 2,
      definition: 'A general or localised threat situation, the nature and extent of which are unpredictable, and circumstances do not justify full implementation of higher alert measures. Local travel restrictions may be necessary.',
    },
    {
      label: 'Level 3 - Standfast',
      value: 3,
      definition: 'A foreseen event or situation that could impact on the security of operations. There is potential for the security situation in the area to deteriorate rapidly. Local lockdowns and / or severely restricted staff movements may be necessary. An evacuation may be required imminently.',
    },
    {
      label: 'Level 4 - Standby',
      value: 4,
      definition: 'A ‘threat to life’ incident is highly likely. Security conditions are hostile and approaching a level where operations are not possible. Critical risk to staff. Partial evacuation should be considered.',
    },
    {
      label: 'Level 5 - Evacuation',
      value: 5,
      definition: 'There is an immediate / direct threat to personnel; or armed conflict has occurred in the area. There are extreme risks to personnel and assets. Full evacuation should be considered.',
    },
  ]

  const flashStatusOptions = [
    { label: 'Low Condition', key: 'low', definition: 'The flashpoint is dormant, with no immediate threat of conflict. The situation remains stable, but periodic monitoring is advised.' },
    { label: 'Guarded Condition', key: 'guarded', definition: 'The flashpoint is active, but the risk of conflict is low. The situation remains stable, though ongoing observation and management are necessary to prevent escalation.' },
    { label: 'Elevated Condition', key: 'elevated', definition: 'The flashpoint is unstable and could escalate rapidly. Urgent action is needed to minimise or avoid conflict.' },
    { label: 'High Condition', key: 'high',definition: 'The flashpoint is highly unstable, and the risk of conflict is imminent.' },
    { label: 'Severe Condition', key: 'severe', definition: 'The flashpoint has escalated into active conflict.' },
  ]

  const getUser = () => {
    const user = users.find((e) => e.id === selectedAsset?.user_id)
    if (user) {
      return { value: user.id, label: `${user.first_name} ${user.final_name}` }
    }
    return { value: null, label: 'N/A' }
  }

  const getNoteUser = (user_id) => {
    const user = users.find((e) => e.id === user_id)
    if (user) {
      return { value: user.id, label: `${user.first_name} ${user.final_name}` }
    }
    return { value: null, label: 'N/A' }
  }

  const updateAdditionalManifest = (newVal: string, index: number) => {
    const copy = flashpointInput.additionalManifestations.slice()
    copy.splice(index, 1, newVal)

    setFlashpointInput({ ...flashpointInput, additionalManifestations: copy })
  }

  const getParent = () => {
    const parent = assets.find((e) => e.id === selectedAsset.parent_id)
    if (parent) {
      return { value: parent.id, label: parent.name }
    }
    return { value: null, label: 'N/A' }
  }

  type OptionType = {
    label: string;
    value: string;
  }

  const [owner, setOwner] = useState<any>(getUser)
  const [alert, setAlert] = useState(alertOptions.find((option) => option.value === selectedAsset.alert_state))
  const [comment, setComment] = useState<any>(selectedAsset.comment)
  const [date, setDate] = useState<any>(selectedAsset.review_date)
  const [factors, setFactors] = useState<{ label: string, value: string }[]>(selectedAsset.threats.map((threat) => ({ label: threat, value: threat })))
  const [name, setName] = useState<string>(selectedAsset.name)
  const [type, setType] = useState<OptionType>({ label: selectedAsset.asset_type, value: selectedAsset.asset_type })
  const [description, setDescription] = useState<string>(selectedAsset.description)
  const [associated, setAssociated] = useState<any>(selectedAsset.associated_asset_ids)
  const [selectedComms, setSelectedComms] = useState<any>(selectedAsset.comm_ids)
  const [subs, setSubs] = useState<any>(selectedAsset.sub_asset_ids)
  const [parent, setParent] = useState<any>(getParent)
  const [input, setInput] = useState<any>({ existingMeasures: selectedAsset.control_measures, newMeasures: [] })
  const [content, setContent] = useState<string>()
  const [subject, setSubject] = useState<string>()
  const [selectedNote, setSelectedNote] = useState<any>()
  const [selectedFlashpoint, setSelectedFlashpoint] = useState<any>()
  const [issues, setIssues] = useState<(IncidentCause & { selected: boolean })[]>([])
  const [flashpointInput, setFlashpointInput] = useState<any>({
    title: '',
    description: '',
    triggers: '',
    relevantAreas: [],
    comments: '',
    primaryManifestation: '',
    additionalManifestations: [''],
    primaryStakeholders: [],
    secondaryStakeholders: [],
    tertiaryStakeholders: [],
    status: '',
    assets: [],
  })
  const [fetchedRisks, setFetchedRisks] = useState<RiskAssessment[]>([])
  const [selectedRisk, setSelectedRisk] = useState<any>()

  const refetchAssetDetails = useCallback(() => {
    if (!selectedAsset?.id) return
    apiHook.getAssetDetails(selectedAsset.id)
      .then((data) => {
        setSelectedAsset((prev) => ({
          ...prev,
          threats: data.threats,
          adjustedRisks: data.adjusted_risks,
          inherentRisks: data.inherent_risks,
          mitigations: data.mitigations,
          incidents: data.incidents,
          monthly_events: data.monthly_events,
          breakdown_30: data.breakdown_30,
        }))
        /* Process backend data and add it to frontend data structures */
        const formattedRisks = processBackendRiskAssessments(data.threats, selectedAsset, users, eventTypes)
        setFetchedRisks(formattedRisks)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [selectedAsset?.id, users, eventTypes])

  useAlertHistoryRefetch(selectedAsset, refetchAssetDetails)

  const compareMeasures = (selectedRiskMeasures, formattedChangesMeasures) => {
    // Calculate removed measures (measures that exist in selectedRisk but not in formattedChanges)
    const toRemove = selectedRiskMeasures.filter((selectedMeasure) => !formattedChangesMeasures.some((formattedMeasure) => formattedMeasure.id === selectedMeasure.id))
    // Calculate added measures (measures that exist in formattedChanges but not in selectedRisk)
    const toAdd = formattedChangesMeasures.filter((formattedMeasure) => !selectedRiskMeasures.some((selectedMeasure) => selectedMeasure.id === formattedMeasure.id))
    return { toRemove, toAdd }
  }

  useEffect(() => {
    // Ensure categories are defined (but avoid returning early).
    const rowa = []
    const rowb = []
    // Process categories as normal if they are defined.
    for (let i = 0; i < selectedExistingCategories.length; i += 3) {
      rowa.push(selectedExistingCategories.slice(i, i + 3))
    }
    for (let i = 0; i < selectedNewCategories.length; i += 3) {
      rowb.push(selectedNewCategories.slice(i, i + 3))
    }
    setExistingRows(rowa)
    setNewRows(rowb)
  }, [selectedRisk, question])

  const getAddRemove = (newRecords: (Stakeholder | { id: number, name: string } | IncidentCause)[], oldRecords:
  (Stakeholder | { id: number, name: string } | IncidentCause)[]) : { toRemove: number[], toAdd: number[] } => {
    const toAdd = newRecords.filter(({ id }) => !oldRecords.find((val) => val.value === id))
    const toRemove = oldRecords.filter(({ id }) => !newRecords.find((val) => val.value === id))

    return {
      toAdd: toAdd.map(({ id }) => id),
      toRemove: toRemove.map(({ id }) => id),
    }
  }

  const colorCodeRisk = (riskLevel: string) : string => ({
    'Very Low': '#00b050',
    Low: '#00b0f0',
    Medium: '#ffff00',
    High: '#ffc000',
    Extreme: '#c00000',
  }[riskLevel])

  const [groupedMeasures, setGroupedMeasures] = useState(selectedAsset.control_measures.reduce((acc, measure) => {
    acc[measure.category] = acc[measure.category] || []
    acc[measure.category].push(measure)
    return acc
  }, {}))

  const [existingGroupedMeasures, setExistingGroupedMeasures] = useState(groupedMeasures)
  const [newGroupedMeasures, setNewGroupedMeasures] = useState(groupedMeasures)

  const selectedCategories = Object.keys(groupedMeasures)
  const [selectedNewCategories, setSelectedNewCategories] = useState(Object.keys(newGroupedMeasures))
  const [selectedExistingCategories, setSelectedExistingCategories] = useState(Object.keys(existingGroupedMeasures))

  // Break categories into chunks of 3 for each row
  const rows = []
  for (let i = 0; i < selectedCategories.length; i += 3) {
    rows.push(selectedCategories.slice(i, i + 3))
  }
  const [newRows, setNewRows] = useState(rows)
  const [existingRows, setExistingRows] = useState([])

  useEffect(() => {
    if (!editing) {
      setIssues(causes.map((val) => ({ ...val })))
      return
    }

    if (!selectedFlashpoint) {
      return
    }

    const stakeholders = {
      primaryStakeholders: selectedFlashpoint?.flashpoint_groups
        .filter(({ group_type }) => group_type === 'primary')
        .map(({ id, stakeholder }) => ({ value: id, label: stakeholder.name })),

      secondaryStakeholders: selectedFlashpoint?.flashpoint_groups
        .filter(({ group_type }) => group_type === 'secondary')
        .map(({ id, stakeholder }) => ({ value: id, label: stakeholder.name })),

      tertiaryStakeholders: selectedFlashpoint?.flashpoint_groups
        .filter(({ group_type }) => group_type === 'tertiary')
        .map(({ id, stakeholder }) => ({ value: id, label: stakeholder.name })),
    }

    setFlashpointInput({
      title: selectedFlashpoint.title,
      description: selectedFlashpoint.description,
      triggers: selectedFlashpoint.triggers,
      relevantAreas: selectedFlashpoint.areas.map(({ id, name }) => ({ value: id, label: name })),
      comments: selectedFlashpoint.comments,
      primaryManifestation: selectedFlashpoint.primary_manifestation,
      additionalManifestations: selectedFlashpoint.additional_manifestations.map(({ name }) => name),
      primaryStakeholders: stakeholders.primaryStakeholders,
      secondaryStakeholders: stakeholders.secondaryStakeholders,
      tertiaryStakeholders: stakeholders.tertiaryStakeholders,
      status: selectedFlashpoint.status,
      ongoing: selectedFlashpoint.ongoing ? 'Yes' : 'No',
    })
    setIssues(causes.map((val) => ({ ...val, selected: !!selectedFlashpoint.issues.find(({ id }) => val.id === id) })))
  }, [editing])

  const handleEditFlashpoint = () => {
    const stakeholdersPrimary = stakeholders.filter(({ id }) => flashpointInput.primaryStakeholders.find((val) => val.value === id))
    const stakeholdersSecondary = stakeholders.filter(({ id }) => flashpointInput.secondaryStakeholders.find((val) => val.value === id))
    const stakeholdersTertiary = stakeholders.filter(({ id }) => flashpointInput.tertiaryStakeholders.find((val) => val.value === id))

    const selectedIssues = issues.filter((val) => val.selected)

    const groups = {
      primaryStakeholders: selectedFlashpoint.flashpoint_groups
        .filter(({ group_type }) => group_type === 'primary')
        .map(({ id, stakeholder }) => ({ value: id, label: stakeholder.name })),

      secondaryStakeholders: selectedFlashpoint.flashpoint_groups
        .filter(({ group_type }) => group_type === 'secondary')
        .map(({ id, stakeholder }) => ({ value: id, label: stakeholder.name })),

      tertiaryStakeholders: selectedFlashpoint.flashpoint_groups
        .filter(({ group_type }) => group_type === 'tertiary')
        .map(({ id, stakeholder }) => ({ value: id, label: stakeholder.name })),
    }

    const primaryRecords = getAddRemove(stakeholdersPrimary, groups.primaryStakeholders)
    const secondaryRecords = getAddRemove(stakeholdersSecondary, groups.secondaryStakeholders)
    const tertiaryRecords = getAddRemove(stakeholdersTertiary, groups.tertiaryStakeholders)

    const issueRecords = getAddRemove(selectedIssues, selectedFlashpoint.issues)
    const communityRecords = getAddRemove(flashpointInput.relevantAreas.map(({ value, label }) => ({ id: value, name: label })), selectedFlashpoint.areas)

    const additionalMani = flashpointInput.additionalManifestations.filter((val) => val !== '').map((val, index) => ({ id: index, name: val }))

    setLoading(true)
    axios.put('/api/v2/flashpoint/edit_flashpoint', {
      flashpoint_id: selectedFlashpoint.id,
      domain_id: workspace.id,
      title: flashpointInput.title,
      description: flashpointInput.description,
      triggers: flashpointInput.triggers,
      status: flashpointInput.status,
      primary_manifestation: flashpointInput.primaryManifestation,
      ongoing: flashpointInput.ongoing === 'Yes',
      comments: flashpointInput.comments,

      primary_stakeholders_add: primaryRecords.toAdd,
      primary_stakeholders_remove: primaryRecords.toRemove,
      secondary_stakeholders_add: secondaryRecords.toAdd,
      secondary_stakeholders_remove: secondaryRecords.toRemove,
      tertiary_stakeholders_add: tertiaryRecords.toAdd,
      tertiary_stakeholders_remove: tertiaryRecords.toRemove,

      issues_add: issueRecords.toAdd,
      issues_remove: issueRecords.toRemove,
      community_add: communityRecords.toAdd,
      community_remove: communityRecords.toRemove,
      manifestations_add: additionalMani.filter(({ name }) => !selectedFlashpoint.additional_manifestations.find((val) => val.name === name)).map(({ name }) => name),
      manifestations_remove: selectedFlashpoint.additional_manifestations.filter(({ name }) => !additionalMani.find((val) => val.name === name)).map(({ name }) => name),
    }).then(({ data }) => {
      if (!data.ok) {
        console.error(data.message)
        return
      }

      const newFlashpoint : Flashpoint = {
        id: selectedFlashpoint.id,
        title: flashpointInput.title,
        description: flashpointInput.description,
        triggers: flashpointInput.triggers,
        status: flashpointInput.status as FlashpointStatus,
        primaryManifestation: flashpointInput.primaryManifestation,
        additionalManifestation: additionalMani,
        ongoing: (flashpointInput.ongoing === 'Yes'),
        issues: selectedIssues,
        primary_groups: stakeholdersPrimary,
        secondary_groups: stakeholdersSecondary,
        tertiary_groups: stakeholdersTertiary,
        relevant_areas: flashpointInput.relevantAreas.map(({ value, label }) => ({ id: value, name: label })),
        comments: flashpointInput.comments,
      }
      setSubmittedMessage('Flashpoint updated Successfully')
      // updateFlashpoint(newFlashpoint)
    }).catch(() => {
      setSubmittedMessage('Flashpoint updated Successfully')
    }).finally(() => {
      setEditing(false)
      setLoading(false)
    })
  }

  const apiHook = useApi()

  const { workspace } = useWorkspace()

  const handleSubjectChange = (event) => {
    setSubject(event.target.value)
  }

  const handleContentChange = (event) => {
    setContent(event.target.value)
  }

  const addManifestation = () => {
    const copy = flashpointInput.additionalManifestations.slice()
    copy.push('')

    setInput({ ...flashpointInput, additionalManifestations: copy })
  }

  const handleAddMeasures = () => {
    const measureIds = input.existingMeasures.map((measure) => measure.id)
    setLoading(true)
    axios.post('/api/v1/asset/add_control_measures', {
      domain_id: workspace.id,
      asset_id: selectedAsset.id,
      measures: measureIds,
    }).then((response) => {
      // Assuming the response contains the newly created note's ID
      // const { id } = response.data // Extract the ID from the response
      // Create a new note object with the ID and other details
      // Update the selectedAsset.notes with the new note
      setSubmittedMessage('Control Measures Created Successfully')
      setLoading(false)
      setView('Control Measures')
      setSelectedAsset({ ...selectedAsset, control_measures: input.existingMeasures })
      setGroupedMeasures(input.existingMeasures.reduce((acc, measure) => {
        acc[measure.category] = acc[measure.category] || []
        acc[measure.category].push(measure)
        return acc
      }, {}))
    }).catch((error) => {
      console.error('Error adding Measure:', error)
      setLoading(false)
      setView('Control Measures')
    })
  }

  const handleEditNote = () => {
    setLoading(true)

    const updatedNote = {
      id: selectedNote.id,
      subject,
      content,
    }

    axios.put('/api/v1/asset/edit_note', {
      domain_id: workspace.id,
      subject,
      note_id: selectedNote.id,
      content,
    }).then(() => {
      setEditing(false)
      setSubmittedMessage('Asset Note Edited Successfully')
      setLoading(false)
      setView('Notes')
      // Update selectedAsset.notes with the edited note
      setSelectedAsset((prevState) => {
        const updatedNotes = prevState.notes.map((note) => (note.id === updatedNote.id ? updatedNote : note))
        return {
          ...prevState,
          notes: updatedNotes,
        }
      })
    })
  }

  const handleEdit = () => {
    setLoading(true)
    const threatValues = factors?.map((threat) => threat.value)
    const subsValues = subs?.map((sub) => sub.value)
    const associatedValues = associated?.map((e) => e.value)
    const commValues = selectedComms?.map((e) => e.value) || []
    const countyValues = selectedCounty?.map((e) => e.value) || []
    apiHook.editAsset({
      domain_id: workspace.id,
      asset_id: selectedAsset.id,
      name,
      longitude: selectedAsset.longitude,
      latitude: selectedAsset.latitude,
      asset_type: type.value,
      description,
      threats: threatValues,
      alert_state: alert?.value,
      comment,
      review_date: date,
      owner: owner ? owner.value : null,
      parent: parent ? parent.value : null,
      subs: subsValues,
      associated: associatedValues,
      county_id: selectedCounty,
      comms: commValues,
      counties: countyValues,
    }).then(() => {
      setEditing(false)
      setSubmittedMessage('Asset Updated Successfully')
      setLoading(false)
    })
  }

  const handleAddFlashpoint = () => {
    const selectedIssues = issues.filter((val) => val.selected)

    setLoading(true)
    axios.post('api/v2/flashpoint/create_flashpoint', {
      domain_id: workspace.id,
      title: flashpointInput.title,
      description: flashpointInput.description,
      triggers: flashpointInput.triggers,
      status: flashpointInput.status,
      primary_manifestation: flashpointInput.primaryManifestation,
      ongoing: flashpointInput.ongoing === 'Yes',
      comments: flashpointInput.comments,
      primary_stakeholders: flashpointInput.primaryStakeholders.map(({ value }) => value),
      secondary_stakeholders: flashpointInput.secondaryStakeholders.map(({ value }) => value),
      tertiary_stakeholders: flashpointInput.tertiaryStakeholders.map(({ value }) => value),
      manifestations: flashpointInput.additionalManifestations.filter((val) => val !== ''),
      issues: selectedIssues.map(({ id }) => id),
      community: flashpointInput.relevantAreas.map(({ value }) => value),
      assets: [selectedAsset.id],
    }).then(({ data }) => {
      if (data.message === 'you have not created a flashpoint.') {
        console.error(data.message)
        return
      }

      const stakeholdersPrimary = stakeholders.filter(({ id }) => flashpointInput.primaryStakeholders.find((val) => val.value === id))
      const stakeholdersSecondary = stakeholders.filter(({ id }) => flashpointInput.secondaryStakeholders.find((val) => val.value === id))
      const stakeholdersTertiary = stakeholders.filter(({ id }) => flashpointInput.tertiaryStakeholders.find((val) => val.value === id))

      const newFlashpoint : Flashpoint = {
        id: data.flashpoint.id,
        title: flashpointInput.title,
        description: flashpointInput.description,
        triggers: flashpointInput.triggers,
        status: flashpointInput.status as FlashpointStatus,
        primaryManifestation: flashpointInput.primaryManifestation,
        additionalManifestation: flashpointInput.additionalManifestations.map((val, index) => ({ id: index, name: val })),
        ongoing: (flashpointInput.ongoing === 'Yes'),
        issues: selectedIssues,
        primary_groups: stakeholdersPrimary,
        secondary_groups: stakeholdersSecondary,
        tertiary_groups: stakeholdersTertiary,
        flashpoint_groups: [...stakeholdersPrimary, ...stakeholdersSecondary, ...stakeholdersTertiary],
        relevant_areas: input.relevantAreas.map(({ value, label }) => ({ id: value, name: label })),
        comments: input.comments,
      }
      setSubmittedMessage('Flashpoint submitted succesfully')
    }).catch(() => {
      console.error('Flashpoint Error - submission failed')
    }).finally(() => {
      setLoading(false)
      setView('Flashpoints')
    })
  }

  const handleAddNote = () => {
    setLoading(true)
    axios.post('/api/v1/asset/add_note', {
      domain_id: workspace.id,
      subject,
      asset_id: selectedAsset.id,
      content,
    }).then((response) => {
      // Assuming the response contains the newly created note's ID
      const { id } = response.data // Extract the ID from the response
      // Create a new note object with the ID and other details
      const newNote = {
        id, // Use the ID from the response
        subject,
        content,
        created_at: new Date().toISOString(), // Or any other fields you want to set
        updated_at: new Date().toISOString(), // Same as above
        user_id: user.user_id,
      }
      // Update the selectedAsset.notes with the new note
      setSelectedAsset((prevState: AssetList) => ({...prevState, notes: [...prevState.notes, newNote]}))
      setEditing(false)
      setSubmittedMessage('Asset Note Created Successfully')
      setLoading(false)
      setView('Notes')
    }).catch((error) => {
      console.error('Error adding note:', error)
      setLoading(false)
    })
  }

  const getAlertLabel = (value) => {
    const alertOption = alertOptions.find((option) => option.value === value)
    return alertOption ? alertOption.label : 'Unknown'
  }

  const getStatusLabel = (value) => {
    const alertOption = flashStatusOptions.find((option) => option.key === value)
    return alertOption ? alertOption.label : 'Unknown'
  }

  const getAlertDefinition = (value) => {
    const alertOption = alertOptions.find((option) => option.value === value)
    return alertOption ? alertOption.definition : 'Unknown'
  }

  const getStatusDefinition = (value) => {
    const alertOption = flashStatusOptions.find((option) => option.key === value)
    return alertOption ? alertOption.definition : 'Unknown'
  }

  const selectCause = (index: number) => {
    const copy = issues.slice()
    copy.splice(index, 1, { ...copy[index], selected: !copy[index].selected })

    setIssues(copy)
  }

  const getAlertStyle = (value) => {
    switch (value) {
      case 1:
        return { backgroundColor: '#14C105', color: 'white' }
      case 2:
        return { backgroundColor: '#349DFF', color: 'white' }
      case 3:
        return { backgroundColor: '#FFE500', color: 'black' }
      case 4:
        return { backgroundColor: '#FF8A00', color: 'white' }
      case 5:
        return { backgroundColor: '#FF8A00', color: 'white' }
      default:
        return { backgroundColor: 'white', color: 'black' }
    }
  }

  
  const getStatusStyle = (value) => {
    switch (value) {
      case 'low':
        return { backgroundColor: '#14C105', color: 'white' }
      case 'guarded':
        return { backgroundColor: '#349DFF', color: 'white' }
      case 'elevated':
        return { backgroundColor: '#FFE500', color: 'black' }
      case 'high':
        return { backgroundColor: '#FF8A00', color: 'white' }
      case 'severe':
        return { backgroundColor: '#FF8A00', color: 'white' }
      default:
        return { backgroundColor: 'white', color: 'black' }
    }
  }

  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1)
  }

  /* Add measure */
  const handleDropAdd = (e) => {
    /* Get measure name */
    const measure = JSON.parse(e.dataTransfer.getData('measure'))

    if (input?.existingMeasures.find((val) => val.id === measure.id)) return
    const copy = input?.existingMeasures.slice()
    copy.push(measure)

    if (editing && Object.keys(input?.removeNew).find((val) => val === measure.id)) {
      setInput({ ...input, removeNew: { ...input?.removeNew, [measure.id]: true }, existingMeasures: copy })
      return
    }

    if (editing && Object.keys(input?.removeExisting).find((val) => val === measure.id)) {
      setInput({ ...input, removeExisting: { ...input?.removeExisting, [measure.id]: true }, existingMeasures: copy })
      return
    }
    setInput({ ...input, existingMeasures: copy })
  }

  /* Remove measure */
  const handleDropRemove = (e) => {
    /* Get measure name */
    const measure = JSON.parse(e.dataTransfer.getData('measure'))

    const index = input?.existingMeasures.findIndex((val) => val.id === measure.id)
    if (index < 0) return

    const copy = input?.existingMeasures.slice()
    copy.splice(index, 1)

    if (editing && Object.keys(input?.removeNew).find((val) => val === measure.id)) {
      setInput({ ...input, removeNew: { ...input?.removeNew, [measure.id]: false }, existingMeasures: copy })
      return
    }

    if (editing && Object.keys(input?.removeExisting).find((val) => val === measure.id)) {
      setInput({ ...input, removeExisting: { ...input.removeExisting, [measure.id]: false }, existingMeasures: copy })
      return
    }
    setInput({ ...input, existingMeasures: copy })
  }

  useEffect(() => {
    if (selectedAsset.county_ids && selectedAsset.county_ids.length > 0) {
      // Find the counties based on county_ids
      const counties = regions.flatMap((region) => region.counties).filter((c) => selectedAsset.county_ids.includes(c.id))
      if (counties.length > 0) {
        // Find the regions based on region_id from the counties
        const regionsSet = new Set(counties.map((county) => county.region_id))
        const selectedRegions = regions.filter((region) => regionsSet.has(region.id))

        // Set the selected regions and counties
        setSelectedRegion(selectedRegions.map((region) => region.id.toString()))
        setCounties(counties)
        setSelectedCounty(counties.map((county) => county.id.toString()))
      }
    }
  }, [selectedAsset.county_ids, regions])

  const handleRegionChange = (selected) => {
    const regionId = selected.value
    setSelectedRegion(selected)
    const selectedRegion = regions.find((region) => region.id === parseInt(regionId))
    setCounties(selectedRegion ? selectedRegion.counties : [])
  }

  const countyRegionMap = new Map()
  regions.forEach((region) => {
    region.counties.forEach((county) => {
      countyRegionMap.set(county.id, { countyName: county.name, regionName: region.name })
    })
  })

  const moveToNext = () => {
    if ((!edit && question < 13) || (edit && question < 16)) setQuestion(question + 1)
  }

  const closeBox = () => {
    setView('Risk Register')
    setQuestion(0)
    setEdit(false)
    setRiskInput({ existingMeasures: selectedAsset.control_measures, newMeasures: [] })
  }

  const getRiskInput = (risk: any) : any => {
    const dropdowns = ['inherentOperations', 'inherentPeople', 'inherentReputation', 'inherentProperty', 'inherentVulnerability',
      'intent', 'capability', 'riskEvent', 'residualOperations', 'residualPeople', 'residualProperty', 'residualVulnerability']
    const optionValues = () => Object.fromEntries(dropdowns.map((key) => ([key, { value: risk[key], label: risk[key] }])))
    if (risk.mitigations) {
      return ({
        ...risk,
        ...optionValues(),
        removeExisting: Object.fromEntries(risk.existingMeasures.map((measure) => [measure.id, false])),
        removeNew: Object.fromEntries(risk.newMeasures.map((measure) => [measure.id, false])),
      })
    }
    return ({
      ...risk,
      ...optionValues(),
    })
  }

  // eslint-disable-next-line @typescript-eslint/no-shadow
  const defaultInput = (selectedRisk: any) => selectedRisk && getRiskInput({
    ...selectedRisk,
    inherentOperations: selectedRisk.inherentImpactCategories.operations,
    inherentPeople: selectedRisk.inherentImpactCategories.people,
    inherentProperty: selectedRisk.inherentImpactCategories.property,
    residualOperations: selectedRisk.residualImpactCategories.operations,
    residualPeople: selectedRisk.residualImpactCategories.people,
    residualProperty: selectedRisk.residualImpactCategories.property,
    riskEvent: selectedRisk.riskEvent,
  })

  const [riskInput, setRiskInput] = useState<any>({ existingMeasures: selectedAsset.control_measures, newMeasures: [] })

  useEffect(() => {
    if (!edit || defaultInput.mitigations) {
      // create assessment start metric
      try {
        apiHook.createRiskMetric('', workspace.id)
      } catch (e) {
        console.debug(e)
      }
      return
    }
    fetchMitigations(focusedRisk, selectedAsset).then(({
      existingMeasures, newMeasures,
    }) => {
      setRiskInput({
        ...riskInput,
        existingMeasures: [],
        removeExisting: Object.fromEntries(existingMeasures.map((measure) => [measure.id, false])),
        newMeasures,
        removeNew: Object.fromEntries(newMeasures.map((measure) => [measure.id, false])),
      })
    })
  }, [])

  const formatInputs = () => ({
    inherentVulnerability: riskInput.inherentVulnerability.value,
    inherentImpactCategories: {
      people: riskInput.inherentPeople.value,
      operations: riskInput.inherentOperations.value,
      property: riskInput.inherentProperty.value,
    },
    intent: riskInput.intent.value,
    mitigations: true,
    owner: { ...user },
    threatRating: riskInput.inherentThreatRating,
    riskRating: riskInput.inherentRisk,
    residualRisk: riskInput.residualRisk,
    residualThreatLikelihood: getLikelihoodCategory(riskInput.residualThreatLikelihood),
    inherentThreatLikelihood: getLikelihoodCategory(riskInput.inherentThreatLikelihood),
    impact: riskInput.inherentImpactRating,
    residualImpact: riskInput.residualImpactRating,
    capability: riskInput.capability.value,
    riskEvent: riskInput.riskEvent.value,
    residualImpactCategories: {
      people: riskInput.residualPeople.value,
      operations: riskInput.residualOperations.value,
      property: riskInput.residualProperty.value,
    },
    residualVulnerability: riskInput.residualVulnerability.value,
    newMeasures: riskInput.newMeasures,
    existingMeasures: riskInput.existingMeasures,
    updated: moment().format('DD/MM/YY'),
    visibleId: selectedAsset.id * 100 + (fetchedRisks?.length ?? 0) + 1,
  })

  const handleReview = (risk: RiskAssessment) : void => {
    dispatchRisk({ type: FocusedActionKind.CHOOSE, chosenRisk: risk })
    setSelectedRisk(risk)
    setView('View Risk')
    setEdit(true)
    const currentRisk = defaultInput(risk)
    setRiskInput({
      ...currentRisk,
      removeExisting: Object.fromEntries(selectedAsset.control_measures.map((measure) => [measure.id, false])),
      removeNew: Object.fromEntries(risk.newMeasures.map((measure) => [measure.id, false])),
    })
    setQuestion(1)
    // create review started metrics
    apiHook.createRiskMetric('edit', selectedAsset.id)
  }

  const Header = (
    <IonRow className='ion-justify-content-between'>
      <SettingField style={{ width: 'auto', display: 'flex', alignItems: 'center' }}>
        <h4 style={{ margin: '0' }}>Risk {(edit) ? 'Review' : 'Assessment'} - { (riskInput?.riskEvent) ? riskInput?.riskEvent?.value : '' } </h4>
        <p style={{ margin: '0 0 0 10px' }}>{question} of { (edit) ? '13' : '12' }</p>
      </SettingField>
      <SimpleButton onClick={() => closeBox()}>Close X</SimpleButton>
    </IonRow>
  )

  if (question === 1) {
    return (
      <RiskSelection
        input={riskInput}
        setInput={setRiskInput}
        users={users}
        onClose={closeBox}
        edit={edit}
        next={moveToNext}
        riskEvents={riskEvents}
      >
        <IonRow className='ion-justify-content-between'>
          <SettingField style={{ width: 'auto', display: 'flex', alignItems: 'center' }}>
            <h4 style={{ margin: '0' }}>Risk {(edit) ? 'Review' : 'Assessment'}</h4>
            <p style={{ margin: '0 0 0 10px' }}>{question} of { (edit) ? '13' : '12' }</p>
          </SettingField>
          <SimpleButton onClick={() => closeBox()}>Close X</SimpleButton>
        </IonRow>
      </RiskSelection>
    )
  }

  if ((!edit && question === 2)) {
    return (
      <SummaryExisting
        input={riskInput}
        onClose={() => setQuestion(question - 1)}
        next={moveToNext}
      >
        {
          Header
        }
      </SummaryExisting>
    )
  }

  if ((!edit && question === 3) || (edit && question === 2)) {
    return (
      <InherentThread
        input={riskInput}
        setInput={setRiskInput}
        onClose={() => setQuestion(question - 1)}
        next={moveToNext}
        edit={edit}
      >
        {
          Header
        }
      </InherentThread>
    )
  }

  if ((!edit && question === 4) || (edit && question === 3)) {
    return (
      <InherentVulnerability
        input={riskInput}
        setInput={setRiskInput}
        vulnerability={vulnerability}
        onClose={() => setQuestion(question - 1)}
        next={moveToNext}
        edit={edit}
        getCategory={getLikelihoodCategory}
        getNumericalValue={getNumericalValue}
      >
        {
          Header
        }
      </InherentVulnerability>
    )
  }

  if ((!edit && question === 5) || (edit && question === 4)) {
    return (
      <InherentImpact
        input={riskInput}
        setInput={setRiskInput}
        vulnerability={vulnerability}
        onClose={() => setQuestion(question - 1)}
        next={moveToNext}
        people={people}
        property={property}
        operations={operations}
        edit={edit}
      >
        {
          Header
        }
      </InherentImpact>
    )
  }

  if ((!edit && question === 6) || (edit && question === 5)) {
    const impacts = [riskInput.inherentOperations.value, riskInput.inherentPeople.value, riskInput.inherentProperty.value]
    const inherentImpactRating = getImpactRating(impacts)
    const inherentRisk = computeRiskRating(riskInput.inherentThreatLikelihood, impacts)

    return (
      <Summary
        onClose={() => setQuestion(question - 1)}
        next={moveToNext}
        message='The following is a summary of the Inherent Risk to the current Asset based on your assessments.'
        title='Inherent Risk Assessment - Summary'
        input={riskInput}
        inherent
        measures={{
          risk: inherentRisk, impactRating: getImpactCategory(inherentImpactRating), threatLikelihood: riskInput.inherentThreatLikelihood,
        }}
        onCreate={() => setRiskInput({
          ...riskInput,
          inherentRisk,
          inherentImpactRating: getImpactCategory(inherentImpactRating),
        })}
        getLikelihoodCategory={getLikelihoodCategory}
      >
        {
          Header
        }
      </Summary>
    )
  }

  if (edit && question === 6) {
    return (
      <RemoveNewMeasures
        input={riskInput}
        onClose={() => setQuestion(question - 1)}
        next={moveToNext}
        setInput={setRiskInput}
        measures={rawMeasures}
      >
        {
          Header
        }
      </RemoveNewMeasures>
    )
  }

  if (edit && question === 7) {
    return (
      <RemoveExistingMeasures
        input={riskInput}
        onClose={() => setQuestion(question - 1)}
        next={moveToNext}
        setInput={setRiskInput}
        measures={selectedAsset.control_measures}
      >
        {
          Header
        }
      </RemoveExistingMeasures>
    )
  }

  if (question === 7) {
    return (
      <NewMeasures
        input={riskInput}
        setInput={setRiskInput}
        onClose={() => setQuestion(question - 1)}
        next={moveToNext}
        measures={rawMeasures}
        categories={categories}
        edit={edit}
      >
        {
          Header
        }
      </NewMeasures>
    )
  }

  if (edit && question === 8) {
    return (
      <NewMeasures
        input={riskInput}
        setInput={setRiskInput}
        onClose={() => setQuestion(question - 1)}
        next={moveToNext}
        measures={rawMeasures}
        categories={categories}
        edit={edit}
      >
        {
          Header
        }
      </NewMeasures>
    )
  }

  if (edit && question === 9) {
    return (
      <MeasureSummary
        onClose={() => setQuestion(question - 1)}
        next={moveToNext}
        input={riskInput}
      >
        {
          Header
        }
      </MeasureSummary>
    )
  }

  if (question === 8) {
    return (
      <MeasureSummary
        onClose={() => setQuestion(question - 1)}
        next={moveToNext}
        input={riskInput}
      >
        {
          Header
        }
      </MeasureSummary>
    )
  }

  if (edit && question === 10) {
    return (
      <ResidualVulnerability
        input={riskInput}
        setInput={setRiskInput}
        vulnerability={vulnerability}
        onClose={() => setQuestion(question - 1)}
        next={moveToNext}
        edit={edit}
        getCategory={getLikelihoodCategory}
        getNumericalValue={getNumericalValue}
      >
        {
          Header
        }
      </ResidualVulnerability>
    )
  }

  if (question === 9) {
    return (
      <ResidualVulnerability
        input={riskInput}
        setInput={setRiskInput}
        vulnerability={vulnerability}
        onClose={() => setQuestion(question - 1)}
        next={moveToNext}
        edit={edit}
        getCategory={getLikelihoodCategory}
        getNumericalValue={getNumericalValue}
      >
        {
          Header
        }
      </ResidualVulnerability>
    )
  }

  if (edit && question === 11) {
    return (
      <ResidualImpact
        input={riskInput}
        setInput={setRiskInput}
        onClose={() => setQuestion(question - 1)}
        next={moveToNext}
        people={people}
        property={property}
        operations={operations}
      >
        {
          Header
        }
      </ResidualImpact>
    )
  }

  if (question === 10) {
    return (
      <ResidualImpact
        input={riskInput}
        setInput={setRiskInput}
        onClose={() => setQuestion(question - 1)}
        next={moveToNext}
        people={people}
        property={property}
        operations={operations}
      >
        {
          Header
        }
      </ResidualImpact>
    )
  }

  if (edit && question === 12) {
    const impacts = [riskInput.residualOperations.value, riskInput.residualPeople.value, riskInput.residualProperty.value]
    const residualImpactRating = getImpactRating(impacts)
    const residualRisk = computeRiskRating(riskInput.residualThreatLikelihood, impacts)

    return (
      <Summary
        onClose={() => setQuestion(question - 1)}
        next={moveToNext}
        message='The following is a summary of the Residual Risk to the current Asset based on your assessments.'
        title='Residual Risk Assessment - Summary'
        measures={{
          risk: residualRisk, impactRating: getImpactCategory(residualImpactRating), threatLikelihood: riskInput.residualThreatLikelihood,
        }}
        onCreate={() => setRiskInput({
          ...riskInput, residualImpactRating: getImpactCategory(residualImpactRating), residualRisk,
        })}
        getLikelihoodCategory={getLikelihoodCategory}
        input={riskInput}
      >
        {
          Header
        }
      </Summary>
    )
  }

  if (question === 11) {
    const impacts = [riskInput.residualOperations.value, riskInput.residualPeople.value, riskInput.residualProperty.value]
    const residualImpactRating = getImpactRating(impacts)
    const residualRisk = computeRiskRating(riskInput.residualThreatLikelihood, impacts)

    return (
      <Summary
        onClose={() => setQuestion(question - 1)}
        next={moveToNext}
        message='The following is a summary of the Residual Risk to the current Asset based on your assessments.'
        title='Residual Risk Assessment - Summary'
        measures={{
          risk: residualRisk, impactRating: getImpactCategory(residualImpactRating), threatLikelihood: riskInput.residualThreatLikelihood,
        }}
        onCreate={() => setRiskInput({
          ...riskInput, residualImpactRating: getImpactCategory(residualImpactRating), residualRisk,
        })}
        getLikelihoodCategory={getLikelihoodCategory}
        input={riskInput}
      >
        {
          Header
        }
      </Summary>
    )
  }

  const approvedIndicators = selectedAsset.alert_state_histories
    .filter((state) => state.status === 'Approved') // filter for approved states
    .flatMap(state => state.alert_indicators || []) // extract and flatten all alert indicators

  const [groupedIndicators, setGroupedIndicators] = useState(() => {
    return approvedIndicators.reduce((acc, indicator) => {
      acc[indicator.category] = acc[indicator.category] || []
      acc[indicator.category].push(indicator)
      return acc
    }, {})
  })

  const selectedIndicatorCategories = Object.keys(groupedIndicators)
  const indicatorRows = []
  for (let i = 0; i < selectedIndicatorCategories.length; i += 3) {
    indicatorRows.push(selectedIndicatorCategories.slice(i, i + 3))
  }

  const handleSelectRisk = (val) => {
    setSelectedRisk(val)
    setView('View Risk')

    const exist = selectedAsset.control_measures.reduce((acc, measure) => {
      acc[measure.category] = acc[measure.category] || []
      acc[measure.category].push(measure)
      return acc
    }, {})
    const newmeas = val.newMeasures.reduce((acc, measure) => {
      acc[measure.category] = acc[measure.category] || []
      acc[measure.category].push(measure)
      return acc
    }, {})
    setExistingGroupedMeasures(exist)
    setNewGroupedMeasures(newmeas)
    setSelectedNewCategories(Object.keys(newmeas))
    setSelectedExistingCategories(Object.keys(exist))
  }

  const pushRiskAssessment = (risk: RiskAssessment, asset: Asset) : Promise<void> => {
    /* Prepare backend request data */
    const requestData = {
      ...formatRequestRisk(asset, risk),
      existing: risk.existingMeasures.map(({ control_measure }) => control_measure),
      new: risk.newMeasures.map(({ control_measure }) => control_measure),
    }

    setLoading(true)
    return apiHook.createAssetRisk(requestData).then(({ id }) => {
      /* Push new risk assessment to asset */
      setFetchedRisks((prev) => [...prev, risk])
      setLoading(false)
    })
  }

  const viewHistory = (history: any) => {
    setSelectedAlert(history)
    setViewAlertPopup(true)
  }

    const reviewHistory = (history: any) => {
    setSelectedAlert(history)
    setReviewAlertPopup(true)
  }

  const updateRisk = (risk: RiskAssessment, asset: Asset, formattedChanges: any) : Promise<void> => {
    /* Prepare backend request data */
    const existingComparison = compareMeasures(selectedRisk.existingMeasures, formattedChanges.existingMeasures)

    const newComparison = compareMeasures(selectedRisk.newMeasures, formattedChanges.newMeasures)
    const requestData = {
      ...formatRequestRisk(asset, risk),
      existing_add: existingComparison.toAdd.map(measure => measure.control_measure),
      existing_remove: existingComparison.toRemove.map((measure) => measure.control_measure),
      new_add: newComparison.toAdd.map(measure => measure.control_measure),
      new_remove: newComparison.toRemove.map((measure) => measure.control_measure),
      id: formattedChanges.id,
    }
    setSelectedAsset({ ...selectedAsset, control_measures: formattedChanges.existingMeasures })
    setGroupedMeasures(formattedChanges.existingMeasures.reduce((acc, measure) => {
      acc[measure.category] = acc[measure.category] || []
      acc[measure.category].push(measure)
      return acc
    }, {}))

    setLoading(true)

    return apiHook.editAssetRisk(requestData).then(() => {
      const impacts = [formattedChanges.inherentOperations.value, formattedChanges.inherentPeople.value, formattedChanges.inherentProperty.value]
      const inherentImpactRating = getImpactRating(impacts)
      const inherentRisk = computeRiskRating(formattedChanges.inherentThreatLikelihood, impacts)

      const resimpacts = [formattedChanges.residualOperations.value, formattedChanges.residualPeople.value, formattedChanges.residualProperty.value]
      const residualImpactRating = getImpactRating(resimpacts)
      const residualRisk = computeRiskRating(formattedChanges.residualThreatLikelihood, resimpacts)

      const inherentThreatRating = computeThreatRating(formattedChanges.intent.value, formattedChanges.capability.value)

      const inherentThreatLikelihood = Math.ceil((getNumericalValue(formattedChanges.inherentThreatRating) * getNumericalValue(formattedChanges.inherentVulnerability.value)) / 5)
      const residualThreatLikelihood = Math.ceil((getNumericalValue(formattedChanges.threatRating) * getNumericalValue(formattedChanges.residualVulnerability.value)) / 5)
      setFetchedRisks((prevRisks) => prevRisks.map((risk) => (risk.id === requestData.id
        ? {
          ...risk,
          ...formattedChanges,
          // Ensure objects like { value, label } become strings
          intent: formattedChanges.intent?.value || risk.intent,
          capability: formattedChanges.capability?.value || risk.capability,
          riskEvent: formattedChanges.riskEvent?.value || risk.riskEvent,
          inherentVulnerability: formattedChanges.inherentVulnerability?.value || risk.inherentVulnerability,
          residualVulnerability: formattedChanges.residualVulnerability?.value || risk.residualVulnerability,
          riskRating: inherentRisk,
          residualImpact: getImpactCategory(residualImpactRating),
          residualRisk,
          threatRating: inherentThreatRating,
          residualThreatLikelihood: getLikelihoodCategory(residualThreatLikelihood),
          inherentThreatLikelihood: getLikelihoodCategory(inherentThreatLikelihood),
          impact: getImpactCategory(inherentImpactRating),
        }
        : risk)))
      setLoading(false)
    })
  }

  const handleSubmit = (repeat) => {
    const formattedSubmitted = formatInputs()
    if (edit) {
      updateRisk(formattedSubmitted, selectedAsset, riskInput).then(() => {
        closeBox()
      })
    }
    if (repeat) {
      pushRiskAssessment(formattedSubmitted, selectedAsset).then(() => {
        setQuestion(1)
        setRiskInput({ existingMeasures: selectedAsset.control_measures, newMeasures: [] })
      })
    }
    if (!edit) {
      pushRiskAssessment(formattedSubmitted, selectedAsset).then(() => {
        closeBox()
      })
    }
  }

  if (edit && question === 13) {
    return (
      <Review
        input={riskInput}
        onClose={() => setQuestion(question - 1)}
        onSubmit={() => handleSubmit(false)}
        edit={edit}
        onSubmitAdd={() => handleSubmit(true)}
      >
        {
          Header
        }
      </Review>
    )
  }

  if (question === 12) {
    return (
      <Review
        input={riskInput}
        onClose={() => setQuestion(question - 1)}
        onSubmit={() => handleSubmit(false)}
        edit={edit}
        onSubmitAdd={() => handleSubmit(true)}
      >
        {
          Header
        }
      </Review>
    )
  }

  switch (view) {
    case 'Home':
      return (
        <>
          <ObscureBackground style={{ zIndex: 20 }} />
          <OverlayContainer style={{ zIndex: 25, width: '90%', height: '90%', borderRadius: '1em' }} className='terrain-add-popup'>
            <IonRow style={{ paddingTop: '10px', margin: '0', padding: '0' }}>
              <IonCol style={{ margin: '0', padding: '0' }}>
                <TabOption
                  style={{
                    marginLeft: '2px', marginTop: '10px', marginBottom: '0px', paddingBottom: '0px', color: '#8E151F', fontWeight: 'bold', fontSize: '16',
                  }}
                  onClick={() => {
                    setView('Home')
                  }}
                >Overview
                </TabOption>
                <TabOption
                  style={{
                    marginLeft: '2px', marginTop: '10px', marginBottom: '0px', paddingBottom: '0px', color: '#28464B', fontWeight: 'bold', fontSize: '16',
                  }}
                  onClick={() => {
                    setView('Notes')
                  }}
                >Notes
                </TabOption>
                <TabOption
                  style={{
                    marginLeft: '2px', marginTop: '10px', marginBottom: '0px', paddingBottom: '0px', color: '#28464B', fontWeight: 'bold', fontSize: '16',
                  }}
                  onClick={() => {
                    setView('Threat')
                  }}
                >Alert State
                </TabOption>
                <TabOption
                  style={{
                    marginLeft: '2px', marginTop: '10px', marginBottom: '0px', paddingBottom: '0px', color: '#28464B', fontWeight: 'bold', fontSize: '16',
                  }}
                  onClick={() => {
                    setView('Flashpoints')
                  }}
                >Flashpoints
                </TabOption>
                <TabOption
                  style={{
                    marginLeft: '2px', marginTop: '10px', marginBottom: '0px', paddingBottom: '0px', color: '#28464B', fontWeight: 'bold', fontSize: '16',
                  }}
                  onClick={() => {
                    setView('Control Measures')
                  }}
                >Control Measures
                </TabOption>
                <TabOption
                  style={{
                    marginLeft: '2px', marginTop: '10px', marginBottom: '0px', paddingBottom: '0px', color: '#28464B', fontWeight: 'bold', fontSize: '16',
                  }}
                  onClick={() => {
                    setView('Risk Register')
                  }}
                >Risk Register
                </TabOption>
              </IonCol>
            </IonRow>
            <IonRow className='ion-justify-content-end'>
              <SimpleButton onClick={() => { setShowSelectedAsset(false); setEditing(false) }}>Close X</SimpleButton>
            </IonRow>
            {editing ? (
              <>
                <IonRow className='ion-justify-content-between ion-align-items-center'>
                  <input style={{ padding: '10px 0', marginLeft: '2em', marginBottom: '4px' }} placeholder='Asset Name' type='text' value={name} onChange={(e) => setName(e.target.value)} />
                </IonRow>
                <div style={{ height: '67%', overflow: 'auto' }}>
                  <IonRow style={{ marginLeft: '2em' }}>
                    <IonCol>
                      <h5 style={{ color: '#326771', fontSize: 16, marginBottom: '4px' }}>Asset Type</h5>
                      <Select
                        placeholder='Select Asset Type'
                        name='alert'
                        id='select-alert-container'
                        className='select-container'
                          // eslint-disable-next-line no-undef
                        menuPortalTarget={document.body}
                        options={assetTypes.map((type) => ({ value: type, label: type }))}
                        onChange={(selected) => setType(selected)}
                        value={type}
                      />
                    </IonCol>
                    <IonCol>
                      <h5 style={{ color: '#326771', fontSize: 16, marginBottom: '4px' }}>Region/State</h5>
                      <CreatableSelect
                        placeholder='Select Region'
                        name='colors'
                        className='select-container'
                        id='region'
                          // eslint-disable-next-line no-undef
                        menuPortalTarget={document.body}
                        options={regions.map(({ id, name }) => ({ label: name, value: id }))}
                        value={selectedRegion}
                        onChange={(selected) => handleRegionChange(selected)}
                      />
                    </IonCol>
                    <IonCol>
                      <h5 style={{ color: '#326771', fontSize: 16, marginBottom: '4px' }}>County</h5>
                      <CreatableSelect
                        isMulti
                        placeholder='Select County'
                        name='colors'
                        className='select-container'
                        id='county'
                          // eslint-disable-next-line no-undef
                        menuPortalTarget={document.body}
                        options={counties.map(({ id, name }) => ({ label: name, value: id }))}
                        value={selectedCounty}
                        onChange={(selected) => setSelectedCounty(selected)}
                      />
                    </IonCol>
                  </IonRow>
                  <IonRow style={{ marginLeft: '2em', marginTop: '2em' }}>
                    <IonCol>
                      <h5 style={{ color: '#326771', fontSize: 16, marginBottom: '4px' }}>Parent Asset</h5>
                      <Select
                        placeholder='Select Parent Asset'
                        name='parent'
                        id='select-parent-container'
                        className='select-container'
                          // eslint-disable-next-line no-undef
                        menuPortalTarget={document.body}
                        options={assets.map((asset) => ({ value: asset.id, label: asset.name }))}
                        onChange={(selected) => setParent(selected)}
                        style={{ width: '50%' }}
                        value={parent}
                      />
                    </IonCol>
                    <IonCol>
                      <h5 style={{ color: '#326771', fontSize: 16, marginBottom: '4px' }}>Sub Assets</h5>
                      <Select
                        isMulti
                        placeholder='Select Sub Assets'
                        name='subasset'
                        id='select-subasset-container'
                        className='select-container'
                          // eslint-disable-next-line no-undef
                        menuPortalTarget={document.body}
                        options={assets.map((asset) => ({ label: asset.name, value: asset.id }))}
                        onChange={(selected) => setSubs(selected)}
                        style={{ width: '50%' }}
                        value={subs}
                      />
                    </IonCol>
                    <IonCol>
                      <h5 style={{ color: '#326771', fontSize: 16, marginBottom: '4px' }}>Associated Assets</h5>
                      <Select
                        isMulti
                        placeholder='Select Associated Assets'
                        name='associated'
                        id='select-associated-container'
                        className='select-container'
                          // eslint-disable-next-line no-undef
                        menuPortalTarget={document.body}
                        options={assets.map((asset) => ({ label: asset.name, value: asset.id }))}
                        onChange={(selected) => setAssociated(selected)}
                        style={{ width: '50%' }}
                        value={associated}
                      />
                    </IonCol>
                  </IonRow>
                  <IonRow style={{ marginLeft: '2em', marginTop: '2em' }}>
                    <IonCol>
                      <h5 style={{ color: '#326771', fontSize: 16, marginBottom: '4px' }}>Communities</h5>
                      <Select
                        isMulti
                        placeholder='Select Communities'
                        name='associated'
                        id='select-associated-container'
                        className='select-container'
                          // eslint-disable-next-line no-undef
                        menuPortalTarget={document.body}
                        options={communities.map((comm) => ({ label: comm.name, value: comm.id }))}
                        onChange={(selected) => setSelectedComms(selected)}
                        style={{ width: '50%' }}
                        value={selectedComms}
                      />
                    </IonCol>
                  </IonRow>
                  <IonRow style={{ marginLeft: '2em', marginTop: '2em' }}>
                    <IonCol>
                      <h5 style={{ color: '#326771', fontSize: 16, marginBottom: '4px' }}>Description</h5>
                      <textarea
                        style={{ height: '5em', width: '100%' }}
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        placeholder='Enter description'
                      />
                    </IonCol>
                  </IonRow>
                </div>
                <IonRow className='ion-justify-content-end'>
                  <IonButton onClick={handleEdit} style={{ '--background': '#326771' }}>Save</IonButton>
                  <IonButton onClick={() => setEditing(false)} style={{ '--background': '#326771' }}>Cancel</IonButton>
                </IonRow>
              </>
            ) : (
              <>
                <IonRow className='ion-justify-content-between ion-align-items-center'>
                  <h5 style={{ marginLeft: '2em', fontSize: 16, color: '#326771' }}>{ name }</h5>
                </IonRow>
                <div style={{ height: '70%', overflow: 'auto' }}>
                  <IonRow style={{ marginLeft: '2em' }}>
                    <IonCol>
                      <h5 style={{ color: '#326771', fontSize: 16, marginBottom: '4px' }}>Asset Type</h5>
                      <p style={{ margin: 0, fontSize: 13, color: '#737475' }}>{ type.label }</p>
                    </IonCol>
                    <IonCol>
                      <h5 style={{ color: '#326771', fontSize: 16, marginBottom: '4px' }}>Region/State</h5>
                      <ul style={{ margin: 0, padding: 0, listStyleType: 'disc', paddingLeft: '20px' }}>
                        {selectedAsset.county_ids?.map((comm) => {
                          const countyInfo = countyRegionMap.get(comm)
                          return (
                            <li key={comm} style={{ fontSize: 13, color: '#737475' }}>
                              {countyInfo
                                ? `${countyInfo.regionName}`
                                : 'Unknown Region'}
                            </li>
                          )
                        })}
                      </ul>
                    </IonCol>
                    <IonCol>
                      <h5 style={{ color: '#326771', fontSize: 16, marginBottom: '4px' }}>County</h5>
                      <ul style={{ margin: 0, padding: 0, listStyleType: 'disc', paddingLeft: '20px' }}>
                        {selectedAsset.county_ids?.map((comm) => {
                          const countyInfo = countyRegionMap.get(comm)
                          return (
                            <li key={comm} style={{ fontSize: 13, color: '#737475' }}>
                              {countyInfo
                                ? `${countyInfo.countyName}`
                                : 'Unknown County '}
                            </li>
                          )
                        })}
                      </ul>
                    </IonCol>
                  </IonRow>
                  <IonRow style={{ marginLeft: '2em', marginTop: '2em' }}>
                    <IonCol>
                      <h5 style={{ color: '#326771', fontSize: 16, marginBottom: '4px' }}>Parent Asset</h5>
                      <p style={{ margin: 0, fontSize: 13, color: '#737475' }}>{ parent.label }</p>
                    </IonCol>
                    <IonCol>
                      <h5 style={{ color: '#326771', fontSize: 16, marginBottom: '4px' }}>Sub Assets</h5>
                      <ul style={{ margin: 0, padding: 0, listStyleType: 'disc', paddingLeft: '20px' }}>
                        {subs.map((sub, index) => {
                          const asset = assets.find((asset) => asset.id === sub.value)
                          return (
                            <li key={index} style={{ fontSize: 13, color: '#737475' }}>
                              {asset ? `${asset.name}, ${asset.asset_type}` : 'N/A'}
                            </li>
                          )
                        })}
                      </ul>
                    </IonCol>
                    <IonCol>
                      <h5 style={{ color: '#326771', fontSize: 16, marginBottom: '4px' }}>Associated Assets</h5>
                      <ul style={{ margin: 0, padding: 0, listStyleType: 'disc', paddingLeft: '20px' }}>
                        {associated.map((assoc, index) => {
                          const asset = assets.find((asset) => asset.id === assoc.value)
                          return (
                            <li key={index} style={{ fontSize: 13, color: '#737475' }}>
                              {asset ? `${asset.name}, ${asset.asset_type}` : 'N/A'}
                            </li>
                          )
                        })}
                      </ul>
                    </IonCol>
                  </IonRow>
                  <IonRow style={{ marginLeft: '2em', marginTop: '2em' }}>
                    <IonCol>
                      <h5 style={{ color: '#326771', fontSize: 16, marginBottom: '4px' }}>Communities</h5>
                      <ul>
                        {selectedAsset.comm_ids?.map((val) => {
                          const community = communities.find((comm) => comm.id === val)
                          return (
                            <li key={val} style={{ fontSize: 13, color: '#737475' }}>
                              {val.content}
                              {community ? community.name : 'N/A'}
                            </li>
                          )
                        })}
                      </ul>
                    </IonCol>
                  </IonRow>
                  <IonRow style={{ marginLeft: '2em', marginTop: '2em' }}>
                    <IonCol>
                      <h5 style={{ color: '#326771', fontSize: 16, marginBottom: '4px' }}>Description</h5>
                      <p style={{ margin: 0, fontSize: 13, color: '#737475' }}>{ description }</p>
                    </IonCol>
                  </IonRow>
                </div>
                <IonRow className='ion-justify-content-end'>
                  <IonButton onClick={() => setEditing(true)} style={{ '--background': '#326771' }}>Edit</IonButton>
                </IonRow>
              </>
            )}
          </OverlayContainer>
        </>
      )
    case 'Threat':
      return (
        <>
          <ObscureBackground style={{ zIndex: 20 }} />
          <OverlayContainer style={{ zIndex: 25, width: '90%', height: '90%', borderRadius: '1em' }} className='terrain-add-popup'>
            <IonRow style={{ paddingTop: '10px', margin: '0', padding: '0' }}>
              <IonCol style={{ margin: '0', padding: '0' }}>
                <TabOption
                  style={{
                    marginLeft: '2px', marginTop: '10px', marginBottom: '0px', paddingBottom: '0px', color: '#28464B', fontWeight: 'bold', fontSize: '16',
                  }}
                  onClick={() => {
                    setView('Home')
                  }}
                >Overview
                </TabOption>
                <TabOption
                  style={{
                    marginLeft: '2px', marginTop: '10px', marginBottom: '0px', paddingBottom: '0px', color: '#28464B', fontWeight: 'bold', fontSize: '16',
                  }}
                  onClick={() => {
                    setView('Notes')
                  }}
                >Notes
                </TabOption>
                <TabOption
                  style={{
                    marginLeft: '2px', marginTop: '10px', marginBottom: '0px', paddingBottom: '0px', color: '#8E151F', fontWeight: 'bold', fontSize: '16',
                  }}
                  onClick={() => {
                    setView('Threat')
                  }}
                >Alert State
                </TabOption>
                <TabOption
                  style={{
                    marginLeft: '2px', marginTop: '10px', marginBottom: '0px', paddingBottom: '0px', color: '#28464B', fontWeight: 'bold', fontSize: '16',
                  }}
                  onClick={() => {
                    setView('Flashpoints')
                  }}
                >Flashpoints
                </TabOption>
                <TabOption
                  style={{
                    marginLeft: '2px', marginTop: '10px', marginBottom: '0px', paddingBottom: '0px', color: '#28464B', fontWeight: 'bold', fontSize: '16',
                  }}
                  onClick={() => {
                    setView('Control Measures')
                  }}
                >Control Measures
                </TabOption>
                <TabOption
                  style={{
                    marginLeft: '2px', marginTop: '10px', marginBottom: '0px', paddingBottom: '0px', color: '#28464B', fontWeight: 'bold', fontSize: '16',
                  }}
                  onClick={() => {
                    setView('Risk Register')
                  }}
                >Risk Register
                </TabOption>
              </IonCol>
            </IonRow>
            <IonRow className='ion-justify-content-end'>
              <SimpleButton onClick={() => { setShowSelectedAsset(false); setEditing(false) }}>Close X</SimpleButton>
            </IonRow>
            {editing ? (
              // Render editing view
              <>
                <IonRow className='ion-justify-content-between ion-align-items-center'>
                  <h5 style={{ marginLeft: '2em', fontSize: 16, color: '#326771' }}>{ selectedAsset.name }</h5>
                </IonRow>
                <div style={{ height: '70%', overflow: 'auto' }}>
                  <IonRow style={{ marginLeft: '2em' }}>
                    <IonCol>
                      <h5 style={{ color: '#326771', fontSize: 16, marginBottom: '4px' }}>Review Date</h5>
                      <Datetime
                        dateFormat='DD/MM/YY'
                        inputProps={{
                          placeholder: 'Start Date',
                          readOnly: true,
                          style: { backgroundColor: 'white' },
                        }}
                        isValidDate={(current) => current.isAfter(moment())}
                        name='date'
                        value={moment(date).format('DD/MM/YY')}
                        onChange={(e) => setDate(e)}
                        timeFormat={false}
                      />
                    </IonCol>
                    <IonCol>
                      <h5 style={{ color: '#326771', fontSize: 16, marginBottom: '4px' }}>Owner</h5>
                      <Select
                        placeholder='Select user'
                        name='owner'
                        id='select-owner-container'
                        className='select-container'
                          // eslint-disable-next-line no-undef
                        menuPortalTarget={document.body}
                        options={users.map((user) => ({ value: user.id, label: `${user.first_name} ${user.final_name}` }))}
                        onChange={(selected) => setOwner(selected)}
                        style={{ width: '50%' }}
                        value={owner}
                      />
                    </IonCol>
                  </IonRow>
                  <IonRow style={{ marginLeft: '2em', marginTop: '0.8em' }}>
                    <IonCol>
                      <h5 style={{ color: '#326771', fontSize: 16, marginBottom: '4px' }}>Asset Alert State</h5>
                      <Select
                        placeholder='Select Alert State'
                        name='alert'
                        id='select-alert-container'
                        className='select-container'
                          // eslint-disable-next-line no-undef
                        menuPortalTarget={document.body}
                        options={alertOptions}
                        onChange={(selected) => setAlert(selected)}
                        value={alert}
                      />
                      <p style={{ margin: 0, fontSize: 13, color: '#737475' }}>{getAlertDefinition(alert?.value)}</p>
                    </IonCol>
                    <IonCol>
                    </IonCol>
                  </IonRow>
                  <IonRow style={{ marginLeft: '2em', marginTop: '0.8em' }}>
                    <IonCol>
                      <h5 style={{ color: '#326771', fontSize: 16, marginBottom: '4px' }}>Main Threat Factors</h5>
                      <CreatableSelect
                        isMulti
                        placeholder='Select Threat Factors'
                        name='colors'
                        className='select-container'
                        id='threat-factors'
                      // eslint-disable-next-line no-undef
                        menuPortalTarget={document.body}
                        options={incidentTypes.map((type) => ({ label: type, value: type }))}
                        value={factors}
                        onChange={(selected) => setFactors(selected)}
                      />
                    </IonCol>
                  </IonRow>
                  <IonRow style={{ marginLeft: '2em', marginTop: '0.8em' }}>
                    <IonCol>
                      <h5 style={{ color: '#326771', fontSize: 16, marginBottom: '4px' }}>Comment</h5>
                      <textarea
                        style={{ height: '5em', width: '100%' }}
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                        placeholder='Enter comment'
                      />
                    </IonCol>
                  </IonRow>
                </div>
                <IonRow className='ion-justify-content-end'>
                  <IonButton onClick={handleEdit} style={{ '--background': '#326771' }}>Save</IonButton>
                  <IonButton onClick={() => setEditing(false)} style={{ '--background': '#326771' }}>Cancel</IonButton>
                </IonRow>
              </>
            ) : (
              // Render view mode
              <>
                <IonRow className='ion-justify-content-between ion-align-items-center'>
                  <IonCol size='9'>
                    <div>
                      <h5 style={{ marginLeft: '2em', fontSize: 16, color: '#326771' }}>{ name }</h5>
                      <p style={{ marginLeft: '2em', fontSize: 13 }}>
                        <span style={{ ...getAlertStyle(selectedAsset.alert_state), padding: '4px 8px', borderRadius: '6px' }}>
                          {getAlertLabel(alert?.value)}
                        </span>
                      </p>
                    </div>
                  </IonCol>
                  <IonCol size='3'>
                    <div>
                      <h5 style={{ fontSize: 16, color: '#326771', marginBottom: '4px' }}>Review Date</h5>
                      <p style={{ margin: 0, fontSize: 13, color: '#737475' }}>{moment(date).format('DD/MM/YYYY')}</p>
                    </div>
                  </IonCol>
                </IonRow>

                <div style={{ height: '60%', overflow: 'auto' }}>
                  <IonRow style={{ marginLeft: '2em', marginTop: '0.8em' }}>
                    <IonCol size='9'>
                      <p style={{ margin: 0, fontSize: 13, color: '#737475' }}>{getAlertDefinition(alert?.value)}</p>
                    </IonCol>
                    <IonCol size='3'>
                      <h5 style={{ color: '#326771', fontSize: 16, marginBottom: '4px' }}>Owner</h5>
                      <p style={{ margin: 0, fontSize: 13, color: '#737475' }}>{ owner.label }</p>
                    </IonCol>
                  </IonRow>
                  <IonRow style={{ marginTop: '0.8em' }}>
                    <h5 style={{ marginLeft: '2em', color: '#326771', fontSize: 16, marginBottom: '4px' }}>Main Indicators</h5>
                      {indicatorRows.map((row, rowIndex) => (
                      <IonRow key={rowIndex} style={{ marginLeft: '2em', marginTop: rowIndex === 0 ? '0' : '2em', height: '40%' }}>
                        {row.map((category) => (
                          <IonCol key={category}>
                            <h5 style={{ color: '#4197A9', fontSize: 13, marginBottom: '4px' }}>{category}</h5>
                            {groupedIndicators[category].map((indicator) => (
                              <div key={indicator.id} style={{ marginBottom: '9px' }}>
                                <p style={{ margin: 0, fontSize: 13, color: '#737475' }}>
                                  {indicator.indicator}
                                </p>
                              </div>
                            ))}
                          </IonCol>
                        ))}
                        {row.length < 3 && [...Array(3 - row.length)].map((_, index) => (
                          <IonCol key={`empty-${index}`} />
                        ))}
                      </IonRow>
                    ))}
                  </IonRow>
                  <IonRow style={{ marginLeft: '2em', marginTop: '0.8em' }}>
                    <IonCol>
                      <h5 style={{ color: '#326771', fontSize: 16, marginBottom: '4px' }}>Comment</h5>
                      <p style={{ margin: 0, fontSize: 13, color: '#737475' }}>{comment}</p>
                    </IonCol>
                  </IonRow>
                  <div style={{ marginLeft:'2em', marginRight:'2em', overflow: 'auto', boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)' }}>

                    <IonRow style={{ padding: '10px' }} className='terrain-list-title ion-justify-content-between ion-align-items-center'>
                      <IonCol size='2'>
                        <h5 style={{ fontSize: 16, color: '#326771' }}>Date</h5>
                      </IonCol>
                      <IonCol size='2'>
                        <h5 style={{ fontSize: 16, color: '#326771' }}>Status</h5>
                      </IonCol>
                      <IonCol size='3'>
                        <h5 style={{ fontSize: 16, color: '#326771' }}>Alert State</h5>
                      </IonCol>
                      <IonCol size='2'>
                        <h5 style={{ fontSize: 16, color: '#326771' }}>Owner</h5>
                      </IonCol>
                      <IonCol size='2'>
                        <h5 style={{ fontSize: 16, color: '#326771' }}>Approver</h5>
                      </IonCol>
                      <IonCol size='1' />
                    </IonRow>
                    <div style={{ flex: 1, overflow: 'auto' }}>
                      {selectedAsset.alert_state_histories.map((val, index) => (
                        <IonRow
                          className='ion-justify-content-between terrain-register-row ion-align-items-center'
                          style={{ backgroundColor: getColor(index) }}
                          key={val.id}
                        >
                          <IonCol size='2' style={{ fontSize: '13px', color: '#737475' }}>{moment(val.submitted_at).format('DD/MM/YYYY')}</IonCol>
                          <IonCol size='2' style={{ fontSize: '13px', color: '#737475' }}>{capitalizeFirstLetter(val.status)}</IonCol>
                          <IonCol size='3' style={{ fontSize: '13px', color: '#737475' }}><span style={{ ...getAlertStyle(val.proposed_level), padding: '4px 8px', borderRadius: '6px' }}>{getAlertLabel(val?.proposed_level)}</span></IonCol>
                          <IonCol size='2' style={{ fontSize: '13px', color: '#737475' }}>{getNoteUser(val.user_id).label}</IonCol>
                          <IonCol size='2' style={{ fontSize: '13px', color: '#737475' }}>{getNoteUser(val.approved_by).label}</IonCol>
                          <IonCol size='1'>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                              {val.status === 'Pending' && user.user_id === val.approved_by && (
                                <BlueButton onClick={() => reviewHistory(val)}>
                                  <span style={{ fontSize: 13 }}>Review</span>
                                </BlueButton>
                              )}
                              <BlueButton onClick={() => viewHistory(val)}>
                                <span style={{ fontSize: 13 }}>View</span>
                              </BlueButton>
                            </div>
                          </IonCol>
                        </IonRow>
                      ))}
                      {selectedAsset.alert_state_histories.length === 0 && (
                        <p style={{ textAlign: 'center' }}>No Alert State History available</p>
                      )}
                    </div>
                  </div>
                </div>
                <IonRow className='ion-justify-content-end'>
                  <IonButton onClick={() => setShowAlertPopup(true)} style={{ '--background': '#326771' }}>Update</IonButton>
                </IonRow>
              </>
            )}
          </OverlayContainer>
          {showAlertPopup && (
            <>
              <AlertPopup
                onClose={() => setShowAlertPopup(false)}
                asset={selectedAsset}
                setShowAlertPopup={setShowAlertPopup}
                setSelectedAsset={setSelectedAsset}
              />
            </>
          )}
          {viewAlertPopup && (
            <>
              <ViewAlertPopup
                onClose={() => setViewAlertPopup(false)}
                asset={selectedAsset}
                setViewAlertPopup={setViewAlertPopup}
                selectedAlert={selectedAlert}
              />
            </>
          )}
          {reviewAlertPopup && (
            <>
              <ReviewAlertPopup
                onClose={() => setReviewAlertPopup(false)}
                asset={selectedAsset}
                setReviewAlertPopup={setReviewAlertPopup}
                selectedAlert={selectedAlert} 
                setSelectedAsset={setSelectedAsset}              
              />
            </>
          )}
        </>
      )
    case 'Notes':
      return (
        <>
          <ObscureBackground style={{ zIndex: 20 }} />
          <OverlayContainer style={{ zIndex: 25, width: '90%', height: '90%', borderRadius: '1em' }} className='terrain-add-popup'>
            <IonRow style={{ paddingTop: '10px', margin: '0', padding: '0' }}>
              <IonCol style={{ margin: '0', padding: '0' }}>
                <TabOption
                  style={{
                    marginLeft: '2px', marginTop: '10px', marginBottom: '0px', paddingBottom: '0px', color: '#28464B', fontWeight: 'bold', fontSize: '16',
                  }}
                  onClick={() => setView('Home')}
                >Overview
                </TabOption>
                <TabOption
                  style={{
                    marginLeft: '2px', marginTop: '10px', marginBottom: '0px', paddingBottom: '0px', color: '#8E151F', fontWeight: 'bold', fontSize: '16',
                  }}
                  onClick={() => setView('Notes')}
                >Notes
                </TabOption>
                <TabOption
                  style={{
                    marginLeft: '2px', marginTop: '10px', marginBottom: '0px', paddingBottom: '0px', color: '#28464B', fontWeight: 'bold', fontSize: '16',
                  }}
                  onClick={() => setView('Threat')}
                >Alert State
                </TabOption>
                <TabOption
                  style={{
                    marginLeft: '2px', marginTop: '10px', marginBottom: '0px', paddingBottom: '0px', color: '#28464B', fontWeight: 'bold', fontSize: '16',
                  }}
                  onClick={() => setView('Flashpoints')}
                >Flashpoints
                </TabOption>
                <TabOption
                  style={{
                    marginLeft: '2px', marginTop: '10px', marginBottom: '0px', paddingBottom: '0px', color: '#28464B', fontWeight: 'bold', fontSize: '16',
                  }}
                  onClick={() => setView('Control Measures')}
                >Control Measures
                </TabOption>
                <TabOption
                  style={{
                    marginLeft: '2px', marginTop: '10px', marginBottom: '0px', paddingBottom: '0px', color: '#28464B', fontWeight: 'bold', fontSize: '16',
                  }}
                  onClick={() => setView('Risk Register')}
                >Risk Register
                </TabOption>
              </IonCol>
            </IonRow>
            <IonRow className='ion-justify-content-end'>
              <SimpleButton onClick={() => { setShowSelectedAsset(false); setEditing(false); }}>Close X</SimpleButton>
            </IonRow>
            <>
              <div style={{ height: '75%', overflow: 'auto', boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)' }}>
                <IonRow style={{ padding: '10px' }} className='terrain-list-title ion-justify-content-between ion-align-items-center'>
                  <IonCol size='1'>
                    <h5 style={{ fontSize: 16, color: '#326771' }}>Date</h5>
                  </IonCol>
                  <IonCol size='1.5'>
                    <h5 style={{ fontSize: 16, color: '#326771' }}>Submitted</h5>
                  </IonCol>
                  <IonCol size='2'>
                    <h5 style={{ fontSize: 16, color: '#326771' }}>Subject</h5>
                  </IonCol>
                  <IonCol size='7'>
                    <h5 style={{ fontSize: 16, color: '#326771' }}>Content</h5>
                  </IonCol>
                  <IonCol />
                </IonRow>
                <div style={{ flex: 1, overflow: 'auto' }}>
                  {selectedAsset?.notes?.length === 0 ? (
                    <p style={{ textAlign: 'center' }}>No Notes available</p>
                  ) : (
                    selectedAsset.notes.map((note, index) => (
                      editing ? (
                        <IonRow
                          className='ion-justify-content-between terrain-register-row ion-align-items-center'
                          style={{ backgroundColor: getColor(index) }}
                          key={note.id}
                        >
                          <IonCol size='1' style={{ fontSize: '13px', color: '#737475' }}>{moment(note.updated_at).format('DD/MM/YY')}</IonCol>
                          <IonCol size='1.5' style={{ fontSize: '13px', color: '#737475' }}>{getNoteUser(note.user_id).label}</IonCol>
                          <IonCol size='2' style={{ fontSize: '13px', color: '#737475' }}>{note.subject}</IonCol>
                          <IonCol size='7' style={{ fontSize: '13px', color: '#737475' }}>{note.content}</IonCol>
                          <IonCol size='0.5'>
                            <BlueButton onClick={() => setEditing(false)}>Edit</BlueButton>
                          </IonCol>
                        </IonRow>
                      ) : (
                        <IonRow
                          className='ion-justify-content-between terrain-register-row ion-align-items-center'
                          style={{ backgroundColor: getColor(index) }}
                          key={note.id}
                        >
                          <IonCol size='1' style={{ fontSize: '13px', color: '#737475' }}>{moment(note.updated_at).format('DD/MM/YY')}</IonCol>
                          <IonCol size='1.5' style={{ fontSize: '13px', color: '#737475' }}>{getNoteUser(note.user_id).label}</IonCol>
                          <IonCol size='2' style={{ fontSize: '13px', color: '#737475' }}>{note.subject}</IonCol>
                          <IonCol size='7' style={{ fontSize: '13px', color: '#737475' }}>{note.content}</IonCol>
                          <IonCol size='0.5'>
                            <BlueButton onClick={() => { setView('View Note'); setSelectedNote(note); setSubject(note.subject); setContent(note.content) }}>View</BlueButton>
                          </IonCol>
                        </IonRow>
                      )
                    ))
                  )}
                </div>
              </div>
              <IonRow className='ion-justify-content-end'>
                <IonButton onClick={() => setView('Add Note')} style={{ '--background': '#0C9500', marginTop: '1.4em' }}>Add Note</IonButton>
              </IonRow>
            </>
          </OverlayContainer>
        </>
      )
    case 'View Note':
      return (
        <>
          <ObscureBackground style={{ zIndex: 20 }} />
          <OverlayContainer style={{ zIndex: 25, width: '90%', height: '90%', borderRadius: '1em' }} className='terrain-add-popup'>
            <IonRow style={{ paddingTop: '10px', margin: '0', padding: '0' }}>
              <IonCol style={{ margin: '0', padding: '0' }}>
                <TabOption
                  style={{
                    marginLeft: '2px', marginTop: '10px', marginBottom: '0px', paddingBottom: '0px', color: '#28464B', fontWeight: 'bold', fontSize: '16',
                  }}
                  onClick={() => {setView('Home'); setEditing(false) }}
                >Overview
                </TabOption>
                <TabOption
                  style={{
                    marginLeft: '2px', marginTop: '10px', marginBottom: '0px', paddingBottom: '0px', color: '#8E151F', fontWeight: 'bold', fontSize: '16',
                  }}
                  onClick={() => {setView('Notes'); setEditing(false) }}
                >Notes
                </TabOption>
                <TabOption
                  style={{
                    marginLeft: '2px', marginTop: '10px', marginBottom: '0px', paddingBottom: '0px', color: '#28464B', fontWeight: 'bold', fontSize: '16',
                  }}
                  onClick={() => {setView('Threat'); setEditing(false) }}
                >Alert State
                </TabOption>
                <TabOption
                  style={{
                    marginLeft: '2px', marginTop: '10px', marginBottom: '0px', paddingBottom: '0px', color: '#28464B', fontWeight: 'bold', fontSize: '16',
                  }}
                  onClick={() => {setView('Flashpoints'); setEditing(false) }}
                >Flashpoints
                </TabOption>
                <TabOption
                  style={{
                    marginLeft: '2px', marginTop: '10px', marginBottom: '0px', paddingBottom: '0px', color: '#28464B', fontWeight: 'bold', fontSize: '16',
                  }}
                  onClick={() => {setView('Control Measures'); setEditing(false) }}
                >Control Measures
                </TabOption>
                <TabOption
                  style={{
                    marginLeft: '2px', marginTop: '10px', marginBottom: '0px', paddingBottom: '0px', color: '#28464B', fontWeight: 'bold', fontSize: '16',
                  }}
                  onClick={() => {setView('Risk Register'); setEditing(false) }}
                >Risk Register
                </TabOption>
              </IonCol>
            </IonRow>
            <IonRow className='ion-justify-content-end'>
              <SimpleButton onClick={() => setShowSelectedAsset(false)}>Close X</SimpleButton>
            </IonRow>
            <>
              <div style={{ height: '79%', overflow: 'auto' }}>
                <IonRow style={{ marginLeft: '2em' }}>
                  <IonCol>
                    <h5 style={{ color: '#4197A9', fontSize: 13, marginBottom: '4px' }}>Date and Submitted By</h5>
                    <p style={{ fontSize: 13, color: '#737475' }}>
                      {new Date(selectedNote.created_at).toLocaleDateString('en-GB')} by {getNoteUser(selectedNote.user_id).label}
                    </p>
                    <h5 style={{ color: '#4197A9', fontSize: 13, marginBottom: '4px' }}>Subject</h5>
                    {editing ? (
                      <input
                        type='text'
                        value={subject}
                        onChange={(e) => setSubject(e.target.value)}
                        style={{ width: '100%', fontSize: 13, color: '#737475', padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
                      />
                    ) : (
                      <p style={{ fontSize: 13, color: '#737475' }}>{selectedNote.subject}</p>
                    )}
                  </IonCol>
                </IonRow>
                <IonRow style={{ marginLeft: '2em', height: '59%' }}>
                  <IonCol size='12'>
                    <h5 style={{ color: '#4197A9', fontSize: 13, marginBottom: '4px' }}>Content</h5>
                    {editing ? (
                      <textarea
                        value={content}
                        onChange={(e) => setContent(e.target.value)}
                        style={{ width: '100%', height: '100%', fontSize: 13, color: '#737475', padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
                      />
                    ) : (
                      <div style={{ width: '100%', height: '100%', fontSize: 13, color: '#737475', padding: '8px', borderRadius: '4px', border: '1px solid #ccc', overflowY: 'auto', backgroundColor: '#f9f9f9' }}>
                        {selectedNote.content}
                      </div>
                    )}
                  </IonCol>
                </IonRow>
              </div>
              { editing ? (
                <IonRow className='ion-justify-content-end'>
                  <IonButton onClick={() => setEditing(false)} style={{ '--background': '#8E151F' }}>Cancel</IonButton>
                  <IonButton onClick={handleEditNote} style={{ '--background': '#326771' }}>Save</IonButton>
                </IonRow>
              ) : (
                <IonRow className='ion-justify-content-end'>
                  <IonButton onClick={() => setView('Notes')} style={{ '--background': '#8E151F' }}>Back</IonButton>
                  <IonButton onClick={() => setEditing(true)} style={{ '--background': '#326771' }}>Edit</IonButton>
                </IonRow>
              )}
            </>
          </OverlayContainer>
        </>
      )
    case 'Add Note':
      return (
        <>
          <ObscureBackground style={{ zIndex: 20 }} />
          <OverlayContainer style={{ zIndex: 25, width: '90%', height: '90%', borderRadius: '1em' }} className='terrain-add-popup'>
            <IonRow style={{ paddingTop: '10px', margin: '0', padding: '0' }}>
              <IonCol style={{ margin: '0', padding: '0' }}>
              <TabOption
                  style={{
                    marginLeft: '2px', marginTop: '10px', marginBottom: '0px', paddingBottom: '0px', color: '#28464B', fontWeight: 'bold', fontSize: '16',
                  }}
                  onClick={() => setView('Home')}
                >Overview
                </TabOption>
                <TabOption
                  style={{
                    marginLeft: '2px', marginTop: '10px', marginBottom: '0px', paddingBottom: '0px', color: '#8E151F', fontWeight: 'bold', fontSize: '16',
                  }}
                  onClick={() => setView('Notes')}
                >Notes
                </TabOption>
                <TabOption
                  style={{
                    marginLeft: '2px', marginTop: '10px', marginBottom: '0px', paddingBottom: '0px', color: '#28464B', fontWeight: 'bold', fontSize: '16',
                  }}
                  onClick={() => setView('Threat')}
                >Alert State
                </TabOption>
                <TabOption
                  style={{
                    marginLeft: '2px', marginTop: '10px', marginBottom: '0px', paddingBottom: '0px', color: '#28464B', fontWeight: 'bold', fontSize: '16',
                  }}
                  onClick={() => setView('Flashpoints')}
                >Flashpoints
                </TabOption>
                <TabOption
                  style={{
                    marginLeft: '2px', marginTop: '10px', marginBottom: '0px', paddingBottom: '0px', color: '#28464B', fontWeight: 'bold', fontSize: '16',
                  }}
                  onClick={() => setView('Control Measures')}
                >Control Measures
                </TabOption>
                <TabOption
                  style={{
                    marginLeft: '2px', marginTop: '10px', marginBottom: '0px', paddingBottom: '0px', color: '#28464B', fontWeight: 'bold', fontSize: '16',
                  }}
                  onClick={() => setView('Risk Register')}
                >Risk Register
                </TabOption>
              </IonCol>
            </IonRow>
            <IonRow className='ion-justify-content-end'>
              <SimpleButton onClick={() => setShowSelectedAsset(false)}>Close X</SimpleButton>
            </IonRow>
            <>
              <div style={{ height: '79%', overflow: 'auto' }}>
                <IonRow className='ion-justify-content-between ion-align-items-center'>
                  <h5 style={{ marginLeft: '2em', fontSize: 16, color: '#326771' }}>{ `${selectedAsset.name} - Add Note` }</h5>
                </IonRow>
                <IonRow style={{ marginLeft: '2em', height: '20%' }}>
                  <IonCol size='12'>
                    <h5 style={{ color: '#4197A9', fontSize: 13, marginBottom: '4px' }}>Subject</h5>
                    <input
                      type='text'
                      value={subject}
                      onChange={handleSubjectChange}
                      style={{ width: '100%', fontSize: 13, color: '#737475', padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
                      placeholder='Enter Subject'
                    />
                  </IonCol>
                </IonRow>
                <IonRow style={{ marginLeft: '2em', marginTop: '2em', height: '59%' }}>
                  <IonCol size='12'>
                    <h5 style={{ color: '#4197A9', fontSize: 13, marginBottom: '4px' }}>Content</h5>
                    <textarea
                      value={content}
                      onChange={handleContentChange}
                      style={{ width: '100%', height: '59%', fontSize: 13, color: '#737475', padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
                      placeholder='Enter Content'
                    />
                  </IonCol>
                </IonRow>
              </div>
              <IonRow className='ion-justify-content-end'>
                <IonButton onClick={() => setView('Notes')} style={{ '--background': '#8E151F' }}>Back</IonButton>
                <IonButton onClick={handleAddNote} style={{ '--background': '#326771' }}>Submit</IonButton>
              </IonRow>
            </>
          </OverlayContainer>
        </>
      )
    case 'Control Measures':
      return (
        <>
          <ObscureBackground style={{ zIndex: 20 }} />
          <OverlayContainer style={{ zIndex: 25, width: '90%', height: '90%', borderRadius: '1em' }} className='terrain-add-popup'>
            <IonRow style={{ paddingTop: '10px', margin: '0', padding: '0' }}>
              <IonCol style={{ margin: '0', padding: '0' }}>
                <TabOption
                  style={{
                    marginLeft: '2px', marginTop: '10px', marginBottom: '0px', paddingBottom: '0px', color: '#28464B', fontWeight: 'bold', fontSize: '16',
                  }}
                  onClick={() => {
                    setView('Home')
                  }}
                >Overview
                </TabOption>
                <TabOption
                  style={{
                    marginLeft: '2px', marginTop: '10px', marginBottom: '0px', paddingBottom: '0px', color: '#28464B', fontWeight: 'bold', fontSize: '16',
                  }}
                  onClick={() => {
                    setView('Notes')
                  }}
                >Notes
                </TabOption>
                <TabOption
                  style={{
                    marginLeft: '2px', marginTop: '10px', marginBottom: '0px', paddingBottom: '0px', color: '#28464B', fontWeight: 'bold', fontSize: '16',
                  }}
                  onClick={() => {
                    setView('Threat')
                  }}
                >Alert State
                </TabOption>
                <TabOption
                  style={{
                    marginLeft: '2px', marginTop: '10px', marginBottom: '0px', paddingBottom: '0px', color: '#28464B', fontWeight: 'bold', fontSize: '16',
                  }}
                  onClick={() => {
                    setView('Flashpoints')
                  }}
                >Flashpoints
                </TabOption>
                <TabOption
                  style={{
                    marginLeft: '2px', marginTop: '10px', marginBottom: '0px', paddingBottom: '0px', color: '#8E151F', fontWeight: 'bold', fontSize: '16',
                  }}
                  onClick={() => {
                    setView('Control Measures')
                  }}
                >Control Measures
                </TabOption>
                <TabOption
                  style={{
                    marginLeft: '2px', marginTop: '10px', marginBottom: '0px', paddingBottom: '0px', color: '#28464B', fontWeight: 'bold', fontSize: '16',
                  }}
                  onClick={() => {
                    setView('Risk Register')
                  }}
                >Risk Register
                </TabOption>
              </IonCol>
            </IonRow>
            <IonRow className='ion-justify-content-end'>
              <SimpleButton onClick={() => setShowSelectedAsset(false)}>Close X</SimpleButton>
            </IonRow>
            <>
              <div style={{ height: '79%', overflow: 'auto' }}>
                {rows.map((row, rowIndex) => (
                  <IonRow key={rowIndex} style={{ marginLeft: '2em', marginTop: rowIndex === 0 ? '0' : '2em', height: '40%' }}>
                    {row.map((category) => (
                      <IonCol key={category}>
                        <h5 style={{ color: '#4197A9', fontSize: 13, marginBottom: '4px' }}>{category}</h5>
                        {groupedMeasures[category].map((measure) => (
                          <div key={measure.id} style={{ marginBottom: '10px' }}>
                            <p style={{ margin: 0, fontSize: 13, color: '#737475' }}>
                              {measure.control_measure}
                            </p>
                          </div>
                        ))}
                      </IonCol>
                    ))}
                    {row.length < 3 && [...Array(3 - row.length)].map((_, index) => (
                      <IonCol key={`empty-${index}`} />
                    ))}
                  </IonRow>
                ))}
              </div>
              <IonRow className='ion-justify-content-end'>
                <IonButton onClick={() => { setView('Add Measures') }} style={{ '--background': '#326771' }}>Add Measure</IonButton>
              </IonRow>
            </>
          </OverlayContainer>
        </>
      )
    case 'Add Measures':
      return (
        <>
          <ObscureBackground style={{ zIndex: 20 }} />
          <OverlayContainer style={{ zIndex: 25, width: '90%', height: '90%', borderRadius: '1em' }} className='terrain-add-popup'>
            <IonRow style={{ paddingTop: '10px', margin: '0', padding: '0' }}>
              <IonCol style={{ margin: '0', padding: '0' }}>
                <TabOption
                  style={{
                    marginLeft: '2px', marginTop: '10px', marginBottom: '0px', paddingBottom: '0px', color: '#28464B', fontWeight: 'bold', fontSize: '16',
                  }}
                  onClick={() => setView('Home')}
                >Overview
                </TabOption>
                <TabOption
                  style={{
                    marginLeft: '2px', marginTop: '10px', marginBottom: '0px', paddingBottom: '0px', color: '#28464B', fontWeight: 'bold', fontSize: '16',
                  }}
                  onClick={() => setView('Notes')}
                >Notes
                </TabOption>
                <TabOption
                  style={{
                    marginLeft: '2px', marginTop: '10px', marginBottom: '0px', paddingBottom: '0px', color: '#28464B', fontWeight: 'bold', fontSize: '16',
                  }}
                  onClick={() => setView('Threat')}
                >Alert State
                </TabOption>
                <TabOption
                  style={{
                    marginLeft: '2px', marginTop: '10px', marginBottom: '0px', paddingBottom: '0px', color: '#28464B', fontWeight: 'bold', fontSize: '16',
                  }}
                  onClick={() => setView('Flashpoints')}
                >Flashpoints
                </TabOption>
                <TabOption
                  style={{
                    marginLeft: '2px', marginTop: '10px', marginBottom: '0px', paddingBottom: '0px', color: '#8E151F', fontWeight: 'bold', fontSize: '16',
                  }}
                  onClick={() => setView('Control Measures')}
                >Control Measures
                </TabOption>
                <TabOption
                  style={{
                    marginLeft: '2px', marginTop: '10px', marginBottom: '0px', paddingBottom: '0px', color: '#28464B', fontWeight: 'bold', fontSize: '16',
                  }}
                  onClick={() => setView('Risk Register')}
                >Risk Register
                </TabOption>
              </IonCol>
            </IonRow>
            <IonRow className='ion-justify-content-end'>
              <SimpleButton onClick={() => setShowSelectedAsset(false)}>Close X</SimpleButton>
            </IonRow>
            <CenterForm style={{ zIndex: '20', width: '90%', height: '105%' }}>
              <IonContent className='risk-assessment-list' style={{ position: 'relative' }}>
                <IonList className='risk-assessment-list' style={{ padding: '20px' }}>
                  <div>
                    <SettingField>
                      <h5 className='blue'>Add Control Measures</h5>
                      <p>Control Measures are measures that are currently in place for this Key Asset. Use the drop-down to select a category,
                        and then <span style={{ color: '#326771' }}>drag and drop</span> items from the left table to the right.
                      </p>
                    </SettingField>
                    <div style={{ width: '200px' }}>
                      <Select
                        placeholder='Select Category'
                        name='existingCategory'
                        id='existing-control-measure-categories'
                        className='select-container'
                        value={input?.existingCategory}
                        // eslint-disable-next-line no-undef
                        menuPortalTarget={document.body}
                        options={categories.map((level) => ({ value: level, label: level }))}
                        onChange={(selected) => setInput({ ...input, existingCategory: selected, edit: true })}
                      />
                    </div>
                    <IonRow className='ion-align-items-center'>
                      <IonCol size={5}>
                        <ColumnContainer onDragOver={(e) => e.preventDefault()} onDrop={handleDropRemove}>
                          {input?.existingCategory
                            && rawMeasures.filter(({ category }) => category === input?.existingCategory.value)
                              .filter((val) => !input?.existingMeasures.find((measure) => measure.id === val.id)).map((measure, index) => (
                                <MeasureContainer
                                  className='single-control-measure'
                                  key={index}
                                  draggable
                                  style={{ backgroundColor: getColor(index) }}
                                  onDragStart={(e) => e.dataTransfer.setData('measure', JSON.stringify(measure))}
                                >
                                  <p> {measure.control_measure} </p>
                                </MeasureContainer>
                              ))}
                          {!input?.existingCategory && (
                            <IonRow style={{ height: '100%' }} className='ion-align-items-center'>
                              <SettingField style={{ textAlign: 'center', width: 'auto' }}>
                                <h4 style={{ fontWeight: 'normal', margin: '20px 0' }}>Choose a category to select measures</h4>
                                <p>To start adding control measures, choose a category from the drop-down menu above. </p>
                              </SettingField>
                            </IonRow>
                          )}
                        </ColumnContainer>
                      </IonCol>
                      <IonCol style={{ textAlign: 'center', fontSize: '2.6rem' }} size={2}>
                        <Icon color='#326771' icon='ic:round-swipe-right' />
                      </IonCol>
                      <IonCol size={5}>
                        <ColumnContainer id='cm-existing-drop' onDragOver={(e) => e.preventDefault()} onDrop={handleDropAdd}>
                          {input?.existingCategory && input?.existingMeasures.filter((selected) => selected.category === input?.existingCategory.value).map((measure, index) => (
                            <MeasureContainer
                              className='selected-control-measure'
                              key={index}
                              draggable
                              style={{ backgroundColor: getColor(index) }}
                              onDragStart={(e) => e.dataTransfer.setData('measure', JSON.stringify(measure))}
                            >
                              <p> {measure.control_measure} </p>
                            </MeasureContainer>
                          ))}
                          {(!input?.existingCategory || input?.existingMeasures.filter((selected) => selected.category === input?.existingCategory.value).length === 0) && (
                            <IonRow style={{ height: '100%' }} className='ion-align-items-center'>
                              <SettingField style={{ textAlign: 'center', width: 'auto' }}>
                                <h4 style={{ fontWeight: 'normal', margin: '20px 0' }}>Drag and drop items from the left to add them to your Key Asset’s profile</h4>
                                <p>Control measures that you add here will appear in the Key Assets profile as existing measures.</p>
                              </SettingField>
                            </IonRow>
                          )}
                        </ColumnContainer>
                      </IonCol>
                    </IonRow>
                  </div>
                  <IonRow className='ion-justify-content-end'>
                    <IonButton style={{ '--background': '#4197A9' }} onClick={() => setView('Control Measures')}>Cancel</IonButton>
                    <IonButton style={{ '--background': '#326771' }} onClick={handleAddMeasures}>Submit</IonButton>
                  </IonRow>
                </IonList>
              </IonContent>
            </CenterForm>
          </OverlayContainer>
        </>
      )
    case 'Risk Register':
      return (
        <>
          <ObscureBackground style={{ zIndex: 20 }} />
          <OverlayContainer style={{ zIndex: 25, width: '90%', height: '90%', borderRadius: '1em' }} className='terrain-add-popup'>
            <IonRow style={{ paddingTop: '10px', margin: '0', padding: '0' }}>
              <IonCol style={{ margin: '0', padding: '0' }}>
                <TabOption
                  style={{
                    marginLeft: '2px', marginTop: '10px', marginBottom: '0px', paddingBottom: '0px', color: '#28464B', fontWeight: 'bold', fontSize: '16',
                  }}
                  onClick={() => setView('Home')}
                >Overview
                </TabOption>
                <TabOption
                  style={{
                    marginLeft: '2px', marginTop: '10px', marginBottom: '0px', paddingBottom: '0px', color: '#28464B', fontWeight: 'bold', fontSize: '16',
                  }}
                  onClick={() => setView('Notes')}
                >Notes
                </TabOption>
                <TabOption
                  style={{
                    marginLeft: '2px', marginTop: '10px', marginBottom: '0px', paddingBottom: '0px', color: '#28464B', fontWeight: 'bold', fontSize: '16',
                  }}
                  onClick={() => setView('Threat')}
                >Alert State
                </TabOption>
                <TabOption
                  style={{
                    marginLeft: '2px', marginTop: '10px', marginBottom: '0px', paddingBottom: '0px', color: '#28464B', fontWeight: 'bold', fontSize: '16',
                  }}
                  onClick={() => setView('Flashpoints')}
                >Flashpoints
                </TabOption>
                <TabOption
                  style={{
                    marginLeft: '2px', marginTop: '10px', marginBottom: '0px', paddingBottom: '0px', color: '#28464B', fontWeight: 'bold', fontSize: '16',
                  }}
                  onClick={() => setView('Control Measures')}
                >Control Measures
                </TabOption>
                <TabOption
                  style={{
                    marginLeft: '2px', marginTop: '10px', marginBottom: '0px', paddingBottom: '0px', color: '#8E151F', fontWeight: 'bold', fontSize: '16',
                  }}
                  onClick={() => setView('Risk Register')}
                >Risk Register
                </TabOption>
              </IonCol>
            </IonRow>
            <IonRow className='ion-justify-content-end'>
              <SimpleButton onClick={() => { setShowSelectedAsset(false); setEditing(false) } }>Close X</SimpleButton>
            </IonRow>
            <div style={{ height: '75%', overflow: 'auto', boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)' }}>
              <IonRow style={{ padding: '10px' }} className='terrain-list-title  ion-justify-content-between ion-align-items-center'>
                <IonCol size='1'>
                  <h5 style={{ fontSize: 16, color: '#326771' }}>Risk ID</h5>
                </IonCol>
                <IonCol size='2'>
                  <h5 style={{ fontSize: 16, color: '#326771' }}>Risk</h5>
                </IonCol>
                <IonCol size='2'>
                  <h5 style={{ fontSize: 16, color: '#326771' }}>Risk Assessor</h5>
                </IonCol>
                <IonCol size='1.5'>
                  <h5 style={{ fontSize: 16, color: '#326771' }}>Inherent Risk</h5>
                </IonCol>
                <IonCol size='1.5'>
                  <h5 style={{ fontSize: 16, color: '#326771' }}>Residual Risk</h5>
                </IonCol>
                <IonCol size='2'>
                  <h5 style={{ fontSize: 16, color: '#326771' }}>Date Modified</h5>
                </IonCol>
                <IonCol size='2' />
              </IonRow>
              <div style={{ flex: 1, overflow: 'auto' }}>
                {fetchedRisks?.map((val, index) => (
                  <IonRow
                    className='ion-justify-content-between terrain-register-row ion-align-items-center'
                    style={{ backgroundColor: getColor(index) }}
                    key={val.id}
                  >
                    <IonCol size='1' style={{ fontSize: '13px', color: '#737475' }}>{val.visibleId}</IonCol>
                    <IonCol size='2' style={{ fontSize: '13px', color: '#737475' }}>{val.riskEvent}</IonCol>
                    <IonCol size='2' style={{ fontSize: '13px', color: '#737475' }}>{val?.owner?.email}</IonCol>
                    <IonCol id={`inherent-risk-${index + 1}`} className='ion-text-center' style={{ color: colorCodeRisk(val.riskRating) }} size='1.5'>{ val.riskRating }</IonCol>
                    <IonCol id={`residual-risk-${index + 1}`} className='ion-text-center' style={{ color: colorCodeRisk(val.residualRisk) }} size='1.5'>{ val.residualRisk } </IonCol>
                    <IonCol size='2' style={{ fontSize: '13px', color: '#737475' }}>{val.updated}</IonCol>
                    <IonCol size='2'>
                      <BlueButton onClick={() => handleReview(val)}>Review</BlueButton> / <BlueButton onClick={() => handleSelectRisk(val)}>View</BlueButton>
                    </IonCol>
                  </IonRow>
                ))}
                {fetchedRisks?.length === 0 && (
                  <p style={{ textAlign: 'center' }}>No Risks available</p>
                )}
              </div>
            </div>
            <IonRow className='ion-justify-content-end'>
              <IonButton onClick={() => setQuestion(1)} style={{ '--background': '#0C9500', marginTop: '1.4em' }}>Add Risk</IonButton>
            </IonRow>
          </OverlayContainer>
        </>
      )
    case 'View Risk':
      return (
        <>
          <ObscureBackground style={{ zIndex: 20 }} />
          <OverlayContainer style={{ zIndex: 25, width: '90%', height: '90%', borderRadius: '1em' }} className='terrain-add-popup'>
            <IonRow style={{ paddingTop: '10px', margin: '0', padding: '0' }}>
              <IonCol style={{ margin: '0', padding: '0' }}>
                <TabOption
                  style={{
                    marginLeft: '2px', marginTop: '10px', marginBottom: '0px', paddingBottom: '0px', color: '#28464B', fontWeight: 'bold', fontSize: '16',
                  }}
                  onClick={() => setView('Home')}
                >Overview
                </TabOption>
                <TabOption
                  style={{
                    marginLeft: '2px', marginTop: '10px', marginBottom: '0px', paddingBottom: '0px', color: '#28464B', fontWeight: 'bold', fontSize: '16',
                  }}
                  onClick={() => setView('Notes')}
                >Notes
                </TabOption>
                <TabOption
                  style={{
                    marginLeft: '2px', marginTop: '10px', marginBottom: '0px', paddingBottom: '0px', color: '#28464B', fontWeight: 'bold', fontSize: '16',
                  }}
                  onClick={() => setView('Threat')}
                >Alert State
                </TabOption>
                <TabOption
                  style={{
                    marginLeft: '2px', marginTop: '10px', marginBottom: '0px', paddingBottom: '0px', color: '#28464B', fontWeight: 'bold', fontSize: '16',
                  }}
                  onClick={() => setView('Flashpoints')}
                >Flashpoints
                </TabOption>
                <TabOption
                  style={{
                    marginLeft: '2px', marginTop: '10px', marginBottom: '0px', paddingBottom: '0px', color: '#28464B', fontWeight: 'bold', fontSize: '16',
                  }}
                  onClick={() => setView('Control Measures')}
                >Control Measures
                </TabOption>
                <TabOption
                  style={{
                    marginLeft: '2px', marginTop: '10px', marginBottom: '0px', paddingBottom: '0px', color: '#8E151F', fontWeight: 'bold', fontSize: '16',
                  }}
                  onClick={() => setView('Risk Register')}
                >Risk Register
                </TabOption>
              </IonCol>
            </IonRow>
            <IonRow className='ion-justify-content-end'>
              <SimpleButton onClick={() => { setShowSelectedAsset(false); setEditing(false) } }>Close X</SimpleButton>
            </IonRow>
            <IonRow className='ion-justify-content-between ion-align-items-center'>
              <h5 style={{ marginLeft: '2em', fontSize: 16, color: '#326771' }}>{`${selectedRisk.visibleId} - ${selectedRisk.riskEvent}`}</h5>
            </IonRow>
            <div style={{ height: '70%', overflow: 'auto' }}>
              <IonRow style={{ marginLeft: '2em' }}>
                <IonCol>
                  <h5 style={{ color: 'black', fontSize: 16, marginBottom: '4px' }}>Inherent Risk Assessment - Summary</h5>
                </IonCol>
                <IonCol>
                  <h5 style={{ color: 'black', fontSize: 16, marginBottom: '4px' }}>Residual Risk Assessment - Summary</h5>
                </IonCol>
              </IonRow>
              <IonRow style={{ marginLeft: '2.5em' }}>
                <IonCol>
                  <h5 style={{ color: '#326771', fontSize: 16, marginBottom: '4px' }}>Threat Rating</h5>
                  <p style={{ margin: 0, fontSize: 13, color: '#737475' }}>{ selectedRisk.threatRating }</p>
                </IonCol>
                <IonCol>
                  <h5 style={{ color: '#326771', fontSize: 16, marginBottom: '4px' }}>Threat Rating</h5>
                  <p style={{ margin: 0, fontSize: 13, color: '#737475' }}>{ selectedRisk.threatRating }</p>
                </IonCol>
              </IonRow>
              <IonRow style={{ marginLeft: '2.5em' }}>
                <IonCol>
                  <h5 style={{ color: '#326771', fontSize: 16, marginBottom: '4px' }}>Likelihood Rating</h5>
                  <p style={{ margin: 0, fontSize: 13, color: '#737475' }}>{ selectedRisk.inherentThreatLikelihood }</p>
                </IonCol>
                <IonCol>
                  <h5 style={{ color: '#326771', fontSize: 16, marginBottom: '4px' }}>Likelihood Rating</h5>
                  <p style={{ margin: 0, fontSize: 13, color: '#737475' }}>{ selectedRisk.residualThreatLikelihood }</p>
                </IonCol>
              </IonRow>
              <IonRow style={{ marginLeft: '2.5em' }}>
                <IonCol>
                  <h5 style={{ color: '#326771', fontSize: 16, marginBottom: '4px' }}>Impact Rating</h5>
                  <p style={{ margin: 0, fontSize: 13, color: '#737475' }}>{ selectedRisk.impact }</p>
                </IonCol>
                <IonCol>
                  <h5 style={{ color: '#326771', fontSize: 16, marginBottom: '4px' }}>Impact Rating</h5>
                  <p style={{ margin: 0, fontSize: 13, color: '#737475' }}>{ selectedRisk.residualImpact }</p>
                </IonCol>
              </IonRow>
              <IonRow style={{ marginLeft: '2.5em' }}>
                <IonCol>
                  <h5 style={{ color: '#326771', fontSize: 16, marginBottom: '4px' }}>Risk Rating</h5>
                  <p style={{ margin: 0, fontSize: 13, color: '#737475' }}>{ selectedRisk.riskRating }</p>
                </IonCol>
                <IonCol>
                  <h5 style={{ color: '#326771', fontSize: 16, marginBottom: '4px' }}>Risk Rating</h5>
                  <p style={{ margin: 0, fontSize: 13, color: '#737475' }}>{ selectedRisk.residualRisk }</p>
                </IonCol>
              </IonRow>
              <IonRow style={{ marginLeft: '2em', marginTop: '2em' }}>
                <IonCol>
                  <h5 style={{ color: 'black', fontSize: 16, marginBottom: '4px' }}>Existing Control Measures</h5>
                </IonCol>
              </IonRow>
              <div style={{ overflow: 'auto' }}>
              {
                existingRows && existingGroupedMeasures ? (
                  existingRows.map((row, rowIndex) => (
                    <IonRow key={rowIndex} style={{ marginLeft: '2em', marginTop: rowIndex === 0 ? '0' : '2em', height: '40%' }}>
                      {row.map((category) => (
                        <IonCol key={category}>
                          <h5 style={{ color: '#4197A9', fontSize: 13, marginBottom: '4px' }}>{category}</h5>
                          {existingGroupedMeasures[category] && existingGroupedMeasures[category].map((measure) => (
                            <div key={measure.id} style={{ marginBottom: '10px' }}>
                              <p style={{ margin: 0, fontSize: 13, color: '#737475' }}>
                                {measure.control_measure}
                              </p>
                            </div>
                          ))}
                        </IonCol>
                      ))}
                      {row.length < 3 && [...Array(3 - row.length)].map((_, index) => (
                        <IonCol key={`empty-${index}`} />
                      ))}
                    </IonRow>
                  ))
                ) : (
                  <div>No data available</div>  // Display a fallback if no data is available.
                )
              }

              </div>
              <IonRow style={{ marginLeft: '2em', marginTop: '2em' }}>
                <IonCol>
                  <h5 style={{ color: 'black', fontSize: 16, marginBottom: '4px' }}>New Control Measures</h5>
                </IonCol>
              </IonRow>
              <div style={{ overflow: 'auto' }}>
                {newRows?.map((row, rowIndex) => (
                  <IonRow key={rowIndex} style={{ marginLeft: '2em', marginTop: rowIndex === 0 ? '0' : '2em', height: '40%' }}>
                    {row?.map((category) => (
                      <IonCol key={category}>
                        <h5 style={{ color: '#4197A9', fontSize: 13, marginBottom: '4px' }}>{category}</h5>
                        {newGroupedMeasures[category]?.map((measure) => (
                          <div key={measure.id} style={{ marginBottom: '10px' }}>
                            <p style={{ margin: 0, fontSize: 13, color: '#737475' }}>
                              {measure.control_measure}
                            </p>
                          </div>
                        ))}
                      </IonCol>
                    ))}
                    {row.length < 3 && [...Array(3 - row.length)].map((_, index) => (
                      <IonCol key={`empty-${index}`} />
                    ))}
                  </IonRow>
                ))}
              </div>
            </div>
            <IonRow className='ion-justify-content-end'>
              <IonButton onClick={() => setView('Risk Register')} style={{ '--background': '#8E151F' }}>Back</IonButton>
              <IonButton disabled onClick={() => setView('Edit Risk')} style={{ '--background': '#326771' }}>Edit</IonButton>
            </IonRow>
          </OverlayContainer>
        </>
      )
    case 'Flashpoints':
      return (
        <>
          <ObscureBackground style={{ zIndex: 20 }} />
          <OverlayContainer style={{ zIndex: 25, width: '90%', height: '90%', borderRadius: '1em' }} className='terrain-add-popup'>
            <IonRow style={{ paddingTop: '10px', margin: '0', padding: '0' }}>
              <IonCol style={{ margin: '0', padding: '0' }}>
                <TabOption
                  style={{
                    marginLeft: '2px', marginTop: '10px', marginBottom: '0px', paddingBottom: '0px', color: '#28464B', fontWeight: 'bold', fontSize: '16',
                  }}
                  onClick={() => setView('Home')}
                >Overview
                </TabOption>
                <TabOption
                  style={{
                    marginLeft: '2px', marginTop: '10px', marginBottom: '0px', paddingBottom: '0px', color: '#28464B', fontWeight: 'bold', fontSize: '16',
                  }}
                  onClick={() => setView('Notes')}
                >Notes
                </TabOption>
                <TabOption
                  style={{
                    marginLeft: '2px', marginTop: '10px', marginBottom: '0px', paddingBottom: '0px', color: '#28464B', fontWeight: 'bold', fontSize: '16',
                  }}
                  onClick={() => setView('Threat')}
                >Alert State
                </TabOption>
                <TabOption
                  style={{
                    marginLeft: '2px', marginTop: '10px', marginBottom: '0px', paddingBottom: '0px', color: '#8E151F', fontWeight: 'bold', fontSize: '16',
                  }}
                  onClick={() => setView('Flashpoints')}
                >Flashpoints
                </TabOption>
                <TabOption
                  style={{
                    marginLeft: '2px', marginTop: '10px', marginBottom: '0px', paddingBottom: '0px', color: '#28464B', fontWeight: 'bold', fontSize: '16',
                  }}
                  onClick={() => setView('Control Measures')}
                >Control Measures
                </TabOption>
                <TabOption
                  style={{
                    marginLeft: '2px', marginTop: '10px', marginBottom: '0px', paddingBottom: '0px', color: '#28464B', fontWeight: 'bold', fontSize: '16',
                  }}
                  onClick={() => setView('Risk Register')}
                >Risk Register
                </TabOption>
              </IonCol>
            </IonRow>
            <IonRow className='ion-justify-content-end'>
              <SimpleButton onClick={() => { setShowSelectedAsset(false); setEditing(false) } }>Close X</SimpleButton>
            </IonRow>
            <div style={{ height: '75%', overflow: 'auto', boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)' }}>
              <IonRow style={{ padding: '10px' }} className='terrain-list-title  ion-justify-content-between ion-align-items-center'>
                <IonCol size='2'>
                  <h5 style={{ fontSize: 16, color: '#326771' }}>Flashpoint</h5>
                </IonCol>
                <IonCol size='2'>
                  <h5 style={{ fontSize: 16, color: '#326771' }}>Status</h5>
                </IonCol>
                <IonCol size='2'>
                  <h5 style={{ fontSize: 16, color: '#326771' }}>Manifestation</h5>
                </IonCol>
                <IonCol size='2'>
                  <h5 style={{ fontSize: 16, color: '#326771' }}>Communities</h5>
                </IonCol>
                <IonCol size='3'>
                  <h5 style={{ fontSize: 16, color: '#326771' }}>Date Modified</h5>
                </IonCol>
                <IonCol size='1' />
              </IonRow>
              <div style={{ flex: 1, overflow: 'auto' }}>
                {selectedAsset.flashpoints.map((val, index) => (
                  <IonRow
                    className='ion-justify-content-between terrain-register-row ion-align-items-center'
                    style={{ backgroundColor: getColor(index) }}
                    key={val.id}
                  >
                    <IonCol size='2' style={{ fontSize: '13px', color: '#737475' }}>{val.title}</IonCol>
                    <IonCol size='2' style={{ fontSize: '13px', color: '#737475' }}>{capitalizeFirstLetter(val.status)}</IonCol>
                    <IonCol size='2' style={{ fontSize: '13px', color: '#737475' }}>{val.primary_manifestation}</IonCol>
                    <IonCol size='2' style={{ fontSize: '13px', color: '#737475' }}>{val.areas.map((area) => area.name).join('; ')}</IonCol>
                    <IonCol size='3' style={{ fontSize: '13px', color: '#737475' }}>{moment(val.updated_at).format('DD/MM/YYYY')}</IonCol>
                    <IonCol size='1'>
                      <BlueButton onClick={() => {setSelectedFlashpoint(val); setView('View Flashpoint')}}>View</BlueButton>
                    </IonCol>
                  </IonRow>
                ))}
                {selectedAsset.flashpoints.length === 0 && (
                  <p style={{ textAlign: 'center' }}>No Flashpoints available</p>
                )}
              </div>
            </div>
            <IonRow className='ion-justify-content-end'>
              <IonButton onClick={() => setView('Add Flashpoint')} style={{ '--background': '#0C9500', marginTop: '1.4em' }}>Add Flashpoint</IonButton>
            </IonRow>
          </OverlayContainer>
        </>
      )
    case 'View Flashpoint':
      return (
        <>
          <ObscureBackground style={{ zIndex: 20 }} />
          <OverlayContainer style={{ zIndex: 25, width: '90%', height: '90%', borderRadius: '1em' }} className='terrain-add-popup'>
            <IonRow style={{ paddingTop: '10px', margin: '0', padding: '0' }}>
              <IonCol style={{ margin: '0', padding: '0' }}>
                <TabOption
                  style={{
                    marginLeft: '2px', marginTop: '10px', marginBottom: '0px', paddingBottom: '0px', color: '#28464B', fontWeight: 'bold', fontSize: '16',
                  }}
                  onClick={() => {
                    setView('Home')
                  }}
                >Overview
                </TabOption>
                <TabOption
                  style={{
                    marginLeft: '2px', marginTop: '10px', marginBottom: '0px', paddingBottom: '0px', color: '#28464B', fontWeight: 'bold', fontSize: '16',
                  }}
                  onClick={() => {
                    setView('Notes')
                  }}
                >Notes
                </TabOption>
                <TabOption
                  style={{
                    marginLeft: '2px', marginTop: '10px', marginBottom: '0px', paddingBottom: '0px', color: '#28464B', fontWeight: 'bold', fontSize: '16',
                  }}
                  onClick={() => {
                    setView('Threat')
                  }}
                >Alert State
                </TabOption>
                <TabOption
                  style={{
                    marginLeft: '2px', marginTop: '10px', marginBottom: '0px', paddingBottom: '0px', color: '#8E151F', fontWeight: 'bold', fontSize: '16',
                  }}
                  onClick={() => {
                    setView('Flashpoints')
                  }}
                >Flashpoints
                </TabOption>
                <TabOption
                  style={{
                    marginLeft: '2px', marginTop: '10px', marginBottom: '0px', paddingBottom: '0px', color: '#28464B', fontWeight: 'bold', fontSize: '16',
                  }}
                  onClick={() => {
                    setView('Control Measures')
                  }}
                >Control Measures
                </TabOption>
                <TabOption
                  style={{
                    marginLeft: '2px', marginTop: '10px', marginBottom: '0px', paddingBottom: '0px', color: '#28464B', fontWeight: 'bold', fontSize: '16',
                  }}
                  onClick={() => {
                    setView('Risk Register')
                  }}
                >Risk Register
                </TabOption>
              </IonCol>
            </IonRow>
            <IonRow className='ion-justify-content-end'>
              <SimpleButton onClick={() => { setShowSelectedAsset(false); setEditing(false) }}>Close X</SimpleButton>
            </IonRow>
            {editing ? (
              <>
                <IonRow className='ion-justify-content-between ion-align-items-center'>
                  <h5 style={{ marginLeft: '2em', fontSize: 16, color: '#326771' }}>{ selectedFlashpoint.title }</h5>
                </IonRow>
                <div style={{ height: '70%', overflow: 'auto' }}>
                  <IonRow style={{ marginLeft: '2em' }}>
                    <IonCol>
                      <h5 style={{ color: '#326771', fontSize: 16, marginBottom: '4px' }}>Description</h5>
                      <textarea
                        style={{ height: '5em' }}
                        value={flashpointInput.description}
                        onChange={(e) => setFlashpointInput({ ...flashpointInput, description: e.target.value })}
                      />
                    </IonCol>
                    <IonCol>
                      <h5 style={{ color: '#326771', fontSize: 16, marginBottom: '4px' }}>Triggers</h5>
                      <textarea
                        style={{ height: '5em' }}
                        value={flashpointInput.triggers}
                        onChange={(e) => setFlashpointInput({ ...flashpointInput, triggers: e.target.value })}
                      />
                    </IonCol>
                  </IonRow>
                  <IonRow style={{ marginLeft: '2em', marginTop: '2em' }}>
                    <IonCol>
                      <h5 style={{ color: '#326771', fontSize: 16, marginBottom: '4px' }}>Status</h5>
                      <select
                        value={flashpointInput.status}
                        onChange={(e) => setFlashpointInput({ ...flashpointInput, status: e.target.value as FlashpointStatus })}
                        style={{ padding: '5px 10px' }}
                      >
                        <option value='' disabled>Select Status</option>
                        <option value='low'>Low</option>
                        <option value='guarded'>Guarded</option>
                        <option value='elevated'>Elevated</option>
                        <option value='high'>High</option>
                        <option value='severe'>Severe</option>
                      </select>
                      <p style={{ margin: 0, fontSize: 13, color: '#737475' }}>{getStatusDefinition(flashpointInput?.status)}</p>
                    </IonCol>
                    <IonCol>
                      <h5 style={{ color: '#326771', fontSize: 16, marginBottom: '4px' }}>Is this ongoing/seasonal?</h5>
                      <IonRow>
                        <label style={{ textAlign: 'center', marginRight: '10px' }}>
                          <input
                            type='radio'
                            value='yes'
                            checked={input.ongoing === 'Yes'}
                            onChange={() => setInput({ ...input, ongoing: 'Yes' })}
                          />
                          Yes
                        </label>
                        <label style={{ textAlign: 'center' }}>
                          <input
                            type='radio'
                            value='No'
                            checked={input.ongoing === 'No'}
                            onChange={() => setInput({ ...input, ongoing: 'No' })}
                          />
                          No
                        </label>
                      </IonRow>
                    </IonCol>
                  </IonRow>
                  <IonRow style={{ marginLeft: '2em', marginTop: '2em' }}>
                    <IonCol>
                      <h5 style={{ color: '#326771', fontSize: 16, marginBottom: '4px' }}>Primary Manifestation</h5>
                      <select
                        value={flashpointInput.primaryManifestation}
                        onChange={(e) => setFlashpointInput({ ...flashpointInput, primaryManifestation: e.target.value as FlashpointStatus })}
                        style={{ padding: '5px 10px' }}
                      >
                        <option value='' disabled>Select manifestation</option>
                        {
                          manifestations?.map((val) => (
                            <option key={val} value={val}>{ val }</option>
                          ))
                        }
                      </select>
                    </IonCol>
                    <IonCol>
                      {
                        flashpointInput?.additionalManifestations?.map((val, index) => (
                          <div key={index} className='terrain-form-field'>
                            <h6 style={{ color: '#326771', fontSize: 16, marginBottom: '4px' }}>Additional Manifestation (optional)</h6>
                            <select
                              value={val}
                              onChange={(e) => updateAdditionalManifest(e.target.value, index)}
                              style={{ padding: '5px 10px' }}
                            >
                              <option value='' disabled>Select manifestation</option>
                              {
                                manifestations?.map((manifestation) => (
                                  <option key={manifestation} value={manifestation}>{ manifestation }</option>
                                ))
                              }
                            </select>
                          </div>
                        ))
                      }
                    </IonCol>
                  </IonRow>
                  <IonRow style={{ marginLeft: '2em', marginTop: '2em' }}>
                    <IonCol>
                      <h5 style={{ color: '#326771', fontSize: 16, marginBottom: '4px' }}>Proximate Issues</h5>
                      <>
                        {
                          issues.map((val, index) => (
                            <TagButton
                              key={val.id}
                              onClick={() => selectCause(index)}
                              style={{ backgroundColor: (val.selected) ? '#326771' : 'white', color: (val.selected) ? 'white' : '#326771' }}
                            >
                              { val.name }
                            </TagButton>
                          ))
                        }
                      </>
                    </IonCol>
                  </IonRow>
                  <IonRow style={{ marginLeft: '2em', marginTop: '2em' }}>
                    <IonCol>
                      <h5 style={{ color: '#326771', fontSize: 16, marginBottom: '4px' }}>Primary Associated Stakeholders</h5>
                      <CreatableSelect
                        isMulti
                        placeholder='Select Stakeholders'
                        name='colors'
                        className='select-container'
                        id='journey-passengers'
                      // eslint-disable-next-line no-undef
                        menuPortalTarget={document.body}
                        options={stakeholders.map(({ id, name }) => ({ value: id, label: name }))}
                        value={flashpointInput.primaryStakeholders}
                        onChange={(selected) => setFlashpointInput({ ...flashpointInput, primaryStakeholders: selected })}
                      />
                    </IonCol>
                    <IonCol>
                      <h5 style={{ color: '#326771', fontSize: 16, marginBottom: '4px' }}>Secondary Associated Stakeholders</h5>
                      <CreatableSelect
                        isMulti
                        placeholder='Select Stakeholders'
                        name='colors'
                        className='select-container'
                        id='journey-passengers'
                      // eslint-disable-next-line no-undef
                        menuPortalTarget={document.body}
                        options={stakeholders.map(({ id, name }) => ({ value: id, label: name }))}
                        value={flashpointInput.secondaryStakeholders}
                        onChange={(selected) => setFlashpointInput({ ...flashpointInput, secondaryStakeholders: selected })}
                      />
                    </IonCol>
                    <IonCol>
                      <h5 style={{ color: '#326771', fontSize: 16, marginBottom: '4px' }}>Tertiary Associated Stakeholders</h5>
                      <CreatableSelect
                        isMulti
                        placeholder='Select Stakeholders'
                        name='colors'
                        className='select-container'
                        id='journey-passengers'
                      // eslint-disable-next-line no-undef
                        menuPortalTarget={document.body}
                        options={stakeholders.map(({ id, name }) => ({ value: id, label: name }))}
                        value={flashpointInput.tertiaryStakeholders}
                        onChange={(selected) => setFlashpointInput({ ...flashpointInput, tertiaryStakeholders: selected })}
                      />
                    </IonCol>
                  </IonRow>
                  <IonRow style={{ marginLeft: '2em', marginTop: '2em' }}>
                    <IonCol>
                      <h5 style={{ color: '#326771', fontSize: 16, marginBottom: '4px' }}>Relevant Areas</h5>
                      <CreatableSelect
                        isMulti
                        placeholder='Select Areas'
                        name='colors'
                        className='select-container'
                        id='journey-passengers'
                      // eslint-disable-next-line no-undef
                        menuPortalTarget={document.body}
                        options={communities.map(({ id, name }) => ({ label: name, value: id }))}
                        value={flashpointInput.relevantAreas}
                        onChange={(selected) => setFlashpointInput({ ...flashpointInput, relevantAreas: selected })}
                      />
                    </IonCol>
                    <IonCol />
                    <IonCol />
                  </IonRow>
                  <IonRow style={{ marginLeft: '2em', marginTop: '2em' }}>
                    <IonCol>
                      <h5 style={{ color: '#326771', fontSize: 16, marginBottom: '4px' }}>Additional Comments</h5>
                      <textarea
                        style={{ width: '100%', height: '59%', fontSize: 13, color: '#737475', padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
                        value={flashpointInput.comments}
                        onChange={(e) => setFlashpointInput({ ...flashpointInput, comments: e.target.value })}
                        placeholder='Enter comments'
                      />
                    </IonCol>
                  </IonRow>
                </div>
                <IonRow className='ion-justify-content-end'>
                  <IonButton onClick={handleEditFlashpoint} style={{ '--background': '#326771' }}>Save</IonButton>
                  <IonButton onClick={() => setEditing(false)} style={{ '--background': '#326771' }}>Cancel</IonButton>
                </IonRow>
              </>
            ) : (
              <>
                <IonRow className='ion-justify-content-between ion-align-items-center'>
                  <h5 style={{ marginLeft: '2em', fontSize: 16, color: '#326771' }}>{ selectedFlashpoint.title }</h5>
                </IonRow>
                <div style={{ height: '70%', overflow: 'auto' }}>
                  <IonRow style={{ marginLeft: '2em' }}>
                    <IonCol>
                      <h5 style={{ color: '#326771', fontSize: 16, marginBottom: '4px' }}>Description</h5>
                      <p style={{ margin: 0, fontSize: 13, color: '#737475' }}>{ selectedFlashpoint.description }</p>
                    </IonCol>
                    <IonCol>
                      <h5 style={{ color: '#326771', fontSize: 16, marginBottom: '4px' }}>Triggers</h5>
                      <p style={{ margin: 0, fontSize: 13, color: '#737475' }}>{ selectedFlashpoint.triggers }</p>
                    </IonCol>
                  </IonRow>
                  <IonRow style={{ marginLeft: '2em', marginTop: '2em' }}>
                    <IonCol>
                      <h5 style={{ color: '#326771', fontSize: 16, marginBottom: '4px' }}>Status</h5>
                      <p style={{ margin: 0, fontSize: 13 }}>
                        <span style={{ ...getStatusStyle(selectedFlashpoint.status), padding: '4px 8px', borderRadius: '6px' }}>
                          {getStatusLabel(selectedFlashpoint?.status)}
                        </span>
                      </p>
                      <p style={{ margin: 0, fontSize: 13, color: '#737475' }}>{getStatusDefinition(selectedFlashpoint?.status)}</p>
                    </IonCol>
                    <IonCol>
                      <h5 style={{ color: '#326771', fontSize: 16, marginBottom: '4px' }}>Is this ongoing/seasonal?</h5>
                      <p style={{ margin: 0, fontSize: 13, color: '#737475' }}>{ (selectedFlashpoint.ongoing) ? 'Yes' : 'No' }</p>
                    </IonCol>
                  </IonRow>
                  <IonRow style={{ marginLeft: '2em', marginTop: '2em' }}>
                    <IonCol>
                      <h5 style={{ color: '#326771', fontSize: 16, marginBottom: '4px' }}>Primary Manifestation</h5>
                      <p style={{ margin: 0, fontSize: 13, color: '#737475' }}>{ selectedFlashpoint.primary_manifestation }</p>
                    </IonCol>
                    <IonCol>
                      <h5 style={{ color: '#326771', fontSize: 16, marginBottom: '4px' }}>Additional Manifestations</h5>
                      <>
                        {
                          selectedFlashpoint?.additional_manifestations?.length === 0 ? (
                            <p style={{ margin: 0, fontSize: 13, color: '#737475' }}>No additional manifestations</p>
                          ) : (
                            <ul>
                              {
                                selectedFlashpoint?.additional_manifestations?.map((val) => (
                                  <li key={val.id}><p style={{ margin: 0, fontSize: 13, color: '#737475' }}>{ val.name }</p></li>
                                ))
                              }
                            </ul>
                          )
                        }
                      </>
                    </IonCol>
                  </IonRow>
                  <IonRow style={{ marginLeft: '2em', marginTop: '2em' }}>
                    <IonCol>
                      <h5 style={{ color: '#326771', fontSize: 16, marginBottom: '4px' }}>Proximate Issues</h5>
                      <>
                        {
                          selectedFlashpoint.issues.map((val) => (
                            <IssueTag key={val.id}>{ val.name }</IssueTag>
                          ))
                        }
                      </>
                    </IonCol>
                  </IonRow>
                  <IonRow style={{ marginLeft: '2em', marginTop: '2em' }}>
                    <IonCol>
                      <h5 style={{ color: '#326771', fontSize: 16, marginBottom: '4px' }}>Primary Associated Stakeholders</h5>
                      {selectedFlashpoint.flashpoint_groups
                        .filter((item) => item.group_type === 'primary') // Inline filtering
                        .map((stakeholder) => (
                          <div key={stakeholder.id}>
                            <p style={{ margin: 0, fontSize: 13, color: '#737475' }}>
                              {stakeholder.stakeholder.name}
                            </p>
                          </div>
                        ))
                      }
                      {selectedFlashpoint.flashpoint_groups.filter((item) => item.group_type === 'primary').length === 0 && (
                        <p style={{ margin: 0, fontSize: 13, color: '#737475' }}>No primary stakeholders available</p>
                      )}
                    </IonCol>
                    <IonCol>
                      <h5 style={{ color: '#326771', fontSize: 16, marginBottom: '4px' }}>Secondary Associated Stakeholders</h5>
                      {selectedFlashpoint.flashpoint_groups
                        .filter((item) => item.group_type === 'secondary') // Inline filtering
                        .map((stakeholder) => (
                          <div key={stakeholder.id}>
                            <p style={{ margin: 0, fontSize: 13, color: '#737475' }}>
                              {stakeholder.stakeholder.name}
                            </p>
                          </div>
                        ))
                      }
                      {selectedFlashpoint.flashpoint_groups.filter((item) => item.group_type === 'secondary').length === 0 && (
                        <p style={{ margin: 0, fontSize: 13, color: '#737475' }}>No secondary stakeholders available</p>
                      )}
                    </IonCol>
                    <IonCol>
                      <h5 style={{ color: '#326771', fontSize: 16, marginBottom: '4px' }}>Tertiary Associated Stakeholders</h5>
                      {selectedFlashpoint.flashpoint_groups
                        .filter((item) => item.group_type === 'tertiary') // Inline filtering
                        .map((stakeholder) => (
                          <div key={stakeholder.id}>
                            <p style={{ margin: 0, fontSize: 13, color: '#737475' }}>
                              {stakeholder.stakeholder.name}
                            </p>
                          </div>
                        ))
                      }
                      {selectedFlashpoint.flashpoint_groups.filter((item) => item.group_type === 'tertiary').length === 0 && (
                        <p style={{ margin: 0, fontSize: 13, color: '#737475' }}>No tertiary stakeholders available</p>
                      )}
                    </IonCol>
                  </IonRow>
                  <IonRow style={{ marginLeft: '2em', marginTop: '2em' }}>
                    <IonCol>
                      <h5 style={{ color: '#326771', fontSize: 16, marginBottom: '4px' }}>Relevant Areas</h5>
                      {selectedFlashpoint.areas
                        .map((area) => (
                          <div key={area.id}>
                            <p style={{ margin: 0, fontSize: 13, color: '#737475' }}>
                              {area.name}
                            </p>
                          </div>
                        ))
                      }
                      {selectedFlashpoint.areas.length === 0 && (
                        <p style={{ margin: 0, fontSize: 13, color: '#737475' }}>No areas available</p>
                      )}
                    </IonCol>
                  </IonRow>
                  <IonRow style={{ marginLeft: '2em', marginTop: '2em' }}>
                    <IonCol>
                      <h5 style={{ color: '#326771', fontSize: 16, marginBottom: '4px' }}>Additional Comments</h5>
                      <p style={{ margin: 0, fontSize: 13, color: '#737475' }}>{ selectedFlashpoint.comments }</p>
                    </IonCol>
                  </IonRow>
                </div>
                <IonRow className='ion-justify-content-end'>
                  <IonButton onClick={() => setView('Flashpoints')} style={{ '--background': '#8E151F' }}>Back</IonButton>
                  <IonButton onClick={() => setEditing(true)} style={{ '--background': '#326771' }}>Edit</IonButton>
                </IonRow>
              </>
            )}
          </OverlayContainer>
        </>
      )
    case 'Add Flashpoint':
      return (
        <>
          <ObscureBackground style={{ zIndex: 20 }} />
          <OverlayContainer style={{ zIndex: 25, width: '90%', height: '90%', borderRadius: '1em' }} className='terrain-add-popup'>
            <IonRow style={{ paddingTop: '10px', margin: '0', padding: '0' }}>
              <IonCol style={{ margin: '0', padding: '0' }}>
                <TabOption
                  style={{
                    marginLeft: '2px', marginTop: '10px', marginBottom: '0px', paddingBottom: '0px', color: '#28464B', fontWeight: 'bold', fontSize: '16',
                  }}
                  onClick={() => {
                    setView('Home')
                  }}
                >Overview
                </TabOption>
                <TabOption
                  style={{
                    marginLeft: '2px', marginTop: '10px', marginBottom: '0px', paddingBottom: '0px', color: '#28464B', fontWeight: 'bold', fontSize: '16',
                  }}
                  onClick={() => {
                    setView('Notes')
                  }}
                >Notes
                </TabOption>
                <TabOption
                  style={{
                    marginLeft: '2px', marginTop: '10px', marginBottom: '0px', paddingBottom: '0px', color: '#28464B', fontWeight: 'bold', fontSize: '16',
                  }}
                  onClick={() => {
                    setView('Threat')
                  }}
                >Alert State
                </TabOption>
                <TabOption
                  style={{
                    marginLeft: '2px', marginTop: '10px', marginBottom: '0px', paddingBottom: '0px', color: '#8E151F', fontWeight: 'bold', fontSize: '16',
                  }}
                  onClick={() => {
                    setView('Flashpoints')
                  }}
                >Flashpoints
                </TabOption>
                <TabOption
                  style={{
                    marginLeft: '2px', marginTop: '10px', marginBottom: '0px', paddingBottom: '0px', color: '#28464B', fontWeight: 'bold', fontSize: '16',
                  }}
                  onClick={() => {
                    setView('Control Measures')
                  }}
                >Control Measures
                </TabOption>
                <TabOption
                  style={{
                    marginLeft: '2px', marginTop: '10px', marginBottom: '0px', paddingBottom: '0px', color: '#28464B', fontWeight: 'bold', fontSize: '16',
                  }}
                  onClick={() => {
                    setView('Risk Register')
                  }}
                >Risk Register
                </TabOption>
              </IonCol>
            </IonRow>
            <IonRow className='ion-justify-content-end'>
              <SimpleButton onClick={() => { setShowSelectedAsset(false); setEditing(false) }}>Close X</SimpleButton>
            </IonRow>
            <IonRow className='ion-justify-content-between ion-align-items-center'>
              <h5 style={{ marginLeft: '2em', fontSize: 16, color: '#326771' }}>Add Flashpoint</h5>
            </IonRow>
            <div style={{ height: '70%', overflow: 'auto' }}>
              <IonRow style={{ marginLeft: '2em' }}>
                <IonCol>
                  <h5 style={{ color: '#326771', fontSize: 16, marginBottom: '4px' }}>Title</h5>
                  <input placeholder='Give this flashpoint a title' type='text' value={flashpointInput.title} onChange={(e) => setFlashpointInput({ ...flashpointInput, title: e.target.value })} />
                </IonCol>
              </IonRow>
              <IonRow style={{ marginLeft: '2em' }}>
                <IonCol>
                  <h5 style={{ color: '#326771', fontSize: 16, marginBottom: '4px' }}>Description</h5>
                  <textarea
                    style={{ height: '5em' }}
                    value={flashpointInput.description}
                    onChange={(e) => setFlashpointInput({ ...flashpointInput, description: e.target.value })}
                    placeholder='Enter Description'
                  />
                </IonCol>
                <IonCol>
                  <h5 style={{ color: '#326771', fontSize: 16, marginBottom: '4px' }}>Triggers</h5>
                  <textarea
                    style={{ height: '5em' }}
                    value={flashpointInput.triggers}
                    onChange={(e) => setFlashpointInput({ ...flashpointInput, triggers: e.target.value })}
                    placeholder='Enter what triggers the flashpoint'
                  />
                </IonCol>
              </IonRow>
              <IonRow style={{ marginLeft: '2em', marginTop: '2em' }}>
                <IonCol>
                  <h5 style={{ color: '#326771', fontSize: 16, marginBottom: '4px' }}>Status</h5>
                  <select
                    value={flashpointInput.status}
                    onChange={(e) => setFlashpointInput({ ...flashpointInput, status: e.target.value as FlashpointStatus })}
                    style={{ padding: '5px 10px' }}
                  >
                    <option value='' disabled>Select Status</option>
                    <option value='low'>Low</option>
                    <option value='guarded'>Guarded</option>
                    <option value='elevated'>Elevated</option>
                    <option value='high'>High</option>
                    <option value='severe'>Severe</option>
                  </select>
                </IonCol>
                <IonCol>
                  <h5 style={{ color: '#326771', fontSize: 16, marginBottom: '4px' }}>Is this ongoing/seasonal?</h5>
                  <IonRow>
                    <label style={{ textAlign: 'center', marginRight: '10px' }}>
                      <input
                        type='radio'
                        value='yes'
                        checked={input.ongoing === 'Yes'}
                        onChange={() => setInput({ ...input, ongoing: 'Yes' })}
                      />
                      Yes
                    </label>
                    <label style={{ textAlign: 'center' }}>
                      <input
                        type='radio'
                        value='No'
                        checked={input.ongoing === 'No'}
                        onChange={() => setInput({ ...input, ongoing: 'No' })}
                      />
                      No
                    </label>
                  </IonRow>
                </IonCol>
              </IonRow>
              <IonRow style={{ marginLeft: '2em', marginTop: '2em' }}>
                <IonCol>
                  <h5 style={{ color: '#326771', fontSize: 16, marginBottom: '4px' }}>Primary Manifestation</h5>
                  <select
                    value={flashpointInput.primaryManifestation}
                    onChange={(e) => setFlashpointInput({ ...flashpointInput, primaryManifestation: e.target.value as FlashpointStatus })}
                    style={{ padding: '5px 10px' }}
                  >
                    <option value='' disabled>Select manifestation</option>
                    {
                      manifestations?.map((val) => (
                        <option key={val} value={val}>{ val }</option>
                      ))
                    }
                  </select>
                </IonCol>
                <IonCol>
                  {
                    flashpointInput.additionalManifestations.map((val, index) => (
                      <div key={index} className='terrain-form-field'>
                        <h6>Additional Manifestation (optional)</h6>
                        <select
                          value={val}
                          onChange={(e) => updateAdditionalManifest(e.target.value, index)}
                          style={{ padding: '5px 10px' }}
                        >
                          <option value='' disabled>Select manifestation</option>
                          {
                            manifestations?.map((manifestation) => (
                              <option key={manifestation} value={manifestation}>{ manifestation }</option>
                            ))
                          }
                        </select>
                      </div>
                    ))
                  }
                  <SimpleButton style={{ fontSize: '0.8rem' }} onClick={addManifestation}>Add Additional Manifestation +</SimpleButton>
                </IonCol>
              </IonRow>
              <IonRow style={{ marginLeft: '2em', marginTop: '2em' }}>
                <IonCol>
                  <h5 style={{ color: '#326771', fontSize: 16, marginBottom: '4px' }}>Proximate Issues</h5>
                  <>
                    {
                      issues.map((val, index) => (
                        <TagButton
                          key={val.id}
                          onClick={() => selectCause(index)}
                          style={{ backgroundColor: (val.selected) ? '#326771' : 'white', color: (val.selected) ? 'white' : '#326771' }}
                        >
                          { val.name }
                        </TagButton>
                      ))
                    }
                  </>
                </IonCol>
              </IonRow>
              <IonRow style={{ marginLeft: '2em', marginTop: '2em' }}>
                <IonCol>
                  <h5 style={{ color: '#326771', fontSize: 16, marginBottom: '4px' }}>Primary Associated Stakeholders</h5>
                  <CreatableSelect
                    isMulti
                    placeholder='Select Stakeholders'
                    name='colors'
                    className='select-container'
                    id='journey-passengers'
                  // eslint-disable-next-line no-undef
                    menuPortalTarget={document.body}
                    options={stakeholders.map(({ id, name }) => ({ value: id, label: name }))}
                    value={flashpointInput.primaryStakeholders}
                    onChange={(selected) => setFlashpointInput({ ...flashpointInput, primaryStakeholders: selected })}
                  />
                </IonCol>
                <IonCol>
                  <h5 style={{ color: '#326771', fontSize: 16, marginBottom: '4px' }}>Secondary Associated Stakeholders</h5>
                  <CreatableSelect
                    isMulti
                    placeholder='Select Stakeholders'
                    name='colors'
                    className='select-container'
                    id='journey-passengers'
                  // eslint-disable-next-line no-undef
                    menuPortalTarget={document.body}
                    options={stakeholders.map(({ id, name }) => ({ value: id, label: name }))}
                    value={flashpointInput.secondaryStakeholders}
                    onChange={(selected) => setFlashpointInput({ ...flashpointInput, secondaryStakeholders: selected })}
                  />
                </IonCol>
                <IonCol>
                  <h5 style={{ color: '#326771', fontSize: 16, marginBottom: '4px' }}>Tertiary Associated Stakeholders</h5>
                  <CreatableSelect
                    isMulti
                    placeholder='Select Stakeholders'
                    name='colors'
                    className='select-container'
                    id='journey-passengers'
                  // eslint-disable-next-line no-undef
                    menuPortalTarget={document.body}
                    options={stakeholders.map(({ id, name }) => ({ value: id, label: name }))}
                    value={flashpointInput.tertiaryStakeholders}
                    onChange={(selected) => setFlashpointInput({ ...flashpointInput, tertiaryStakeholders: selected })}
                  />
                </IonCol>
              </IonRow>
              <IonRow style={{ marginLeft: '2em', marginTop: '2em' }}>
                <IonCol>
                  <h5 style={{ color: '#326771', fontSize: 16, marginBottom: '4px' }}>Relevant Areas</h5>
                  <CreatableSelect
                    isMulti
                    placeholder='Select Areas'
                    name='colors'
                    className='select-container'
                    id='journey-passengers'
                  // eslint-disable-next-line no-undef
                    menuPortalTarget={document.body}
                    options={communities.map(({ id, name }) => ({ label: name, value: id }))}
                    value={flashpointInput.relevantAreas}
                    onChange={(selected) => setFlashpointInput({ ...flashpointInput, relevantAreas: selected })}
                  />
                </IonCol>
                <IonCol />
                <IonCol />
              </IonRow>
              <IonRow style={{ marginLeft: '2em', marginTop: '2em' }}>
                <IonCol>
                  <h5 style={{ color: '#326771', fontSize: 16, marginBottom: '4px' }}>Additional Comments</h5>
                  <textarea
                    style={{ width: '100%', height: '59%', fontSize: 13, color: '#737475', padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
                    value={flashpointInput.comments}
                    onChange={(e) => setFlashpointInput({ ...flashpointInput, comments: e.target.value })}
                    placeholder='Enter comments'
                  />
                </IonCol>
              </IonRow>
            </div>
            <IonRow className='ion-justify-content-end'>
              <IonButton onClick={handleAddFlashpoint} style={{ '--background': '#326771' }}>Save</IonButton>
              <IonButton onClick={() => setView('Flashpoints')} style={{ '--background': '#326771' }}>Cancel</IonButton>
            </IonRow>
          </OverlayContainer>
        </>
      )
  }
}

export default AssetProfileV2
